export default {
  about_page: {
    aim: "בוויזנט, אנו שואפים:",
    aim_1: "לפשט את תהליך בקשת הוויזה.",
    aim_2: "להבטיח את הרמות הגבוהות ביותר של אבטחה ותאימות.",
    aim_3: "לספק ערך יוצא דופן ושביעות רצון לקוחות.",
    choose: "למה <span class='text-primary'> לבחור בוי </span> זנט?",
    company_name: "חברת איוויסנט בע\"מ",
    connect: "התחבר איתנו",
    contact_us: "יש לך שאלות או זקוק לעזרה? צור איתנו קשר באמצעות:",
    customer_support_1: "סיוע 24/7 באמצעות צ'אט, דוא\"ל וטלפון.",
    customer_support_2: "תמיכה רב לשונית לקהל עולמי.",
    customer_support_title: "תמיכת לקוחות ללא תחרות",
    experience: "עם ניסיון של שנים בתהליכי תיירות ושגרירות, זיהינו את הצורך בדרך פשוטה ובטוחה יותר להגיש בקשה לויזה מהנוחות של הבית. Visanet נולדה כדי לגשר על פער זה, ומציעה שירותי eVisa ו-ETA חלקים למטיילים ברחבי העולם.",
    fast_and_secure_1: "הגש בקשה מהבית - אין צורך בביקורי שגרירות.",
    fast_and_secure_2: "אשרות שאושרו על ידי הממשלה נמסרות ישירות לדוא\"ל שלך.",
    fast_and_secure_title: "שירות מהיר ומאובטח",
    follow_us: "עקבו אחרינו ב:",
    founded: "הקמנו את Visanet במטרה לספק פתרון מהיר, בטוח ובמחיר סביר לאתגרים הנפוצים של קבלת אשרות אלקטרוניות.",
    global_presence: "הנוכחות הגלובלית שלנו:",
    img_checkmark_shield: "סימן ביקורת ירוק בתוך סמל מגן",
    img_doc_with_checkmark: "מסמך עם סמל סימן ביקורת ירוק",
    img_fast_online_service: "רקטה מהירה יוצאת מאייקון מחשב נייד",
    img_gem: "סמל פנינה כחולה",
    img_globe: "אייקון גלובוס",
    img_magnifying_glass: "זכוכית מגדלת מעל סמל המסמך",
    img_man_at_table: "איש מתוסכל יושב ליד אייקון שולחן",
    img_rocking_chair_with_cat_and_laptop: "Rocking Chair with a Cat on a Table with a Laptop 3D Illustration",
    img_support_headphones: "נניח אוזניות עם סמל כתר ירוק",
    legal: "מידע משפטי",
    licensed: "Visanet הינה חברה בעלת רישיון מלא:",
    location: "מיקום",
    operate_body: "Visanet משרתת נוסעים במספר אזורים, ומציעה שירותי eVisa ו-ETA מותאמים אישית למדינות כמו הודו, ארה\"ב, וייטנאם, קנדה ועוד.",
    operate_title: "היכן אנו פו <span class='text-primary'> עלים </span>",
    our_mission: "<span class='text-primary'>המשימה שלנו </span>",
    our_story_1: "Visanet התחילה ברעיון פשוט: להפוך את בקשות הוויזה ללא מתח. התפתחנו לספק שירותים מוביל, המסייע למטיילים ברחבי העולם להשיג ויזות אלקטרוניות במהירות, בצורה מאובטחת ובמחיר סביר.",
    our_story_2: "אנו עובדים ישירות עם רשויות ההגירה כדי להבטיח ציות ולספק מסמכי נסיעה רשמיים שאושרו על ידי הממשלה. המחויבות שלנו לשקיפות ושביעות רצון הלקוחות הפכה אותנו לשם מהימן בענף.",
    our_story_title: "<span class='text-primary'>הסיפור שלנו </span>",
    registered: "רשום בבריטניה באישור ממשלתי לפעולות גלובליות.",
    successfully_processed: "מאז הקמתנו, עיבדנו בהצלחה <span class='text-primary'> מאות אלפי ויזות</span>, והעצמתנו למטיילים שירות אמין <span class='text-primary'> ונטול מתח. </span>",
    title: "אודות Visanet: השותף המהימן שלך לנסיעות ללא טרחה",
    trust_1: "ניסיון של {yearsActive} שנים בענף הוויזה.",
    trust_2: "מאות אלפי יישומים מוצלחים ברחבי העולם.",
    trust_title: "מומחיות שאפשר לסמוך עליה"
  },
  about_us: "אודותינו",
  academic: "אקדמי",
  accompanying_children: {
    add: "הוסף ילד מלווה",
    country_of_birth: "ארץ לידתו של הילד",
    dob: "תאריך הלידה של הילד",
    index: "ילד # {n}",
    label: "מידע ליווי ילדים",
    name: "שמו המלא של הילד"
  },
  according_to_passport: "על פי דרכון",
  aerial_only: "הויזה תקפה לכניסה <strong> אווירית (טיסה) בלבד</strong>.",
  agree_terms: "אני מסכים לתנ <a href=\"/terms\" target=\"_blank\"> אי השימוש </a> של Visanet.",
  airport: "שדה תעופה",
  all_vaccinated: "כל האנשים באפליקציה חוסנו נגד COVID",
  and_connector: "and ",
  applicant: "המועמד",
  applicant_info: {
    family: "משפחה",
    occupation: "עיסוק",
    passport: "דרכון",
    pastTravels: "ביקורים קודמים",
    personal: "מידע אישי"
  },
  applicant_photos: {
    address_proof: "Address proof",
    address_proof_desc: "A document that proves your address (like a utility bill, bank statement, driver's license, etc.)",
    address_proof_upload_hint: "Upload a document that proves your address (utility bill, bank statement, driver's license, etc.)",
    bank: "דף חשבון בנק",
    bank_desc: "דף חשבון בנק אישי עם סכום מינימלי של 2000 דולר (או שווה ערך) משלושת החודשים האחרונים (כולל שם, תאריך ויתרת חשבון)",
    bank_upload_hint: "העלה/י דף חשבון בנק אישי עם סכום מינימלי של 2000 דולר (או שווה ערך) משלושת החודשים האחרונים",
    booking: "הזמנת מלון",
    booking_desc: "עותק של הזמנת המלון שלך, או עותק של הדפסת קורא תעודות הזהות של המארח/ת שלך",
    booking_upload_hint: "העלה/י עותק של הזמנת המלון שלך או עותק של הדפסת קורא תעודות הזהות של המארח/ת שלך",
    card: "כרטיס ביקור",
    card_desc: "כרטיס ביקור עם שמך, תפקידך, שם העסק, כתובת ופרטי התקשרות כתובים עליו.",
    card_upload_hint: "מסמך עם שמך, שם העסק, תפקידך, כתובת ואמצעי התקשרות",
    face: "תמונת פנים",
    face_desc: "תמונה ברורה ועדכנית של הפנים שלך, השתמש/י ברקע לבן או בהיר (בדומה לסלפי או תמונת דרכון).",
    face_upload_hint: "תמונה ברורה של הפנים שלך עם רקע בהיר (כמו סלפי)",
    invitation: "מכתב הזמנה",
    invitation_desc: "מכתב הזמנה עם שמך, תפקידך, סיבת הביקור, כתובת ופרטי התקשרות כתובים עליו.",
    invitation_upload_hint: "מכתב הזמנה עם שמך, תפקידך, סיבת הביקור, כתובת ופרטי התקשרות.",
    occupation: "Occupation proof",
    occupation_desc: "A document that proves your occupation, like business license, work contract, pension statement, student card, retirement certificate, etc.",
    occupation_upload_hint: "Upload an occupation document (business license, work contract, pension statement, student card, retirement certificate, etc.)",
    passport: "תמונת דרכון",
    passport_desc: "תמונה ברורה ועדכנית של עמוד הנתונים בדרכון שלך.",
    passport_upload_hint: "תמונה ברורה של עמוד הנתונים בדרכון שלך",
    return_ticket: "כרטיס חזור",
    return_ticket_desc: "עותק של הזמנת טיסת הכרטיס חזור שלך",
    return_ticket_upload_hint: "העלה/י עותק של הזמנת טיסת הכרטיס חזור שלך",
    travel_ticket: "Travel booking",
    travel_ticket_desc: "A copy of your travel reservation",
    travel_ticket_upload_hint: "Upload your travel reservation"
  },
  application_id: "מזהה יישום",
  application_received: "קיבלנו את בקשת הויזה האלקטרונית שלך",
  apply_coupon: "להגיש בקשה",
  assumed_passport_expiry: "הערכנו אוטומטית את תאריך התפוגה של הדרכון שלך",
  authority: "סמכות",
  autocompleted: "השלמה אוטומטית",
  back_to_form_bahrain: "טופס ויזה",
  back_to_form_cambodia: "טופס ויזה",
  back_to_form_canada: "טופס eTA",
  back_to_form_india: "טופס ויזה",
  back_to_form_indonesia: "טופס ויזה",
  back_to_form_israel: "טופס ETA-IL",
  back_to_form_korea: "טופס K-ETA",
  back_to_form_morocco: "טופס ויזה",
  back_to_form_new_zealand: "טופס NZeTA",
  back_to_form_saudi_arabia: "טופס ויזה",
  back_to_form_sri_lanka: "טופס ויזה",
  back_to_form_thailand: "Visa Form",
  back_to_form_togo: "Visa Form",
  back_to_form_uk: "טופס ETA",
  back_to_form_usa: "טופס ESTA",
  back_to_form_vietnam: "טופס ויזה",
  bahrain: "בחריין",
  bahrain_evisa: "ויזה אלקטרונית בחריין",
  bahrain_page: {
    faq: [
      {
        a: "ויזה אלקטרונית בחריין היא אישור נסיעה אלקטרוני המאפשר לאזרחים זרים, כולל אזרחים מארה\"ב, להיכנס לבחריין לתקופה מסוימת. זה מחליף את חותמת הוויזה או המדבקה הישנה בדרכון שלך שהיית צריך לקבל מהשגרירות. עכשיו, התהליך הרבה יותר פשוט - אתה יכול בקלות לקבל את הוויזה האלקטרונית שלך בחריין ממש <a href=\"/\"> כאן באתר האינטרנט שלנו. </a>",
        q: "מהי ויזה אלקטרונית בחריין?"
      },
      {
        a: "אזרחי מדינות זכאות יכולים להגיש בקשה לויזה אלקטרונית בחריין באופן מקוון. תוכל לבדוק את רשימת המדינות הזכאות <a data-eligibility-list-opener> כאן</a>.",
        q: "מי זכאי להגיש בקשה לויזה אלקטרונית בחריין?"
      },
      {
        a: "הגשת בקשה לויזה אלקטרונית בחריין היא פשוטה. פשוט מלא את טופס <a href=\"#form\"> הוויזה המקוון</a>, העלה את המסמכים הדרושים ושלם את דמי הויזה. פשוט ככה!",
        q: "כיצד אוכל להגיש בקשה לויזה אלקטרונית בחריין?"
      },
      {
        a: "הנה מה שתצטרך: עו <ul> <li> תק של הדרכון שלך (כולל דף המשפחה, אם רלוונטי, וכל דפי מידע נוספים). </li><li>עותק של כרטיס הטיסה חזרה שאושר. </li><li>עותק של הזמנת המלון שלך בבחריין. אם אתה שוהה עם קרוב משפחה או חבר, תצטרך לספק עותק של תדפיס קורא תעודת הזהות שלהם בבחריין. </li><li>עבור ויזה ל-5 שנים (לא זמינה לכל הלאומים), הצהרת בנק המציגה יתרה מינימלית של 1000$. </li></ul>",
        q: "אילו מסמכים נדרשים לבקשת ויזה אלקטרונית בחריין?"
      },
      {
        a: "זמני העיבוד עשויים להשתנות, אך רוב הוויזות האלקטרוניות בחריין מוכנות תוך 3 עד 5 ימי עסקים. אנו ממליצים להגיש בקשה הרבה לפני תאריך הנסיעה שלך כדי להימנע מכל לחץ ברגע האחרון.",
        q: "כמה זמן לוקח לעבד ויזה אלקטרונית בחריין?"
      },
      {
        a: "העלות תלויה בסוג הוויזה שאליה אתה מגיש בקשה - בין אם זו אשרת תייר, עסקים או מעבר. אתה יכול למצוא את העמלות המפורטות בטו <a href=\"#form\"> פס שלנו כאן</a>.",
        q: "כמה עולה ויזה אלקטרונית בחריין?"
      },
      {
        a: "אנו מציעים מספר סוגים של ויזות אלקטרוניות בחריין, כולל: ויזה <ul> <li> <strong> לשבועיים: שהייה של </strong> שבועיים, כניסה יחידה. </li><li><strong>ויזה לשלושה חודשים: </strong> שהייה של חודש אחד, כניסות מרובות. </li><li><strong>ויזה לשנה: שהי </strong> יה של 3 חודשים, כניסות מרובות. </li></ul>",
        q: "אילו סוגים של ויזות אלקטרוניות בחריין זמינות?"
      },
      {
        a: "במקרים מסוימים, כן! ייתכן שתוכל להאריך את הוויזה האלקטרונית שלך לבחריין, אך תצטרך להגיש בקשה להארכה לפני שתוקף הוויזה הנוכחית שלך יפוג. האישור הוא לפי שיקול דעתן של הרשויות. לפרטים נוספים, אל תהסס <a href=\"/contact\"> לפנות אלינו</a>.",
        q: "האם אוכל להאריך את הוויזה האלקטרונית שלי לבחריין?"
      },
      {
        a: "אם הבקשה שלך נדחתה, תקבל הודעה המסבירה מדוע. ייתכן שתוכל להגיש בקשה מחדש לאחר טיפול בבעיות. אם זה קורה, פנה אלינו - אנחנו כאן כדי לעזור לך להבין את הצעדים הבאים.",
        q: "מה עלי לעשות אם בקשת הוויזה האלקטרונית שלי לבחריין נדחית?"
      },
      {
        a: "זה תלוי בסוג הויזה האלקטרונית שאליה אתה מגיש בקשה. חלקם תקפים לכניסה יחידה, בעוד שאחרים מאפשרים כניסות מרובות. הקפד לבחור את האפשרות המתאימה לצרכי הנסיעה שלך.",
        q: "האם אוכל להשתמש בויזה אלקטרונית בחריין לכניסות מרובות?"
      },
      {
        a: "משך השהייה שלך משתנה בהתאם לסוג הויזה האלקטרונית שתקבל. משך הזמן הנפוץ כולל 14 יום, 30 יום או 90 יום, כך שתוכל לבחור מה מתאים ביותר לביקור שלך.",
        q: "כמה זמן אוכל להישאר בבחריין עם ויזה אלקטרונית?"
      },
      {
        a: "שהייה מופרזת בויזה האלקטרונית שלך בחריין עלולה להוביל לקנסות, גירוש או בעיות בבקשות ויזה עתידיות. חשוב לכבד את תוקף הויזה ולוודא שאתה עוזב לפני שתוקפו.",
        q: "מה קורה אם אשאר מעבר לויזה האלקטרונית שלי לבחריין?"
      },
      {
        a: "כן, מומלץ להדפיס עותק של אישור הוויזה האלקטרונית שלך לבחריין ולשאת אותו איתך בעת נסיעה. ייתכן שתצטרך להראות את זה לפקידי ההגירה כשתגיע.",
        q: "האם עלי להדפיס את הוויזה האלקטרונית שלי לבחריין לפני הנסיעה?"
      },
      {
        a: "כן, הדרכון שלך צריך להיות בתוקף לפחות שישה חודשים מיום הכניסה לבחריין כדי להיות זכאי לוויזה אלקטרונית.",
        q: "האם הדרכון שלי נדרש להיות בעל תוקף מסוים כדי להגיש בקשה לויזה אלקטרונית בחריין?"
      },
      {
        a: "לא, הוויזה האלקטרונית בחריין אינה מאפשרת לך לעבוד. אם אתה מתכנן לעבוד בבחריין, תצטרך להגיש בקשה לויזת עבודה דרך הערוצים המתאימים, כגון השגרירות.",
        q: "האם אוכל לעבוד בבחריין עם ויזה אלקטרונית?"
      },
      {
        a: "ביטוח בריאות אינו חובה לכניסה לבחריין עם ויזה אלקטרונית, אך תמיד כדאי לקבל כיסוי בזמן נסיעה.",
        q: "האם ביטוח בריאות נדרש כדי להיכנס לבחריין עם ויזה אלקטרונית?"
      }
    ],
    meta_desc: "הגש בקשה לויזה אלקטרונית לבחריין באנגלית. קבל ויזה מבלי לבקר בשגרירות, תהליך מהיר ונוח",
    title: "ויזה אלקטרונית לבחריין"
  },
  bill_payment: "תשלום על ידי חשבון",
  birth_city: "עיר/עיר לידה",
  birth_country: "ארץ לידה",
  birth_date: "תאריך לידה",
  blog: {
    author: "מחבר",
    blog: "בלוג",
    categories: "קטגוריות",
    description: "חקור את החדשות האחרונות, ייעוץ מומחה ומדריכים מקיפים כדי להקל על תכנון הנסיעות שלך. בין אם אתה מגיש בקשה לויזה, מחפש השראה ליעד או מתעדכן במדיניות ההגירה, אנחנו דואגים לך.",
    find_articles: "חפש מאמרים",
    header: "בלוג ויזנט <span class='text-primary'> </span>",
    hero_img: "אדם קורא עיתון ויושב על כיסא חוף",
    meta_desc: "חדשות, מדריכים, עדכונים ומידע חיוני על אשרות אלקטרוניות והיתרי כניסה למטיילים בחו\"ל.",
    overview_img: "איור עיתון",
    overview_title: "<span class='text-primary'>חדשות ויזה </span> וייעוץ נסיעות",
    published_on: "פורסם בתאריך:",
    read_more: "קרא עוד",
    recent: "מאמרים אחרונים",
    search: "חיפוש",
    subheader: "המדריך האולטימטיבי שלך לוויזות ותובנות נסיעות",
    table_of_contents: "תוכן עניינים",
    title: "בלוג Visanet - אשרות אלקטרוניות, חדשות ועדכונים",
    updated_on: "עודכן בתאריך:",
    written_by: "נכתב על ידי"
  },
  brand: {
    name: "ויזנט"
  },
  business_address: "כתובת עסק",
  business_details: "פרטים עסקיים",
  business_name: "שם העסק",
  business_name_hint: "שם העסק באנגלית",
  cambodia: "קמבודיה",
  cambodia_evisa: "ויזה אלקטרונית בקמבודיה",
  cambodia_page: {
    faq: [
      {
        a: "אין צורך לבקר בשגרירות. אתה יכול להציג ולהדפיס את הוויזה שלך בכל מקום בעולם. דלג על התור בשדה התעופה. בסך הכל, תהליך מהיר וקל משמעותית.",
        q: "מהם היתרונות של ויזה אלקטרונית לקמבודיה?"
      },
      {
        a: "בהחלט לא נדרש. ניתן להנפיק ויזה באתר האינטרנט שלנו גם אם טרם רכשת כרטיס טיסה.",
        q: "האם עלי לקנות כרטיס טיסה לפני שליחת הבקשה?"
      },
      {
        a: "להלן שדות התעופה ומעברי הגבול היחידים המכבדים ויזה אלקטרונית לקמבודיה: נמל התעופה הבינלאומי פנו </li> <li> ם <ul> <li> פן נמל התעופה הבינלאומי סיאם ריפ צ'אם ים (קו קונג) פוי פט (בנטיאי מיאנ </li> <li> צ' </li> <li> י) באובט (סוואי ריאנג) תחנת הגבול טרופאנג קריאל (סטונג טרנג) </li> <li> שדה התעופה הבינלאומי סיהנוקוויל </li> <li> </li> <li> </li>",
        q: "האם ניתן להיכנס לקמבודיה משדה התעופה או גבול כלשהו?"
      },
      {
        a: "למרבה הצער, זה לא אפשרי. כדי לבצע שינוי בפרטים, עליך להנפיק ויזה אלקטרונית חדשה. מסיבה זו, וודא בעת מילוי הטופס שכל המידע שאתה מקליד תואם לחלוטין את הפרטים המצוינים בדרכון שלך.",
        q: "האם ניתן לבקש שינוי כלשהו בויזה לאחר שליחתה?"
      },
      {
        a: "ישנן מדינות ספציפיות שאזרחיהן אינם זקוקים לויזה: אינדונזיה, לאוס, וייטנאם, הפיליפינים, תאילנד, סינגפור ומלזיה. אם אתה אזרח בכל מדינה שאינה זו המפורטת כאן, אתה בהחלט צריך ויזה כדי להיכנס לקמבודיה.",
        q: "איך אני יודע אם אני צריך ויזה לקמבודיה?"
      },
      {
        a: "לא. המחיר והתשלום באתרים שלנו כוללים את כל העמלות, התשלום עבור ממשלת קמבודיה, כל המסים ודמי הבולים - התשלום באתרים שלנו הוא מלא וסופי, ועל כך תקבל חותמת רשמית בדרכון שלך.",
        q: "האם עלי לשלם אגרה עבור הויזה בקמבודיה?"
      },
      {
        a: "eVisa קמבודית היא תעודה אלקטרונית מהממשלה, המונפקת בפורמט PDF. ויזה זו מאפשרת כניסה לקמבודיה ותנועה בתוכה למטרות תיירותיות. הוויזה האלקטרונית משמשת תחליף נוח למסמך נייר המונפק פיזית בשגרירות לאחר המתנה ארוכה.",
        q: "מהי ויזה אלקטרונית לקמבודיה?"
      },
      {
        a: "מי שמעדיף את הדרך הנוחה והבטוחה לקבל ויזה להיכנס למדינה זרה. עם ויזה אלקטרונית לקמבודיה אתה לא צריך ללכת בפועל לשגרירות, אתה לא צריך לחכות בתור בשדה התעופה, ואתה אפילו נהנה מהחזר מלא במקרה הנדיר ביותר של דחייה.",
        q: "מי צריך ויזה אלקטרונית?"
      },
      {
        a: "בהחלט. הוויזה האלקטרונית הקמבודית תקפה למשך 90 יום. אתה יכול להיכנס לקמבודיה בכל עת שתבחר בתוך שלושת החודשים האלה.",
        q: "האם ניתן להיכנס לקמבודיה בזמן שונה מזה שצוין ב- eVisa?"
      },
      {
        a: "התשובה היא לא. במהלך שלושת החודשים שבהם הויזה שלך תקפה, אתה רשאי להיכנס לקמבודיה פעם אחת בלבד.",
        q: "האם ניתן להיכנס שוב לקמבודיה עם אותה ויזה?"
      },
      {
        a: "<p>אל תהסס לחקור את הב </a> לוג <a href=\"/blog\"> שלנו לקבלת החדשות האחרונות, עדכונים ומדריכים מקיפים לקבלת אשרות לקמבודיה. </p><p>בנוסף, הצוות שלנו מוכן להציע לך <a href=\"/contact\"> סיוע אנושי חי 24/7 </a></p>. <p>תודה לך, צוות ויזנט. </p>",
        q: "יש לי שאלות נוספות"
      }
    ],
    meta_desc: "קבל ויזה אלקטרונית רשמית לקמבודיה באמצעות טופס מקוון באנגלית. הגש בקשה לויזה מבלי לבקר בשגרירות, בתהליך מהיר וקל",
    title: "ויסה אלקטרונית לקמבודיה"
  },
  canada: "קנדה",
  canada_evisa: "קנדה eTA",
  canada_page: {
    faq: [
      {
        a: "eTA מייצג אישור נסיעה אלקטרוני. על מנת להיכנס למדינות מסוימות, כולל קנדה, המטיילים נדרשים לקבל אישור ממשלתי להיכנס ולהישאר במדינה. הרשאה זו נקראת אשרת כניסה, או ויזה. בעבר התהליך היה מסובך יחסית, ודרש התמודדות עם דואר פיזי. כיום בעידן הדיגיטלי, משרדי הגירה רבים מאפשרים לך להגיש בקשת ויזה באופן מקוון, ולקבל את הויזה ישירות לדוא\"ל שלך. זה נקרא ויזה אלקטרונית, ואנחנו נשמח להנפיק אותה עבורך.",
        q: "מה זה eTA?"
      },
      {
        a: "ממשלת קנדה מחייבת כל אדם שאינו אזרח קנדי לקבל ויזה לפני ההגעה לקנדה. כלומר, כמעט כל מי שנוסע לנסוע ולשהות בקנדה נדרש לקבל אשרת כניסה. למעשה, לא יורשו לעלות למטוס ללא ויזה סטנדרטית שפרטיה זהים לפרטים בדרכון.",
        q: "מי צריך ויזה אלקטרונית לקנדה?"
      },
      {
        a: "1-2 ימים לאחר הגשת הטופס המקוון באתר האינטרנט שלנו, ה- eTA של קנדה יישלח אליך כמסמך המצורף להודעת דוא\"ל בתיבת הדואר הנכנס שלך. בעזרתו תקבל חותמת רשמית בדרכון שלך כשתגיע לבקרת הגבול בכניסה לקנדה.",
        q: "איך התהליך עובד עם הויזה האלקטרונית?"
      },
      {
        a: "כן. מספר הכניסות לקנדה עם אותה ויזה הוא בלתי מוגבל. בהנחה, כמובן, שהדרכון שלך עדיין תקף ליותר משישה חודשים, וכי הוויזה שלך עדיין בתוקף",
        q: "האם אוכל להיכנס שוב לקנדה עם אותה ויזה?"
      },
      {
        a: "בכל כניסה לקנדה מותרת שהייה רציפה של עד 180 יום. לאחר היציאה מגבולות קנדה, וכניסה חוזרת, תוכלו להישאר עד 180 ימים נוספים וכן הלאה",
        q: "כמה זמן מותר לך להישאר בקנדה בכל כניסה?"
      },
      {
        a: "מרגע הוצאתו, אשרת הכניסה תקפה למשך 5 שנים. חשוב מאוד לזכור כי אשרת הכניסה מאבדת את תוקפה כאשר תוקף הדרכון שעבורו הונפקה הויזה פג",
        q: "כמה זמן תקפה אשרת קנדה?"
      },
      {
        a: "כן, בהחלט. כל אדם שאינו אזרח קנדי, ללא קשר לגיל, מחויב לקבל ויזה סטנדרטית שהונפקה עבורו.",
        q: "האם ילדים נדרשים לקבל ויזה אלקטרונית לקנדה?"
      },
      {
        a: "לא, זה לא נדרש. ניתן להנפיק אשרת כניסה גם אם טרם קנית כרטיס טיסה.",
        q: "האם עלי לרכוש כרטיס טיסה לפני הגשת בקשה?"
      },
      {
        a: "<p>-כן. אתה יכול אפילו לעשות את זה אלקטרונית <a href=\"https:/www.canada.ca/en/immigration-refugees-citizenship/services/visit-canada/extend-stay.html\" target=\"_blank\"> כאן</a>. העלות היא כ 100$ ועשויה להימשך מספר ימים. בנוסף, יש צורך לבקש הארכה לפחות חודש לפני תום הויזה, בהנחה שהנוסע שוהה בקנדה. בשל המחיר הגבוה במקצת, עדיף לעזוב את קנדה, לקבל ויזה חדשה ל -5 שנים ולהיכנס מחדש. </p>",
        q: "האם ניתן לבקש הארכה בזמן שהייתם בקנדה?"
      },
      {
        a: "לא. לאחר שליחת בקשת הוויזה למשרד ההגירה הקנדי, אין דרך לבקש שינוי בפרטי אותה בקשה. עם זאת, בהחלט ניתן להנפיק ויזה אלקטרונית נוספת.",
        q: "האם ניתן לבקש שינוי בויזה לאחר שאושרה?"
      },
      {
        a: "<p>אל תהסס לחקור את הב </a> לוג <a href=\"/blog\"> שלנו לקבלת החדשות האחרונות, העדכונים והמדריכים המקיפים להשגת ETA לקנדה. </p><p>בנוסף, הצוות שלנו מוכן להציע לך <a href=\"/contact\"> סיוע אנושי חי 24/7 </a></p>. <p>תודה לך, צוות ויזנט. </p>",
        q: "יש לי שאלות נוספות"
      }
    ],
    meta_desc: "הגש בקשה לאישור נסיעה אלקטרוני לקנדה באנגלית וקבל אותו תוך יום אחד",
    title: "eTA לקנדה באינטרנט"
  },
  category_pages: {
    "e-visas": {
      meta_desc: "טיפים ומדריכים לטיולים למטיילים תכופים - הבלוג של Visanet מספק את המידע העדכני ביותר על נסיעות עולמיות, ויזות אלקטרוניות ו- ETA. הירשם כדי להישאר מעודכן!",
      title: "ויזות אלקטרוניות ו- ETA למטיילים תכופים • בלוג Visanet"
    },
    india: {
      meta_desc: "ויזות אלקטרוניות ואישורי נסיעה להודו - ETA להודו, אשרות שגרירות ומידע נוסף על אשרות הודיות, רק בבלוג Visanet",
      title: "הרשאות ETA ויזות אלקטרוניות להודו • בלוג Visanet"
    },
    israel: {
      meta_desc: "ויזות אלקטרוניות ואישורי נסיעה לישראל - ETA-IL לישראל, אשרות שגרירות ומידע נוסף על אשרות ישראליות, רק בבלוג Visanet",
      title: "הרשאות ויזות ETA-IL לישראל • Visanet Blog"
    },
    korea: {
      meta_desc: "ויזות אלקטרוניות ואישורי נסיעה לדרום קוריאה - K-etas לקוריאה הדרומית, אשרות שגרירות ומידע נוסף על אשרות קוריאניות, רק בבלוג Visanet",
      title: "הרשאות ויזות K-ETA לדרום קוריאה • בלוג Visanet"
    },
    news: {
      meta_desc: "חדשות תיירות למטיילים תכופים - הבלוג של Visanet מספק את המידע העדכני ביותר על ויזות אלקטרוניות, ETA והגבלות נסיעה ברחבי העולם. הירשם כדי להישאר מעודכן!",
      title: "חדשות ועדכונים למטיילים תכופים • בלוג Visanet"
    },
    travel: {
      meta_desc: "ויזות אלקטרוניות ואישורי נסיעה — מה הם מתכוונים? הבלוג של Visanet מסביר ומספק את המידע העדכני ביותר עבור נוסעים תכופים בויזות ברחבי העולם",
      title: "טיפים ומדריכים למטיילים תכופים • בלוג Visanet"
    },
    vietnam: {
      meta_desc: "ויזות אלקטרוניות ו- VOA (ויזה בהגעה) לווייטנאם - ETA לווייטנאם, אשרות שגרירות ומידע נוסף על ויזות וייטנאם, רק בבלוג Visanet",
      title: "הרשאות VOA וויזות אלקטרוניות לווייטנאם • בלוג Visanet"
    }
  },
  cc_validation_error: "פרטי הכרטיס אינם חוקיים",
  change_image: "שינוי תמונה",
  chat: "Chat",
  christianity: "נצרות",
  cities_or_locations: "שמות ערים או מיקומים",
  city: "עיר/עיר",
  click_drag_image: "לחץ או גרור תמונה כאן",
  click_here: "לחצו כאן",
  close: "סגור",
  collapse: "צמצם כרטיסיות",
  company_num: "מספר החברה",
  contact: "צור קשר",
  contact_on_pay_issue: "אם אתה נתקל בבעיות כלשהן בעת ניסיון לשלם, אנא אל תהסס <a href=\"/contact\" target=\"_blank\"> לפנות אלינו</a>.",
  contact_page: {
    additional_support: "תמיכה נוספת",
    assist: "אנו כאן כדי לסייע לך בכל שאלה, בעיה או בקשה שיש לך. ב-Visanet, אנו מחויבים לספק תמיכה יוצאת דופן ולהבטיח שהחוויה שלך תהיה חלקה ככל האפשר. לקבלת תשובות מהירות, עיין בשאלות הנפוצות שלנו או פנה ישירות באמצעות צ'אט או דוא\"ל.",
    availability: "זמין בימים שני עד שישי, בין השעות 10:00-20:00.",
    available_247: "(זמין 24/7)",
    chat: "צ'אט חי",
    desk: "מחשב נייד וציוד משרדי על שולחן",
    email: "דוא״ל",
    email_address: "כתובת אימייל",
    get_in_touch: "צור איתנו קשר בכל עת דרך הערוצים הבאים:",
    header: "צור קשר עם <span class='text-primary'> ויזנט </span>",
    hours: "ראשון-חמישי, שעות{hours}, בטלפון + WhatsApp",
    meta_desc: "צור קשר עם שירות הלקוחות של Visanet בדרכים הבאות: טלפון, WhatsApp, צ'אט חי באתר ודוא\"ל. תוכל למצוא מידע נוסף בדף יצירת הקשר.",
    msg: "ההודעה שלך",
    msg_send: "שלח לנו הודעה",
    msg_send_body: "יש לך שאלה או בקשה ספציפית? מלא את הטופס למטה ואנו נחזור אליך בהקדם האפשרי.",
    msg_send_error: "שגיאה בשליחת ההודעה",
    msg_send_success: "ההודעה נשלחה בהצלחה",
    personalized_assistance: "לקבלת סיוע מותאם אישית יותר, פנה אלינו באמצעות:",
    send_msg: "שלח הודעה",
    support_247: "אפשרויות תמיכה 24/7",
    title: "דף יצירת קשר של ויזנט"
  },
  contact_us: "צור קשר",
  continue_img_upload_later: "אתה יכול להמשיך. <br>עם הגשת הטופס, תקבל דואר אלקטרוני עם הוראות ואפשרויות להגשת התמונות שלך.",
  copy_link: "העתק קישור",
  countries_short: {
    GBR: "בריטניה"
  },
  country: "ארץ",
  coupon_applied: "קופון מוחל!",
  coupon_code: "קוד קופון",
  credit_card_charge_on_click: "על ידי לחיצה על כפתור התשלום, אמצעי התשלום שבחרת יחויב בסכום הסופי של ההזמנה:",
  credit_card_details: "פרטי כרטיס אשראי",
  crossing: {
    air: "Air",
    border: "Border name",
    flight: "Flight number",
    land: "Land",
    radio_label: "How do you plan to cross the border?",
    sea: "Sea",
    ship: "Ship name"
  },
  customer_details: "פרטי לקוח",
  day: "יום",
  days: "{n}יום | {n} ימים",
  days_1: "יום אחד",
  days_10: "10 ימים",
  days_2: "2 ימים",
  days_21: "21 Days",
  days_3: "3 ימים",
  days_4: "4 ימים",
  days_5: "5 ימים",
  days_7: "7 Days",
  describe_incident: "תיאור קצר של המקרה",
  describe_rejection: "תיאור קצר של הסירוב",
  details: "פרטי דרכון",
  did_army: "האם שירתת בצבא?",
  did_visit_saarc: "האם ביקרת באף אחת ממדינות SAARC בשלוש השנים האחרונות?",
  discount: "הנחה",
  education: "חינוך",
  eligible_countries_title_bahrain: "מדינות זכאות ל- eVisa בבחריין",
  eligible_countries_title_cambodia: "מדינות זכאות ל- eVisa בקמבודיה",
  eligible_countries_title_canada: "מדינות זכאות ל- eTA של קנדה",
  eligible_countries_title_india: "מדינות זכאות ל- eVisa בהודו",
  eligible_countries_title_indonesia: "מדינות זכאות ל- eVisa באינדונזיה",
  eligible_countries_title_israel: "מדינות זכאות לישראל ETA-IL",
  eligible_countries_title_korea: "Eligible countries for Korea K-ETA",
  eligible_countries_title_morocco: "מדינות זכאות ל- eVisa במרוקו",
  eligible_countries_title_new_zealand: "מדינות זכאות ל- eTA של ניו זילנד",
  eligible_countries_title_saudi_arabia: "מדינות זכאות לביזה אלקטרונית של ערב הסעודית",
  eligible_countries_title_sri_lanka: "מדינות זכאות ל- eVisa בסרי לנקה",
  eligible_countries_title_thailand: "Eligible countries for Thailand eVisa",
  eligible_countries_title_togo: "Eligible countries for Togo eVisa",
  eligible_countries_title_uk: "מדינות זכאות ל- ETA בבריטניה",
  eligible_countries_title_usa: "מדינות זכאות ל- ESTA בארה\"ב",
  eligible_countries_title_vietnam: "מדינות זכאות לוויזה אלקטרונית בווייטנאם",
  email: "דוא״ל",
  email_images_continue: "אנא שלח את התמונות שלך לכתובת הדוא\"ל שלנו: <a href=\"mailto:{email}\" target=\"_blank\"> {email}</a>. <br>אתה יכול להמשיך לאחר מכן.",
  emails: {
    approved: {
      approval_confirmation_bahrain: "ה-eVisa שלך לבחריין אושר בהצלחה. כעת את/ה מורש/ית לנסוע לבחריין",
      approval_confirmation_cambodia: "ה-eVisa שלך לקמבודיה אושר בהצלחה. כעת את/ה מורש/ית לנסוע לקמבודיה",
      approval_confirmation_canada: "ה-eTA שלך לקנדה אושר בהצלחה. כעת את/ה מורש/ית לנסוע לקנדה",
      approval_confirmation_india: "ה-eVisa שלך להודו אושר בהצלחה. כעת את/ה מורש/ית לנסוע להודו",
      approval_confirmation_indonesia: "ה-eVisa שלך לאינדונזיה אושר בהצלחה. כעת את/ה מורש/ית לנסוע לאינדונזיה",
      approval_confirmation_israel: "ה-ETA-IL שלך לישראל אושר בהצלחה. כעת את/ה מורש/ית לנסוע לישראל",
      approval_confirmation_korea: "ה-K-ETA שלך לקוריאה אושר בהצלחה. כעת את/ה מורש/ית לנסוע לקוריאה",
      approval_confirmation_morocco: "ה-eVisa שלך למרוקו אושר בהצלחה. כעת את/ה מורש/ית לנסוע למרוקו",
      approval_confirmation_new_zealand: "ה-NZeTA שלך לניו זילנד אושר בהצלחה. כעת את/ה מורש/ית לנסוע לניו זילנד",
      approval_confirmation_saudi_arabia: "ה-eVisa שלך לערב הסעודית אושר בהצלחה. כעת את/ה מורש/ית לנסוע לערב הסעודית",
      approval_confirmation_sri_lanka: "ה-eVisa שלך לסרי לנקה אושר בהצלחה. כעת את/ה מורש/ית לנסוע לסרי לנקה",
      approval_confirmation_thailand: "Your eVisa to Thailand has been successfully approved. You are now authorized to travel.",
      approval_confirmation_togo: "ה-eVisa שלך לטוגו אושר בהצלחה. כעת את/ה מורש/ית לנסוע לטוגו",
      approval_confirmation_uk: "ה-UK-ETA שלך לבריטניה אושר בהצלחה. כעת את/ה מורש/ית לנסוע לבריטניה",
      approval_confirmation_usa: "ה-ESTA שלך לארה\"ב אושר בהצלחה. כעת את/ה מורש/ית לנסוע לארה\"ב",
      approval_confirmation_vietnam: "ה-eVisa שלך לווייטנאם אושר בהצלחה. כעת את/ה מורש/ית לנסוע לווייטנאם",
      available_via: "אנחנו זמינים דרך מייל (ענה/י ישירות להודעה זו), <a href='{whatsapp}'>וואטסאפ</a>, או <a href='tel:{phone}'>טלפון</a>.",
      calendar_stay_limit_bahrain: "השהיות בבחריין מוגבלות ל-{days} ימים בכל שנת לוח שנה.",
      calendar_stay_limit_cambodia: "השהיות בקמבודיה מוגבלות ל-{days} ימים בכל שנת לוח שנה.",
      calendar_stay_limit_canada: "השהיות בקנדה מוגבלות ל-{days} ימים בכל שנת לוח שנה.",
      calendar_stay_limit_india: "השהיות בהודו מוגבלות ל-{days} ימים בכל שנת לוח שנה.",
      calendar_stay_limit_indonesia: "השהיות באינדונזיה מוגבלות ל-{days} ימים בכל שנת לוח שנה.",
      calendar_stay_limit_israel: "השהיות בישראל מוגבלות ל-{days} ימים בכל שנת לוח שנה.",
      calendar_stay_limit_korea: "השהיות בדרום קוריאה מוגבלות ל-{days} ימים בכל שנת לוח שנה.",
      calendar_stay_limit_morocco: "השהיות במרוקו מוגבלות ל-{days} ימים בכל שנת לוח שנה.",
      calendar_stay_limit_new_zealand: "השהיות בניו זילנד מוגבלות ל-{days} ימים בכל שנת לוח שנה.",
      calendar_stay_limit_saudi_arabia: "השהיות בערב הסעודית מוגבלות ל-{days} ימים בכל שנת לוח שנה.",
      calendar_stay_limit_sri_lanka: "השהיות בסרי לנקה מוגבלות ל-{days} ימים בכל שנת לוח שנה.",
      calendar_stay_limit_thailand: "Stays in Thailand are limited to {days} days per calendar year.",
      calendar_stay_limit_togo: "השהיות בטוגו מוגבלות ל-{days} ימים בכל שנת לוח שנה.",
      calendar_stay_limit_uk: "השהיות בבריטניה מוגבלות ל-{days} ימים בכל שנת לוח שנה.",
      calendar_stay_limit_usa: "השהיות בארצות הברית מוגבלות ל-{days} ימים בכל שנת לוח שנה.",
      calendar_stay_limit_vietnam: "השהיות בווייטנאם מוגבלות ל-{days} ימים בכל שנת לוח שנה.",
      canada_usa_link: "מתכננים לבקר בארה\"ב? החל מהיום, תוכלו להגיש בקשה ל<a href='https://visanet.co.il/us'>ויזת ESTA לארה\"ב</a> 🇺🇸",
      days_to_use_bahrain: "ה-eVisa שלך דורש כניסה לבחריין בתוך {days} הימים הקרובים!",
      days_to_use_cambodia: "ה-eVisa שלך דורש כניסה לקמבודיה בתוך {days} הימים הקרובים!",
      days_to_use_canada: "ה-eTA שלך דורש כניסה לקנדה בתוך {days} הימים הקרובים!",
      days_to_use_india: "ה-eVisa שלך דורש כניסה להודו בתוך {days} הימים הקרובים!",
      days_to_use_indonesia: "ה-eVisa שלך דורש כניסה לאינדונזיה בתוך {days} הימים הקרובים!",
      days_to_use_israel: "ה-ETA-IL שלך דורש כניסה לישראל בתוך {days} הימים הקרובים!",
      days_to_use_korea: "ה-K-ETA שלך דורש כניסה לקוריאה בתוך {days} הימים הקרובים!",
      days_to_use_morocco: "ה-eVisa שלך דורש כניסה למרוקו בתוך {days} הימים הקרובים!",
      days_to_use_new_zealand: "ה-NZeTA שלך דורש כניסה לניו זילנד בתוך {days} הימים הקרובים!",
      days_to_use_saudi_arabia: "ה-eVisa שלך דורש כניסה לערב הסעודית בתוך {days} הימים הקרובים!",
      days_to_use_sri_lanka: "ה-eVisa שלך דורש כניסה לסרי לנקה בתוך {days} הימים הקרובים!",
      days_to_use_thailand: "Your eVisa requires entry to Thailand within the next {days} days!",
      days_to_use_togo: "ה-eVisa שלך דורש כניסה לטוגו בתוך {days} הימים הקרובים!",
      days_to_use_uk: "ה-UK-ETA שלך דורש כניסה לבריטניה בתוך {days} הימים הקרובים!",
      days_to_use_usa: "ה-ESTA שלך דורש כניסה לארה\"ב בתוך {days} הימים הקרובים!",
      days_to_use_vietnam: "ה-eVisa שלך דורש כניסה לווייטנאם בתוך {days} הימים הקרובים!",
      doc_ready_bahrain: "ה-eVisa הרשמי לבחריין (eVisa Bahrain) מוכן ומצורף למייל זה.",
      doc_ready_cambodia: "ה-eVisa הרשמי לקמבודיה (eVisa Cambodia) מוכן ומצורף למייל זה.",
      doc_ready_canada: "ה-eTA הרשמי לקנדה (eTA Canada) מוכן ומצורף למייל זה.",
      doc_ready_india: "ה-eVisa הרשמי להודו (eVisa India) מוכן ומצורף למייל זה.",
      doc_ready_indonesia: "ה-eVisa הרשמי לאינדונזיה (eVisa Indonesia) מוכן ומצורף למייל זה.",
      doc_ready_israel: "ה-eVisa הרשמי לישראל (eVisa Israel) מוכן ומצורף למייל זה.",
      doc_ready_korea: "ה-eVisa הרשמי לקוריאה (eVisa Korea) מוכן ומצורף למייל זה.",
      doc_ready_morocco: "ה-eVisa הרשמי למרוקו (eVisa Morocco) מוכן ומצורף למייל זה.",
      doc_ready_new_zealand: "ה-eVisa הרשמי לניו זילנד (eVisa New Zealand) מוכן ומצורף למייל זה.",
      doc_ready_saudi_arabia: "ה-eVisa הרשמי לערב הסעודית (eVisa Saudi Arabia) מוכן ומצורף למייל זה.",
      doc_ready_sri_lanka: "ה-eVisa הרשמי לסרי לנקה (eVisa Sri Lanka) מוכן ומצורף למייל זה.",
      doc_ready_thailand: "We're pleased to inform you that your eVisa for Thailand has been approved!",
      doc_ready_togo: "ה-eVisa הרשמי לטוגו (eVisa Togo) מוכן ומצורף למייל זה.",
      doc_ready_uk: "ה-eVisa הרשמי לבריטניה (eVisa UK) מוכן ומצורף למייל זה.",
      doc_ready_usa: "ה-eVisa הרשמי לארה\"ב (eVisa USA) מוכן ומצורף למייל זה.",
      doc_ready_vietnam: "ה-eVisa הרשמי לווייטנאם (eVisa Vietnam) מוכן ומצורף למייל זה.",
      ensure_details_accurate: "אנא ודא/י שכל הפרטים האישיים שלך מדויקים ותואמים למידע בדרכון שלך.",
      entries_double_bahrain: "הויזה מאפשרת 2 כניסות לבחריין (כניסה כפולה).",
      entries_double_cambodia: "הויזה מאפשרת 2 כניסות לקמבודיה (כניסה כפולה).",
      entries_double_canada: "ה-eTA מאפשר 2 כניסות לקנדה (כניסה כפולה).",
      entries_double_india: "הויזה מאפשרת 2 כניסות להודו (כניסה כפולה).",
      entries_double_indonesia: "הויזה מאפשרת 2 כניסות לאינדונזיה (כניסה כפולה).",
      entries_double_israel: "ה-ETA-IL מאפשר 2 כניסות לישראל (כניסה כפולה).",
      entries_double_korea: "ה-K-ETA מאפשר 2 כניסות לדרום קוריאה (כניסה כפולה).",
      entries_double_morocco: "הויזה מאפשרת 2 כניסות למרוקו (כניסה כפולה).",
      entries_double_new_zealand: "ה-NZeTA מאפשר 2 כניסות לניו זילנד (כניסה כפולה).",
      entries_double_saudi_arabia: "הויזה מאפשרת 2 כניסות לערב הסעודית (כניסה כפולה).",
      entries_double_sri_lanka: "הויזה מאפשרת 2 כניסות לסרי לנקה (כניסה כפולה).",
      entries_double_thailand: "This eVisa allows for double entry (2 entries) into Thailand as long as the physical visa (stamp) remains valid.",
      entries_double_togo: "הויזה מאפשרת 2 כניסות לטוגו (כניסה כפולה).",
      entries_double_uk: "ה-UK-ETA מאפשר 2 כניסות לבריטניה (כניסה כפולה).",
      entries_double_usa: "ה-ESTA מאפשר 2 כניסות לארצות הברית (כניסה כפולה).",
      entries_double_vietnam: "הויזה מאפשרת 2 כניסות לווייטנאם (כניסה כפולה).",
      entries_multiple_bahrain: "את/ה יכול/ה להיכנס לבחריין מספר פעמים ללא הגבלות נסיעה כל עוד הויזה שלך נשארת תקפה.",
      entries_multiple_cambodia: "את/ה יכול/ה להיכנס לקמבודיה מספר פעמים ללא הגבלות נסיעה כל עוד הויזה שלך נשארת תקפה.",
      entries_multiple_canada: "את/ה יכול/ה להיכנס לקנדה מספר פעמים ללא הגבלות נסיעה כל עוד ה-eTA שלך נשאר תקף.",
      entries_multiple_india: "את/ה יכול/ה להיכנס להודו מספר פעמים ללא הגבלות נסיעה כל עוד הויזה שלך נשארת תקפה.",
      entries_multiple_indonesia: "את/ה יכול/ה להיכנס לאינדונזיה מספר פעמים ללא הגבלות נסיעה כל עוד הויזה שלך נשארת תקפה.",
      entries_multiple_israel: "את/ה יכול/ה להיכנס לישראל מספר פעמים ללא הגבלות נסיעה כל עוד ה-ETA-IL שלך נשאר תקף.",
      entries_multiple_korea: "את/ה יכול/ה להיכנס לדרום קוריאה מספר פעמים ללא הגבלות נסיעה כל עוד ה-K-ETA שלך נשאר תקף.",
      entries_multiple_morocco: "את/ה יכול/ה להיכנס למרוקו מספר פעמים ללא הגבלות נסיעה כל עוד הויזה שלך נשארת תקפה.",
      entries_multiple_new_zealand: "את/ה יכול/ה להיכנס לניו זילנד מספר פעמים ללא הגבלות נסיעה כל עוד ה-NZeTA שלך נשאר תקף.",
      entries_multiple_saudi_arabia: "את/ה יכול/ה להיכנס לערב הסעודית מספר פעמים ללא הגבלות נסיעה כל עוד הויזה שלך נשארת תקפה.",
      entries_multiple_sri_lanka: "את/ה יכול/ה להיכנס לסרי לנקה מספר פעמים ללא הגבלות נסיעה כל עוד הויזה שלך נשארת תקפה.",
      entries_multiple_thailand: "You may enter Thailand multiple times without restrictions while your eVisa remains valid.",
      entries_multiple_togo: "את/ה יכול/ה להיכנס לטוגו מספר פעמים ללא הגבלות נסיעה כל עוד הויזה שלך נשארת תקפה.",
      entries_multiple_uk: "את/ה יכול/ה להיכנס לבריטניה מספר פעמים ללא הגבלות נסיעה כל עוד ה-UK-ETA שלך נשאר תקף.",
      entries_multiple_usa: "את/ה יכול/ה להיכנס לארצות הברית מספר פעמים ללא הגבלות נסיעה כל עוד ה-ESTA שלך נשאר תקף.",
      entries_multiple_vietnam: "את/ה יכול/ה להיכנס לווייטנאם מספר פעמים ללא הגבלות נסיעה כל עוד הויזה שלך נשארת תקפה.",
      entries_single_bahrain: "הויזה מאפשרת כניסה חד פעמית לבחריין.",
      entries_single_cambodia: "הויזה מאפשרת כניסה חד פעמית לקמבודיה.",
      entries_single_canada: "ה-eTA מאפשר כניסה חד פעמית לקנדה.",
      entries_single_india: "הויזה מאפשרת כניסה חד פעמית להודו.",
      entries_single_indonesia: "הויזה מאפשרת כניסה חד פעמית לאינדונזיה.",
      entries_single_israel: "ה-ETA-IL מאפשר כניסה חד פעמית לישראל.",
      entries_single_korea: "ה-K-ETA מאפשר כניסה חד פעמית לדרום קוריאה.",
      entries_single_morocco: "הויזה מאפשרת כניסה חד פעמית למרוקו.",
      entries_single_new_zealand: "ה-NZeTA מאפשר כניסה חד פעמית לניו זילנד.",
      entries_single_saudi_arabia: "הויזה מאפשרת כניסה חד פעמית לערב הסעודית.",
      entries_single_sri_lanka: "הויזה מאפשרת כניסה חד פעמית לסרי לנקה.",
      entries_single_thailand: "This eVisa permits a single entry into Thailand.",
      entries_single_togo: "הויזה מאפשרת כניסה חד פעמית לטוגו.",
      entries_single_uk: "ה-UK-ETA מאפשר כניסה חד פעמית לבריטניה.",
      entries_single_usa: "ה-ESTA מאפשר כניסה חד פעמית לארצות הברית.",
      entries_single_vietnam: "הויזה מאפשרת כניסה חד פעמית לווייטנאם.",
      eta_disclaimer_bahrain: "בעוד שה-eVisa מאשר/ת נסיעה לבחריין, הכניסה למדינה נתונה בסופו של דבר לשיקול דעתם של קציני הגירה בבקרת הגבולות. הם יקבלו את ההחלטה הסופית על סמך הפרטים שנמסרו, כגון מטרת הביקור שלך, מסלול הנסיעה שלך ואנשי הקשר שלך בתוך בחריין.",
      eta_disclaimer_cambodia: "בעוד שה-eVisa מאשר/ת נסיעה לקמבודיה, הכניסה למדינה נתונה בסופו של דבר לשיקול דעתם של קציני הגירה בבקרת הגבולות. הם יקבלו את ההחלטה הסופית על סמך הפרטים שנמסרו, כגון מטרת הביקור שלך, מסלול הנסיעה שלך ואנשי הקשר שלך בתוך קמבודיה.",
      eta_disclaimer_canada: "בעוד שה-eTA מאשר/ת נסיעה לקנדה, הכניסה למדינה נתונה בסופו של דבר לשיקול דעתם של קציני הגירה בבקרת הגבולות. הם יקבלו את ההחלטה הסופית על סמך הפרטים שנמסרו, כגון מטרת הביקור שלך, מסלול הנסיעה שלך ואנשי הקשר שלך בתוך קנדה.",
      eta_disclaimer_india: "בעוד שה-eVisa מאשר/ת נסיעה להודו, הכניסה למדינה נתונה בסופו של דבר לשיקול דעתם של קציני הגירה בבקרת הגבולות. הם יקבלו את ההחלטה הסופית על סמך הפרטים שנמסרו, כגון מטרת הביקור שלך, מסלול הנסיעה שלך ואנשי הקשר שלך בתוך הודו.",
      eta_disclaimer_indonesia: "בעוד שה-eVisa מאשר/ת נסיעה לאינדונזיה, הכניסה למדינה נתונה בסופו של דבר לשיקול דעתם של קציני הגירה בבקרת הגבולות. הם יקבלו את ההחלטה הסופית על סמך הפרטים שנמסרו, כגון מטרת הביקור שלך, מסלול הנסיעה שלך ואנשי הקשר שלך בתוך אינדונזיה.",
      eta_disclaimer_israel: "בעוד שה-ETA-IL מאשר/ת נסיעה לישראל, הכניסה למדינה נתונה בסופו של דבר לשיקול דעתם של קציני הגירה בבקרת הגבולות. הם יקבלו את ההחלטה הסופית על סמך הפרטים שנמסרו, כגון מטרת הביקור שלך, מסלול הנסיעה שלך ואנשי הקשר שלך בתוך ישראל.",
      eta_disclaimer_korea: "בעוד שה-K-ETA מאשר/ת נסיעה לקוריאה, הכניסה למדינה נתונה בסופו של דבר לשיקול דעתם של קציני הגירה בבקרת הגבולות. הם יקבלו את ההחלטה הסופית על סמך הפרטים שנמסרו, כגון מטרת הביקור שלך, מסלול הנסיעה שלך ואנשי הקשר שלך בתוך קוריאה.",
      eta_disclaimer_morocco: "בעוד שה-eVisa מאשר/ת נסיעה למרוקו, הכניסה למדינה נתונה בסופו של דבר לשיקול דעתם של קציני הגירה בבקרת הגבולות. הם יקבלו את ההחלטה הסופית על סמך הפרטים שנמסרו, כגון מטרת הביקור שלך, מסלול הנסיעה שלך ואנשי הקשר שלך בתוך מרוקו.",
      eta_disclaimer_new_zealand: "בעוד שה-NZeTA מאשר/ת נסיעה לניו זילנד, הכניסה למדינה נתונה בסופו של דבר לשיקול דעתם של קציני הגירה בבקרת הגבולות. הם יקבלו את ההחלטה הסופית על סמך הפרטים שנמסרו, כגון מטרת הביקור שלך, מסלול הנסיעה שלך ואנשי הקשר שלך בתוך ניו זילנד.",
      eta_disclaimer_saudi_arabia: "בעוד שה-eVisa מאשר/ת נסיעה לערב הסעודית, הכניסה למדינה נתונה בסופו של דבר לשיקול דעתם של קציני הגירה בבקרת הגבולות. הם יקבלו את ההחלטה הסופית על סמך הפרטים שנמסרו, כגון מטרת הביקור שלך, מסלול הנסיעה שלך ואנשי הקשר שלך בתוך ערב הסעודית.",
      eta_disclaimer_sri_lanka: "בעוד שה-eVisa מאשר/ת נסיעה לסרי לנקה, הכניסה למדינה נתונה בסופו של דבר לשיקול דעתם של קציני הגירה בבקרת הגבולות. הם יקבלו את ההחלטה הסופית על סמך הפרטים שנמסרו, כגון מטרת הביקור שלך, מסלול הנסיעה שלך ואנשי הקשר שלך בתוך סרי לנקה.",
      eta_disclaimer_thailand: "While your eVisa authorizes travel, entry into Thailand is ultimately at the discretion of border control immigration officers. They will make the final decision based on your visit’s purpose, travel itinerary, and local contacts.",
      eta_disclaimer_togo: "בעוד שה-eVisa מאשר/ת נסיעה לטוגו, הכניסה למדינה נתונה בסופו של דבר לשיקול דעתם של קציני הגירה בבקרת הגבולות. הם יקבלו את ההחלטה הסופית על סמך הפרטים שנמסרו, כגון מטרת הביקור שלך, מסלול הנסיעה שלך ואנשי הקשר שלך בתוך טוגו.",
      eta_disclaimer_uk: "בעוד שה-UK-ETA מאשר/ת נסיעה לבריטניה, הכניסה למדינה נתונה בסופו של דבר לשיקול דעתם של קציני הגירה בבקרת הגבולות. הם יקבלו את ההחלטה הסופית על סמך הפרטים שנמסרו, כגון מטרת הביקור שלך, מסלול הנסיעה שלך ואנשי הקשר שלך בתוך בריטניה.",
      eta_disclaimer_usa: "בעוד שה-ESTA מאשר/ת נסיעה לארה\"ב, הכניסה למדינה נתונה בסופו של דבר לשיקול דעתם של קציני הגירה בבקרת הגבולות. הם יקבלו את ההחלטה הסופית על סמך הפרטים שנמסרו, כגון מטרת הביקור שלך, מסלול הנסיעה שלך ואנשי הקשר שלך בתוך ארה\"ב.",
      eta_disclaimer_vietnam: "בעוד שה-eVisa מאשר/ת נסיעה לווייטנאם, הכניסה למדינה נתונה בסופו של דבר לשיקול דעתם של קציני הגירה בבקרת הגבולות. הם יקבלו את ההחלטה הסופית על סמך הפרטים שנמסרו, כגון מטרת הביקור שלך, מסלול הנסיעה שלך ואנשי הקשר שלך בתוך וייטנאם.",
      eta_please_note: "שימו לב:",
      greeting: "מזל טוב, {name}",
      instruction_2_passport_pages: "חייבים להיות לך לפחות 2 עמודים ריקים בדרכון שלך.",
      instruction_dont_print_eta: "אין צורך להדפיס את ה-{visaDocName} הזה.",
      instruction_dont_print_evisa: "אין צורך להדפיס את הויזה הזה.",
      instruction_dont_print_verification_eta: "צוות התחבורה ובקרת הגבולות יאמת/י את ה-{visaDocName} שלך בעת הצגת הדרכון שלך. במידת הצורך, את/ה יכול/ה גם להציג את ה-{visaDocName} בטלפון שלך.",
      instruction_dont_print_verification_evisa: "צוות התחבורה ובקרת הגבולות יאמת/י את הויזה שלך בעת הצגת הדרכון שלך. במידת הצורך, את/ה יכול/ה גם להציג את ה-{visaDocName} בטלפון שלך.",
      instruction_print_eta: "עליך/עלייך להדפיס את אישור ה-{visaDocName} המצורף למייל זה.",
      instruction_print_evisa: "עליך/עלייך להדפיס את אישור הויזה המצורף למייל זה.",
      instruction_print_keep_handy_bahrain: "שמור/שמרי את הויזה המודפס בהישג יד בעת העלייה למטוס ו/או חציית הגבול.",
      instruction_print_keep_handy_cambodia: "שמור/שמרי את הויזה המודפס בהישג יד בעת העלייה למטוס ו/או חציית הגבול.",
      instruction_print_keep_handy_canada: "שמור/שמרי את ה-eTA המודפס בהישג יד בעת העלייה למטוס ו/או חציית הגבול.",
      instruction_print_keep_handy_india: "שמור/שמרי את הויזה המודפס בהישג יד בעת העלייה למטוס ו/או חציית הגבול.",
      instruction_print_keep_handy_indonesia: "שמור/שמרי את הויזה המודפס בהישג יד בעת העלייה למטוס ו/או חציית הגבול.",
      instruction_print_keep_handy_israel: "שמור/שמרי את ה-ETA-IL המודפס בהישג יד בעת העלייה למטוס ו/או חציית הגבול.",
      instruction_print_keep_handy_korea: "שמור/שמרי את ה-K-ETA המודפס בהישג יד בעת העלייה למטוס ו/או חציית הגבול.",
      instruction_print_keep_handy_morocco: "שמור/שמרי את הויזה המודפס בהישג יד בעת העלייה למטוס ו/או חציית הגבול.",
      instruction_print_keep_handy_new_zealand: "שמור/שמרי את ה-NZeTA המודפס בהישג יד בעת העלייה למטוס ו/או חציית הגבול.",
      instruction_print_keep_handy_saudi_arabia: "שמור/שמרי את הויזה המודפס בהישג יד בעת העלייה למטוס ו/או חציית הגבול.",
      instruction_print_keep_handy_sri_lanka: "שמור/שמרי את הויזה המודפס בהישג יד בעת העלייה למטוס ו/או חציית הגבול.",
      instruction_print_keep_handy_thailand: "Keep the printed eVisa handy when boarding and/or crossing the border in Thailand.",
      instruction_print_keep_handy_togo: "שמור/שמרי את הויזה המודפס בהישג יד בעת העלייה למטוס ו/או חציית הגבול.",
      instruction_print_keep_handy_uk: "שמור/שמרי את ה-UK-ETA המודפס בהישג יד בעת העלייה למטוס ו/או חציית הגבול.",
      instruction_print_keep_handy_usa: "שמור/שמרי את ה-ESTA המודפס בהישג יד בעת העלייה למטוס ו/או חציית הגבול.",
      instruction_print_keep_handy_vietnam: "שמור/שמרי את הויזה המודפס בהישג יד בעת העלייה למטוס ו/או חציית הגבול.",
      instruction_print_twice_eta: "עליך/עלייך להדפיס שני עותקים של ה-{visaDocName}.",
      instruction_print_twice_evisa: "עליך/עלייך להדפיס שני עותקים של הויזה.",
      instruction_print_twice_present: "הצג/הציגי עותק אחד במהלך הצ'ק-אין ואת השני בביקורת הדרכונים עם ההגעה. הדפסה בשחור לבן מקובלת.",
      instruction_return_ticket_and_accommodation_bahrain: "יהיה עליך/עלייך להציג: כרטיס טיסה חזרה או יציאה, והזמנה לבית מלון או דירה.",
      instruction_return_ticket_and_accommodation_cambodia: "יהיה עליך/עלייך להציג: כרטיס טיסה חזרה או יציאה, והזמנה לבית מלון או דירה.",
      instruction_return_ticket_and_accommodation_canada: "יהיה עליך/עלייך להציג: כרטיס טיסה חזרה או יציאה, והזמנה לבית מלון או דירה.",
      instruction_return_ticket_and_accommodation_india: "יהיה עליך/עלייך להציג: כרטיס טיסה חזרה או יציאה, והזמנה לבית מלון או דירה.",
      instruction_return_ticket_and_accommodation_indonesia: "יהיה עליך/עלייך להציג: כרטיס טיסה חזרה או יציאה, והזמנה לבית מלון או דירה.",
      instruction_return_ticket_and_accommodation_israel: "יהיה עליך/עלייך להציג: כרטיס טיסה חזרה או יציאה, והזמנה לבית מלון או דירה.",
      instruction_return_ticket_and_accommodation_korea: "יהיה עליך/עלייך להציג: כרטיס טיסה חזרה או יציאה, והזמנה לבית מלון או דירה.",
      instruction_return_ticket_and_accommodation_morocco: "יהיה עליך/עלייך להציג: כרטיס טיסה חזרה או יציאה, והזמנה לבית מלון או דירה.",
      instruction_return_ticket_and_accommodation_new_zealand: "יהיה עליך/עלייך להציג: כרטיס טיסה חזרה או יציאה, והזמנה לבית מלון או דירה.",
      instruction_return_ticket_and_accommodation_saudi_arabia: "יהיה עליך/עלייך להציג: כרטיס טיסה חזרה או יציאה, והזמנה לבית מלון או דירה.",
      instruction_return_ticket_and_accommodation_sri_lanka: "יהיה עליך/עלייך להציג: כרטיס טיסה חזרה או יציאה, והזמנה לבית מלון או דירה.",
      instruction_return_ticket_and_accommodation_thailand: "Upon entering Thailand, you must present a return or departure flight ticket and accommodation reservation.",
      instruction_return_ticket_and_accommodation_togo: "יהיה עליך/עלייך להציג: כרטיס טיסה חזרה או יציאה, והזמנה לבית מלון או דירה.",
      instruction_return_ticket_and_accommodation_uk: "יהיה עליך/עלייך להציג: כרטיס טיסה חזרה או יציאה, והזמנה לבית מלון או דירה.",
      instruction_return_ticket_and_accommodation_usa: "יהיה עליך/עלייך להציג: כרטיס טיסה חזרה או יציאה, והזמנה לבית מלון או דירה.",
      instruction_return_ticket_and_accommodation_vietnam: "יהיה עליך/עלייך להציג: כרטיס טיסה חזרה או יציאה, והזמנה לבית מלון או דירה.",
      instruction_return_ticket_bahrain: "יהיה עליך/עלייך להציג כרטיס טיסה חזרה/יציאה מבחריין.",
      instruction_return_ticket_cambodia: "יהיה עליך/עלייך להציג כרטיס טיסה חזרה/יציאה מקמבודיה.",
      instruction_return_ticket_canada: "יהיה עליך/עלייך להציג כרטיס טיסה חזרה/יציאה מקנדה.",
      instruction_return_ticket_india: "יהיה עליך/עלייך להציג כרטיס טיסה חזרה/יציאה מהודו.",
      instruction_return_ticket_indonesia: "יהיה עליך/עלייך להציג כרטיס טיסה חזרה/יציאה מאינדונזיה.",
      instruction_return_ticket_israel: "יהיה עליך/עלייך להציג כרטיס טיסה חזרה/יציאה מישראל.",
      instruction_return_ticket_korea: "יהיה עליך/עלייך להציג כרטיס טיסה חזרה/יציאה מדרום קוריאה.",
      instruction_return_ticket_morocco: "יהיה עליך/עלייך להציג כרטיס טיסה חזרה/יציאה ממרוקו.",
      instruction_return_ticket_new_zealand: "יהיה עליך/עלייך להציג כרטיס טיסה חזרה/יציאה מניו זילנד.",
      instruction_return_ticket_saudi_arabia: "יהיה עליך/עלייך להציג כרטיס טיסה חזרה/יציאה מערב הסעודית.",
      instruction_return_ticket_sri_lanka: "יהיה עליך/עלייך להציג כרטיס טיסה חזרה/יציאה מסרי לנקה.",
      instruction_return_ticket_thailand: "Upon entering Thailand, you must present a return or departure flight ticket.",
      instruction_return_ticket_togo: "יהיה עליך/עלייך להציג כרטיס טיסה חזרה/יציאה מטוגו.",
      instruction_return_ticket_uk: "יהיה עליך/עלייך להציג כרטיס טיסה חזרה/יציאה מבריטניה.",
      instruction_return_ticket_usa: "יהיה עליך/עלייך להציג כרטיס טיסה חזרה/יציאה מארצות הברית.",
      instruction_return_ticket_vietnam: "יהיה עליך/עלייך להציג כרטיס טיסה חזרה/יציאה מווייטנאם.",
      instruction_stay_reset_bahrain: "כל ביקור בבחריין מוגבל ל-{days} ימים רצופים.",
      instruction_stay_reset_cambodia: "כל ביקור בקמבודיה מוגבל ל-{days} ימים רצופים.",
      instruction_stay_reset_canada: "כל ביקור בקנדה מוגבל ל-{days} ימים רצופים.",
      instruction_stay_reset_extend: "To extend your stay legally, exit and re-enter the country. Upon re-entry, your permitted stay resets for another {days} days.",
      instruction_stay_reset_extend_bahrain: "- כדי להמשיך את שהותך/שהותך באופן חוקי, עליך/עלייך לצאת מהמדינה ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה מחדש, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים במדינה.",
      instruction_stay_reset_extend_cambodia: "- כדי להמשיך את שהותך/שהותך באופן חוקי, עליך/עלייך לצאת מהמדינה ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה מחדש, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים במדינה.",
      instruction_stay_reset_extend_canada: "- כדי להמשיך את שהותך/שהותך באופן חוקי, עליך/עלייך לצאת מהמדינה ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה מחדש, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים במדינה.",
      instruction_stay_reset_extend_india: "- כדי להמשיך את שהותך/שהותך באופן חוקי, עליך/עלייך לצאת מהמדינה ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה מחדש, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים במדינה.",
      instruction_stay_reset_extend_indonesia: "- כדי להמשיך את שהותך/שהותך באופן חוקי, עליך/עלייך לצאת מהמדינה ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה מחדש, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים במדינה.",
      instruction_stay_reset_extend_israel: "- כדי להמשיך את שהותך/שהותך באופן חוקי, עליך/עלייך לצאת מהמדינה ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה מחדש, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים במדינה.",
      instruction_stay_reset_extend_korea: "- כדי להמשיך את שהותך/שהותך באופן חוקי, עליך/עלייך לצאת מהמדינה ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה מחדש, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים במדינה.",
      instruction_stay_reset_extend_morocco: "- כדי להמשיך את שהותך/שהותך באופן חוקי, עליך/עלייך לצאת מהמדינה ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה מחדש, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים במדינה.",
      instruction_stay_reset_extend_new_zealand: "- כדי להמשיך את שהותך/שהותך באופן חוקי, עליך/עלייך לצאת מהמדינה ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה מחדש, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים במדינה.",
      instruction_stay_reset_extend_saudi_arabia: "- כדי להמשיך את שהותך/שהותך באופן חוקי, עליך/עלייך לצאת מהמדינה ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה מחדש, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים במדינה.",
      instruction_stay_reset_extend_sri_lanka: "- כדי להמשיך את שהותך/שהותך באופן חוקי, עליך/עלייך לצאת מהמדינה ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה מחדש, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים במדינה.",
      instruction_stay_reset_extend_thailand: "To legally extend your stay, you must exit the country and re-enter on a subsequent day. Upon re-entry, your permitted stay will reset, allowing you an additional {days} days in Thailand.",
      instruction_stay_reset_extend_togo: "- כדי להמשיך את שהותך/שהותך באופן חוקי, עליך/עלייך לצאת מהמדינה ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה מחדש, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים במדינה.",
      instruction_stay_reset_extend_uk: "- כדי להמשיך את שהותך/שהותך באופן חוקי, עליך/עלייך לצאת מהמדינה ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה מחדש, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים במדינה.",
      instruction_stay_reset_extend_usa: "- כדי להמשיך את שהותך/שהותך באופן חוקי, עליך/עלייך לצאת מהמדינה ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה מחדש, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים במדינה.",
      instruction_stay_reset_extend_vietnam: "- כדי להמשיך את שהותך/שהותך באופן חוקי, עליך/עלייך לצאת מהמדינה ולהיכנס מחדש ביום שלאחר מכן. עם הכניסה מחדש, השהייה המותרת שלך תתאפס, ותאפשר לך {days} ימים נוספים במדינה.",
      instruction_stay_reset_india: "כל ביקור בהודו מוגבל ל-{days} ימים רצופים.",
      instruction_stay_reset_indonesia: "כל ביקור באינדונזיה מוגבל ל-{days} ימים רצופים.",
      instruction_stay_reset_israel: "כל ביקור בישראל מוגבל ל-{days} ימים רצופים.",
      instruction_stay_reset_korea: "כל ביקור בדרום קוריאה מוגבל ל-{days} ימים רצופים.",
      instruction_stay_reset_morocco: "כל ביקור במרוקו מוגבל ל-{days} ימים רצופים.",
      instruction_stay_reset_new_zealand: "כל ביקור בניו זילנד מוגבל ל-{days} ימים רצופים.",
      instruction_stay_reset_saudi_arabia: "כל ביקור בערב הסעודית מוגבל ל-{days} ימים רצופים.",
      instruction_stay_reset_sri_lanka: "כל ביקור בסרי לנקה מוגבל ל-{days} ימים רצופים.",
      instruction_stay_reset_thailand: "Each visit to Thailand is limited to {days} consecutive days.",
      instruction_stay_reset_togo: "כל ביקור בטוגו מוגבל ל-{days} ימים רצופים.",
      instruction_stay_reset_uk: "כל ביקור בבריטניה מוגבל ל-{days} ימים רצופים.",
      instruction_stay_reset_usa: "כל ביקור בארצות הברית מוגבל ל-{days} ימים רצופים.",
      instruction_stay_reset_vietnam: "כל ביקור בווייטנאם מוגבל ל-{days} ימים רצופים.",
      instruction_travel_documents: "לידיעתך, תתבקש/י להציג הזמנה לבית מלון או דירה כדי להוכיח שיש לך מקום לינה, להוכיח את היכולת הכלכלית לכסות את שהותך/שהותך במדינה ולספק הוכחה לביטוח בריאות.",
      instructions_title: "Important Instructions",
      instructions_title_bahrain: "הוראות ל-eVisa לבחריין",
      instructions_title_cambodia: "הוראות ל-eVisa לקמבודיה",
      instructions_title_canada: "הוראות ל-eTA לקנדה",
      instructions_title_india: "הוראות ל-eVisa להודו",
      instructions_title_indonesia: "הוראות ל-eVisa לאינדונזיה",
      instructions_title_israel: "הוראות ל-ETA-IL לישראל",
      instructions_title_korea: "הוראות ל-K-ETA לקוריאה",
      instructions_title_morocco: "הוראות ל-eVisa למרוקו",
      instructions_title_new_zealand: "הוראות ל-NZeTA לניו זילנד",
      instructions_title_saudi_arabia: "הוראות ל-eVisa לערב הסעודית",
      instructions_title_sri_lanka: "הוראות ל-eVisa לסרי לנקה",
      instructions_title_thailand: "Instructions for eVisa to Thailand",
      instructions_title_togo: "הוראות ל-eVisa לטוגו",
      instructions_title_uk: "הוראות ל-UK-ETA לבריטניה",
      instructions_title_usa: "הוראות ל-ESTA לארה\"ב",
      instructions_title_vietnam: "הוראות ל-eVisa לווייטנאם",
      intent_business_bahrain: "מטרת הביקור שלך היא עסקית. את/ה מורשה/ית לנהל עסקים במהלך שהותך/שהותך.",
      intent_business_cambodia: "מטרת הביקור שלך היא עסקית. את/ה מורשה/ית לנהל עסקים במהלך שהותך/שהותך.",
      intent_business_canada: "מטרת הביקור שלך היא עסקית. את/ה מורשה/ית לנהל עסקים במהלך שהותך/שהותך.",
      intent_business_india: "מטרת הביקור שלך היא עסקית. את/ה מורשה/ית לנהל עסקים במהלך שהותך/שהותך.",
      intent_business_indonesia: "מטרת הביקור שלך היא עסקית. את/ה מורשה/ית לנהל עסקים במהלך שהותך/שהותך.",
      intent_business_israel: "מטרת הביקור שלך היא עסקית. את/ה מורשה/ית לנהל עסקים במהלך שהותך/שהותך.",
      intent_business_korea: "מטרת הביקור שלך היא עסקית. את/ה מורשה/ית לנהל עסקים במהלך שהותך/שהותך.",
      intent_business_morocco: "מטרת הביקור שלך היא עסקית. את/ה מורשה/ית לנהל עסקים במהלך שהותך/שהותך.",
      intent_business_new_zealand: "מטרת הביקור שלך היא עסקית. את/ה מורשה/ית לנהל עסקים במהלך שהותך/שהותך.",
      intent_business_saudi_arabia: "מטרת הביקור שלך היא עסקית. את/ה מורשה/ית לנהל עסקים במהלך שהותך/שהותך.",
      intent_business_sri_lanka: "מטרת הביקור שלך היא עסקית. את/ה מורשה/ית לנהל עסקים במהלך שהותך/שהותך.",
      intent_business_thailand: "The purpose of your visit is business. You may conduct business activities during your stay in Thailand.",
      intent_business_togo: "מטרת הביקור שלך היא עסקית. את/ה מורשה/ית לנהל עסקים במהלך שהותך/שהותך.",
      intent_business_uk: "מטרת הביקור שלך היא עסקית. את/ה מורשה/ית לנהל עסקים במהלך שהותך/שהותך.",
      intent_business_usa: "מטרת הביקור שלך היא עסקית. את/ה מורשה/ית לנהל עסקים במהלך שהותך/שהותך.",
      intent_business_vietnam: "מטרת הביקור שלך היא עסקית. את/ה מורשה/ית לנהל עסקים במהלך שהותך/שהותך.",
      intent_tourism_bahrain: "מטרת הביקור שלך היא תיירות בלבד. אינך/אינך מורשה/ית לעבוד או לנהל עסקים במהלך שהותך/שהותך.",
      intent_tourism_cambodia: "מטרת הביקור שלך היא תיירות בלבד. אינך/אינך מורשה/ית לעבוד או לנהל עסקים במהלך שהותך/שהותך.",
      intent_tourism_canada: "מטרת הביקור שלך היא תיירות בלבד. אינך/אינך מורשה/ית לעבוד או לנהל עסקים במהלך שהותך/שהותך.",
      intent_tourism_india: "מטרת הביקור שלך היא תיירות בלבד. אינך/אינך מורשה/ית לעבוד או לנהל עסקים במהלך שהותך/שהותך.",
      intent_tourism_indonesia: "מטרת הביקור שלך היא תיירות בלבד. אינך/אינך מורשה/ית לעבוד או לנהל עסקים במהלך שהותך/שהותך.",
      intent_tourism_israel: "מטרת הביקור שלך היא תיירות בלבד. אינך/אינך מורשה/ית לעבוד או לנהל עסקים במהלך שהותך/שהותך.",
      intent_tourism_korea: "מטרת הביקור שלך היא תיירות בלבד. אינך/אינך מורשה/ית לעבוד או לנהל עסקים במהלך שהותך/שהותך.",
      intent_tourism_morocco: "מטרת הביקור שלך היא תיירות בלבד. אינך/אינך מורשה/ית לעבוד או לנהל עסקים במהלך שהותך/שהותך.",
      intent_tourism_new_zealand: "מטרת הביקור שלך היא תיירות בלבד. אינך/אינך מורשה/ית לעבוד או לנהל עסקים במהלך שהותך/שהותך.",
      intent_tourism_saudi_arabia: "מטרת הביקור שלך היא תיירות בלבד. אינך/אינך מורשה/ית לעבוד או לנהל עסקים במהלך שהותך/שהותך.",
      intent_tourism_sri_lanka: "מטרת הביקור שלך היא תיירות בלבד. אינך/אינך מורשה/ית לעבוד או לנהל עסקים במהלך שהותך/שהותך.",
      intent_tourism_thailand: "The purpose of your visit is tourism only. You are not permitted to work or conduct business in Thailand.",
      intent_tourism_togo: "מטרת הביקור שלך היא תיירות בלבד. אינך/אינך מורשה/ית לעבוד או לנהל עסקים במהלך שהותך/שהותך.",
      intent_tourism_uk: "מטרת הביקור שלך היא תיירות בלבד. אינך/אינך מורשה/ית לעבוד או לנהל עסקים במהלך שהותך/שהותך.",
      intent_tourism_usa: "מטרת הביקור שלך היא תיירות בלבד. אינך/אינך מורשה/ית לעבוד או לנהל עסקים במהלך שהותך/שהותך.",
      intent_tourism_vietnam: "מטרת הביקור שלך היא תיירות בלבד. אינך/אינך מורשה/ית לעבוד או לנהל עסקים במהלך שהותך/שהותך.",
      leave_review: "זה יחמם את ליבנו אם תשאר/י המלצה או ביקורת עלינו ב-",
      liked_service: "אהבת את השירות שלנו?",
      passport_requirement_eta: "עליך/עלייך להציג את הדרכון ששימש להגשת בקשה ל-{visaDocName}; לא יתקבל דרכון אחר.",
      passport_requirement_evisa: "עליך/עלייך להציג את הדרכון ששימש להגשת בקשה לויזה; לא יתקבל דרכון אחר.",
      pleasant_flight: "אנו מאחלים לך טיסה נעימה",
      regards: "Best regards,<br/>The Visanet Team",
      safe_travels: "Thank you for choosing Visanet. Safe travels!",
      thank_you_choosing: "ותודה שבחרת בוויזאנט.",
      upon_entering_bahrain: "עם הכניסה לבחריין,",
      upon_entering_cambodia: "עם הכניסה לקמבודיה,",
      upon_entering_canada: "עם הכניסה לקנדה,",
      upon_entering_india: "עם הכניסה להודו,",
      upon_entering_indonesia: "עם הכניסה לאינדונזיה,",
      upon_entering_israel: "עם הכניסה לישראל,",
      upon_entering_korea: "עם הכניסה לקוריאה,",
      upon_entering_morocco: "עם הכניסה למרוקו,",
      upon_entering_new_zealand: "עם הכניסה לניו זילנד,",
      upon_entering_saudi_arabia: "עם הכניסה לערב הסעודית,",
      upon_entering_sri_lanka: "עם הכניסה לסרי לנקה,",
      upon_entering_thailand: "Upon entering Thailand,",
      upon_entering_togo: "עם הכניסה לטוגו,",
      upon_entering_uk: "עם הכניסה לבריטניה,",
      upon_entering_usa: "עם הכניסה לארה\"ב,",
      upon_entering_vietnam: "עם הכניסה לווייטנאם,",
      valid_since_approval_eta: "ה-{visaDocName} שלך תקף למשך {validity} מהיום, או עד שתוקף הדרכון שלך יפוג, המוקדם מביניהם.",
      valid_since_approval_evisa: "הויזה שלך תקפה למשך {validity} מהיום, או עד שתוקף הדרכון שלך יפוג, המוקדם מביניהם.",
      valid_since_entry_bahrain: "מרגע הכניסה לבחריין, תורשה/י לשהות במדינה עד {validity}.",
      valid_since_entry_cambodia: "מרגע הכניסה לקמבודיה, תורשה/י לשהות במדינה עד {validity}.",
      valid_since_entry_canada: "מרגע הכניסה לקנדה, תורשה/י לשהות במדינה עד {validity}.",
      valid_since_entry_india: "מרגע הכניסה להודו, תורשה/י לשהות במדינה עד {validity}.",
      valid_since_entry_indonesia: "מרגע הכניסה לאינדונזיה, תורשה/י לשהות במדינה עד {validity}.",
      valid_since_entry_israel: "מרגע הכניסה לישראל, תורשה/י לשהות במדינה עד {validity}.",
      valid_since_entry_korea: "מרגע הכניסה לקוריאה, תורשה/י לשהות במדינה עד {validity}.",
      valid_since_entry_morocco: "מרגע הכניסה למרוקו, תורשה/י לשהות במדינה עד {validity}.",
      valid_since_entry_new_zealand: "מרגע הכניסה לניו זילנד, תורשה/י לשהות במדינה עד {validity}.",
      valid_since_entry_saudi_arabia: "מרגע הכניסה לערב הסעודית, תורשה/י לשהות במדינה עד {validity}.",
      valid_since_entry_sri_lanka: "מרגע הכניסה לסרי לנקה, תורשה/י לשהות במדינה עד {validity}.",
      valid_since_entry_thailand: "Upon entering Thailand, your permitted stay is up to {validity}.",
      valid_since_entry_togo: "מרגע הכניסה לטוגו, תורשה/י לשהות במדינה עד {validity}.",
      valid_since_entry_uk: "מרגע הכניסה לבריטניה, תורשה/י לשהות במדינה עד {validity}.",
      valid_since_entry_usa: "מרגע הכניסה לארה\"ב, תורשה/י לשהות במדינה עד {validity}.",
      valid_since_entry_vietnam: "מרגע הכניסה לווייטנאם, תורשה/י לשהות במדינה עד {validity}.",
      valid_since_specified_eta: "ה-{visaDocName} מעניק שהייה של עד {validity}, כאשר טווח התאריכים המדויק נקבע על ידי הרשויות.",
      valid_since_specified_evisa: "הויזה מעניקת שהייה של עד {validity}, כאשר טווח התאריכים המדויק נקבע על ידי הרשויות.",
      valid_since_specified_note_bahrain: "שימו לב לתאריך התפוגה של הויזה המופיע בקובץ תחת הסעיף: 'תקף/תקפה מ/עד'. עליך/עלייך לעזוב/לעזוב את בחריין עד לתאריך זה.",
      valid_since_specified_note_cambodia: "שימו לב לתאריך התפוגה של הויזה המופיע בקובץ תחת הסעיף: 'תקף/תקפה מ/עד'. עליך/עלייך לעזוב/לעזוב את קמבודיה עד לתאריך זה.",
      valid_since_specified_note_canada: "שימו לב לתאריך התפוגה של ה-eTA המופיע בקובץ תחת הסעיף: 'תקף/תקפה מ/עד'. עליך/עלייך לעזוב/לעזוב את קנדה עד לתאריך זה.",
      valid_since_specified_note_india: "שימו לב לתאריך התפוגה של הויזה המופיע בקובץ תחת הסעיף: 'תקף/תקפה מ/עד'. עליך/עלייך לעזוב/לעזוב את הודו עד לתאריך זה.",
      valid_since_specified_note_indonesia: "שימו לב לתאריך התפוגה של הויזה המופיע בקובץ תחת הסעיף: 'תקף/תקפה מ/עד'. עליך/עלייך לעזוב/לעזוב את אינדונזיה עד לתאריך זה.",
      valid_since_specified_note_israel: "שימו לב לתאריך התפוגה של ה-ETA-IL המופיע בקובץ תחת הסעיף: 'תקף/תקפה מ/עד'. עליך/עלייך לעזוב/לעזוב את ישראל עד לתאריך זה.",
      valid_since_specified_note_korea: "שימו לב לתאריך התפוגה של ה-K-ETA המופיע בקובץ תחת הסעיף: 'תקף/תקפה מ/עד'. עליך/עלייך לעזוב/לעזוב את דרום קוריאה עד לתאריך זה.",
      valid_since_specified_note_morocco: "שימו לב לתאריך התפוגה של הויזה המופיע בקובץ תחת הסעיף: 'תקף/תקפה מ/עד'. עליך/עלייך לעזוב/לעזוב את מרוקו עד לתאריך זה.",
      valid_since_specified_note_new_zealand: "שימו לב לתאריך התפוגה של ה-NZeTA המופיע בקובץ תחת הסעיף: 'תקף/תקפה מ/עד'. עליך/עלייך לעזוב/לעזוב את ניו זילנד עד לתאריך זה.",
      valid_since_specified_note_saudi_arabia: "שימו לב לתאריך התפוגה של הויזה המופיע בקובץ תחת הסעיף: 'תקף/תקפה מ/עד'. עליך/עלייך לעזוב/לעזוב את ערב הסעודית עד לתאריך זה.",
      valid_since_specified_note_sri_lanka: "שימו לב לתאריך התפוגה של הויזה המופיע בקובץ תחת הסעיף: 'תקף/תקפה מ/עד'. עליך/עלייך לעזוב/לעזוב את סרי לנקה עד לתאריך זה.",
      valid_since_specified_note_thailand: "You must leave Thailand by this expiration date.",
      valid_since_specified_note_togo: "שימו לב לתאריך התפוגה של הויזה המופיע בקובץ תחת הסעיף: 'תקף/תקפה מ/עד'. עליך/עלייך לעזוב/לעזוב את טוגו עד לתאריך זה.",
      valid_since_specified_note_uk: "שימו לב לתאריך התפוגה של ה-UK-ETA המופיע בקובץ תחת הסעיף: 'תקף/תקפה מ/עד'. עליך/עלייך לעזוב/לעזוב את בריטניה עד לתאריך זה.",
      valid_since_specified_note_usa: "שימו לב לתאריך התפוגה של ה-ESTA המופיע בקובץ תחת הסעיף: 'תקף/תקפה מ/עד'. עליך/עלייך לעזוב/לעזוב את ארצות הברית עד לתאריך זה.",
      valid_since_specified_note_vietnam: "שימו לב לתאריך התפוגה של הויזה המופיע בקובץ תחת הסעיף: 'תקף/תקפה מ/עד'. עליך/עלייך לעזוב/לעזוב את ויאטנם עד לתאריך זה.",
      view_file_instruction: "כדי להציג את קובץ ה-{visaDocName}, לחץ/י על הכפתור הכחול בתחתית ההודעה"
    },
    form_abandonment: {
      action_text: "כדי להקל עליך, <strong>לחץ/י על הכפתור למטה כדי לסיים את הבקשה שלך ולהבטיח את ה-{visaDocName} שלך</strong> 🔽",
      action_text_eta: "To finalize your application and secure your {visaDocName}, <strong>simply click the button below</strong> 🔽",
      action_text_evisa: "To finalize your application and secure your eVisa, <strong>simply click the button below</strong> 🔽",
      almost_ready_bahrain: "המסע שלך לבחריין כמעט מוכן!",
      almost_ready_cambodia: "המסע שלך לקמבודיה כמעט מוכן!",
      almost_ready_canada: "המסע שלך לקנדה כמעט מוכן!",
      almost_ready_india: "המסע שלך להודו כמעט מוכן!",
      almost_ready_indonesia: "המסע שלך לאינדונזיה כמעט מוכן!",
      almost_ready_israel: "המסע שלך לישראל כמעט מוכן!",
      almost_ready_korea: "המסע שלך לקוריאה כמעט מוכן!",
      almost_ready_morocco: "המסע שלך למרוקו כמעט מוכן!",
      almost_ready_new_zealand: "המסע שלך לניו זילנד כמעט מוכן!",
      almost_ready_saudi_arabia: "המסע שלך לערב הסעודית כמעט מוכן!",
      almost_ready_sri_lanka: "המסע שלך לסרי לנקה כמעט מוכן!",
      almost_ready_thailand: "Your journey to Thailand is almost set!",
      almost_ready_togo: "המסע שלך לטוגו כמעט מוכן!",
      almost_ready_uk: "המסע שלך לבריטניה כמעט מוכן!",
      almost_ready_usa: "המסע שלך לארה\"ב כמעט מוכן!",
      almost_ready_vietnam: "המסע שלך לוייטנאם כמעט מוכן!",
      button: "סיים/י את הבקשה שלך",
      closing: "נסיעות בטוחות,<br>צוות ויזאנט 👋",
      greeting: "היי {name},",
      main_text_bahrain: "You're just one step away from completing your journey to Bahrain.",
      main_text_cambodia: "You're just one step away from completing your journey to Cambodia.",
      main_text_canada: "You're just one step away from completing your journey to Canada.",
      main_text_eta: "שמנו לב שהיית/היית קרוב/ה לסיום מילוי בקשת ה-{visaDocName} שלך באתר ויזאנט.",
      main_text_evisa: "שמנו לב שהיית/היית קרוב/ה לסיום מילוי בקשת הויזה שלך באתר ויזאנט.",
      main_text_india: "You're just one step away from completing your journey to India.",
      main_text_indonesia: "You're just one step away from completing your journey to Indonesia.",
      main_text_israel: "You're just one step away from completing your journey to Israel.",
      main_text_korea: "You're just one step away from completing your journey to Korea.",
      main_text_morocco: "You're just one step away from completing your journey to Morocco.",
      main_text_new_zealand: "You're just one step away from completing your journey to New Zealand.",
      main_text_saudi_arabia: "You're just one step away from completing your journey to Saudi Arabia.",
      main_text_sri_lanka: "You're just one step away from completing your journey to Sri Lanka.",
      main_text_thailand: "You're just one step away from completing your journey to Thailand.",
      main_text_togo: "You're just one step away from completing your journey to Togo.",
      main_text_uk: "You're just one step away from completing your journey to the UK.",
      main_text_usa: "You're just one step away from completing your journey to the US.",
      main_text_vietnam: "You're just one step away from completing your journey to Vietnam.",
      support: "אם יש לך שאלות או שאת/ה צריכ/ה עזרה, צוות התמיכה שלנו כאן כדי לעזור דרך מייל (פשוט ענה/י להודעה זו), <a href='{whatsapp}'>וואטסאפ</a> או <a href='tel:{phone}'>טלפון</a>."
    },
    onetime_coupon: {
      closing: "תודה שאת/ה לקוח/ה מוערך/ת של ויזאנט. אם יש לך שאלות, הצוות שלנו כאן 24/7 כדי לסייע לך.",
      coupon_label: "קופון",
      feedback_text: "המשוב שלך לא רק עוזר לנו להשתפר אלא גם עוזר לאחרים לגלות את השירות שלנו. כאות תודה, אנו מציעים לך קופון חד פעמי לרכישה הבאה שלך:",
      greeting: "היי {name},<br>ברכות על קבלת ה-{visaDocName} שלך! אנחנו שמחים שעזרנו לך עם תוכניות הנסיעה שלך ונשמח לשמוע על החוויה שלך.",
      greeting_eta: "👋 Hi {name},<br>We hope your {visaDocName} experience was smooth and effortless! We’re thrilled to have helped you with your travel plans and would love to hear about your experience.",
      greeting_evisa: "👋 Hi {name},<br>We hope your eVisa experience was smooth and effortless! We’re thrilled to have helped you with your travel plans and would love to hear about your experience.",
      review_label: "השאר/י ביקורת",
      support: "Thank you for being a valued Visanet customer. If you have any questions, our team is here 24/7 to assist you. Reply directly to this email or reach out via Phone/WhatsApp at {phone}.",
      title: "תודה שבחרת בוויזאנט 💙"
    },
    order_received: {
      applicant_info: "Applicant Information",
      application_received_bahrain: "טופס בקשת הוויזה שלך לבחריין התקבל בהצלחה.",
      application_received_cambodia: "טופס בקשת הוויזה שלך לקמבודיה התקבל בהצלחה.",
      application_received_canada: "טופס בקשת ה-eTA שלך לקנדה התקבל בהצלחה.",
      application_received_india: "טופס בקשת הוויזה שלך להודו התקבל בהצלחה.",
      application_received_indonesia: "טופס בקשת הוויזה שלך לאינדונזיה התקבל בהצלחה.",
      application_received_israel: "טופס בקשת ה-ETA-IL שלך לישראל התקבל בהצלחה.",
      application_received_korea: "טופס בקשת ה-K-ETA שלך לקוריאה התקבל בהצלחה.",
      application_received_morocco: "טופס בקשת הוויזה שלך למרוקו התקבל בהצלחה.",
      application_received_new_zealand: "טופס בקשת ה-NZeTA שלך לניו זילנד התקבל בהצלחה.",
      application_received_saudi_arabia: "טופס בקשת הוויזה שלך לערב הסעודית התקבל בהצלחה.",
      application_received_sri_lanka: "טופס בקשת הוויזה שלך לסרי לנקה התקבל בהצלחה.",
      application_received_thailand: "Your Thailand eVisa application form has been successfully received.",
      application_received_togo: "טופס בקשת הוויזה שלך לטוגו התקבל בהצלחה.",
      application_received_uk: "טופס בקשת ה-UK-ETA שלך לבריטניה התקבל בהצלחה.",
      application_received_usa: "טופס בקשת ה-ESTA שלך לארה\"ב התקבל בהצלחה.",
      application_received_vietnam: "טופס בקשת הוויזה שלך לווייטנאם התקבל בהצלחה.",
      attention: "שימו לב",
      available_via: "אנחנו זמינים דרך מייל (ענה/י ישירות להודעה זו), <a href='{whatsapp}'>וואטסאפ</a>, או <a href='tel:{phone}'>טלפון</a>.",
      closing: "Best,<br>The Visanet Team 🙏",
      delay_alert_bahrain: "תאריך הכניסה המתוכנן שלך רחוק יותר מ-{daysToUse} ימים מעכשיו. כדי להבטיח שהוויזה שלך תהיה תקפה לטיול שלך, נגיש את בקשת הוויזה שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג הוויזה שבחרת דורש כניסה תוך {daysToUse} ימים מהנפקתו.",
      delay_alert_cambodia: "תאריך הכניסה המתוכנן שלך רחוק יותר מ-{daysToUse} ימים מעכשיו. כדי להבטיח שהוויזה שלך תהיה תקפה לטיול שלך, נגיש את בקשת הוויזה שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג הוויזה שבחרת דורש כניסה תוך {daysToUse} ימים מהנפקתו.",
      delay_alert_canada: "תאריך הכניסה המתוכנן שלך רחוק יותר מ-{daysToUse} ימים מעכשיו. כדי להבטיח שה-eTA שלך יהיה תקף לטיול שלך, נגיש את בקשת ה-eTA שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג ה-eTA שבחרת דורש כניסה תוך {daysToUse} ימים מהנפקתו.",
      delay_alert_india: "תאריך הכניסה המתוכנן שלך רחוק יותר מ-{daysToUse} ימים מעכשיו. כדי להבטיח שהוויזה שלך תהיה תקפה לטיול שלך, נגיש את בקשת הוויזה שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג הוויזה שבחרת דורש כניסה תוך {daysToUse} ימים מהנפקתו.",
      delay_alert_indonesia: "תאריך הכניסה המתוכנן שלך רחוק יותר מ-{daysToUse} ימים מעכשיו. כדי להבטיח שהוויזה שלך תהיה תקפה לטיול שלך, נגיש את בקשת הוויזה שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג הוויזה שבחרת דורש כניסה תוך {daysToUse} ימים מהנפקתו.",
      delay_alert_israel: "תאריך הכניסה המתוכנן שלך רחוק יותר מ-{daysToUse} ימים מעכשיו. כדי להבטיח שה-ETA-IL שלך יהיה תקף לטיול שלך, נגיש את בקשת ה-ETA-IL שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג ה-ETA-IL שבחרת דורש כניסה תוך {daysToUse} ימים מהנפקתו.",
      delay_alert_korea: "תאריך הכניסה המתוכנן שלך רחוק יותר מ-{daysToUse} ימים מעכשיו. כדי להבטיח שה-K-ETA שלך יהיה תקף לטיול שלך, נגיש את בקשת ה-K-ETA שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג ה-K-ETA שבחרת דורש כניסה תוך {daysToUse} ימים מהנפקתו.",
      delay_alert_morocco: "תאריך הכניסה המתוכנן שלך רחוק יותר מ-{daysToUse} ימים מעכשיו. כדי להבטיח שהוויזה שלך תהיה תקפה לטיול שלך, נגיש את בקשת הוויזה שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג הוויזה שבחרת דורש כניסה תוך {daysToUse} ימים מהנפקתו.",
      delay_alert_new_zealand: "תאריך הכניסה המתוכנן שלך רחוק יותר מ-{daysToUse} ימים מעכשיו. כדי להבטיח שה-NZeTA שלך יהיה תקף לטיול שלך, נגיש את בקשת ה-NZeTA שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג ה-NZeTA שבחרת דורש כניסה תוך {daysToUse} ימים מהנפקתו.",
      delay_alert_saudi_arabia: "תאריך הכניסה המתוכנן שלך רחוק יותר מ-{daysToUse} ימים מעכשיו. כדי להבטיח שהוויזה שלך תהיה תקפה לטיול שלך, נגיש את בקשת הוויזה שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג הוויזה שבחרת דורש כניסה תוך {daysToUse} ימים מהנפקתו.",
      delay_alert_sri_lanka: "תאריך הכניסה המתוכנן שלך רחוק יותר מ-{daysToUse} ימים מעכשיו. כדי להבטיח שהוויזה שלך תהיה תקפה לטיול שלך, נגיש את בקשת הוויזה שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג הוויזה שבחרת דורש כניסה תוך {daysToUse} ימים מהנפקתו.",
      delay_alert_thailand: "Your planned date of entry is more than {daysToUse} days from now. To ensure your eVisa is valid for your trip, we will submit your eVisa application 3 weeks before your planned travel date. This is because the visa type you have chosen requires entry within {daysToUse} days of issuance.",
      delay_alert_togo: "תאריך הכניסה המתוכנן שלך רחוק יותר מ-{daysToUse} ימים מעכשיו. כדי להבטיח שהוויזה שלך תהיה תקפה לטיול שלך, נגיש את בקשת הוויזה שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג הוויזה שבחרת דורש כניסה תוך {daysToUse} ימים מהנפקתו.",
      delay_alert_uk: "תאריך הכניסה המתוכנן שלך רחוק יותר מ-{daysToUse} ימים מעכשיו. כדי להבטיח שה-UK-ETA שלך יהיה תקף לטיול שלך, נגיש את בקשת ה-UK-ETA שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג ה-UK-ETA שבחרת דורש כניסה תוך {daysToUse} ימים מהנפקתו.",
      delay_alert_usa: "תאריך הכניסה המתוכנן שלך רחוק יותר מ-{daysToUse} ימים מעכשיו. כדי להבטיח שה-ESTA שלך יהיה תקף לטיול שלך, נגיש את בקשת ה-ESTA שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג ה-ESTA שבחרת דורש כניסה תוך {daysToUse} ימים מהנפקתו.",
      delay_alert_vietnam: "תאריך הכניסה המתוכנן שלך רחוק יותר מ-{daysToUse} ימים מעכשיו. כדי להבטיח שהוויזה שלך תהיה תקפה לטיול שלך, נגיש את בקשת הוויזה שלך 3 שבועות לפני תאריך הנסיעה המתוכנן שלך. הסיבה לכך היא שסוג הוויזה שבחרת דורש כניסה תוך {daysToUse} ימים מהנפקתו.",
      ensure_details_accurate: "אנא ודא/י שכל הפרטים האישיים שלך מדויקים ותואמים למידע בדרכון שלך.",
      estimated_entry_date: "תאריך כניסה משוער:",
      expect_receive_bahrain: "את/ה יכול/ה לצפות לקבל את הוויזה שלך בכתובת המייל הזו.",
      expect_receive_cambodia: "את/ה יכול/ה לצפות לקבל את הוויזה שלך בכתובת המייל הזו.",
      expect_receive_canada: "את/ה יכול/ה לצפות לקבל את ה-eTA שלך בכתובת המייל הזו.",
      expect_receive_india: "את/ה יכול/ה לצפות לקבל את הוויזה שלך בכתובת המייל הזו.",
      expect_receive_indonesia: "את/ה יכול/ה לצפות לקבל את הוויזה שלך בכתובת המייל הזו.",
      expect_receive_israel: "את/ה יכול/ה לצפות לקבל את ה-ETA-IL שלך בכתובת המייל הזו.",
      expect_receive_korea: "את/ה יכול/ה לצפות לקבל את ה-K-ETA שלך בכתובת המייל הזו.",
      expect_receive_morocco: "את/ה יכול/ה לצפות לקבל את הוויזה שלך בכתובת המייל הזו.",
      expect_receive_new_zealand: "את/ה יכול/ה לצפות לקבל את ה-NZeTA שלך בכתובת המייל הזו.",
      expect_receive_saudi_arabia: "את/ה יכול/ה לצפות לקבל את הוויזה שלך בכתובת המייל הזו.",
      expect_receive_sri_lanka: "את/ה יכול/ה לצפות לקבל את הוויזה שלך בכתובת המייל הזו.",
      expect_receive_thailand: "You can expect to receive your eVisa for Thailand at this email address",
      expect_receive_togo: "את/ה יכול/ה לצפות לקבל את הוויזה שלך בכתובת המייל הזו.",
      expect_receive_uk: "את/ה יכול/ה לצפות לקבל את ה-UK-ETA שלך בכתובת המייל הזו.",
      expect_receive_usa: "את/ה יכול/ה לצפות לקבל את ה-ESTA שלך בכתובת המייל הזו.",
      expect_receive_vietnam: "את/ה יכול/ה לצפות לקבל את הוויזה שלך בכתובת המייל הזו.",
      greeting: "שלום {name},",
      here_to_help: "We're here to help you enjoy smooth travels!",
      no_further_action: "אם כל המידע נכון, לא נדרשת פעולה נוספת מצדך. בקשת הוויזה שלך נמצאת כעת בידיים שלנו, ואנו נטפל בהכל מכאן.",
      order_details: "פרטי הזמנה #{id}:",
      passport_expiration: "Passport Expiration",
      passport_issue: "Passport Issue Date",
      payment_receipt: "חשבונית עבור ההזמנה שלכם תישלח בהודעת דוא\"ל נפרדת.",
      photos_needed: "🚨 כדי להמשיך בעיבוד הבקשה שלך, <u>אנא שלח/י לנו את התמונות הבאות עבור כל מועמד:</u>",
      processing_bahrain: "הטופס שלך נמצא כעת בעיבוד ויוגש מיד כבקשה רשמית למחלקת ההגירה של בחריין.",
      processing_cambodia: "הטופס שלך נמצא כעת בעיבוד ויוגש מיד כבקשה רשמית למחלקת ההגירה של קמבודיה.",
      processing_canada: "הטופס שלך נמצא כעת בעיבוד ויוגש מיד כבקשה רשמית למחלקת ההגירה של קנדה.",
      processing_india: "הטופס שלך נמצא כעת בעיבוד ויוגש מיד כבקשה רשמית למחלקת ההגירה של הודו.",
      processing_indonesia: "הטופס שלך נמצא כעת בעיבוד ויוגש מיד כבקשה רשמית למחלקת ההגירה של אינדונזיה.",
      processing_israel: "הטופס שלך נמצא כעת בעיבוד ויוגש מיד כבקשה רשמית למחלקת ההגירה של ישראל.",
      processing_korea: "הטופס שלך נמצא כעת בעיבוד ויוגש מיד כבקשה רשמית למחלקת ההגירה של קוריאה.",
      processing_morocco: "הטופס שלך נמצא כעת בעיבוד ויוגש מיד כבקשה רשמית למחלקת ההגירה של מרוקו.",
      processing_new_zealand: "הטופס שלך נמצא כעת בעיבוד ויוגש מיד כבקשה רשמית למחלקת ההגירה של ניו זילנד.",
      processing_saudi_arabia: "הטופס שלך נמצא כעת בעיבוד ויוגש מיד כבקשה רשמית למחלקת ההגירה של ערב הסעודית.",
      processing_sri_lanka: "הטופס שלך נמצא כעת בעיבוד ויוגש מיד כבקשה רשמית למחלקת ההגירה של סרי לנקה.",
      processing_thailand: "Your form is currently being processed and will be promptly submitted as an official request to the Immigration Department of Thailand.",
      processing_time_label: "Processing Time:",
      processing_time_text: "Up to {days} Business Days",
      processing_time_text_1: "Up to the next business day.",
      processing_time_text_1_2_days: "Up to 1-2 Business Days",
      processing_time_text_3_days: "Up to 3 Business Days",
      processing_time_text_5_days: "Up to 5 Business Days",
      processing_time_text_few_hours: "Up to a Few Hours",
      processing_time_text_next_day: "Up to the Next Business Day",
      processing_togo: "הטופס שלך נמצא כעת בעיבוד ויוגש מיד כבקשה רשמית למחלקת ההגירה של טוגו.",
      processing_uk: "הטופס שלך נמצא כעת בעיבוד ויוגש מיד כבקשה רשמית למחלקת ההגירה של בריטניה.",
      processing_usa: "הטופס שלך נמצא כעת בעיבוד ויוגש מיד כבקשה רשמית למחלקת ההגירה של ארה\"ב.",
      processing_vietnam: "הטופס שלך נמצא כעת בעיבוד ויוגש מיד כבקשה רשמית למחלקת ההגירה של וייטנאם.",
      product: "סוג ויזה:",
      quantity: "כמות:",
      send_photos_via: "את/ה יכול/ה לשלוח את התמונות על ידי מענה למייל זה או דרך <a href='{whatsapp}'>וואטסאפ</a>.",
      thank_you_choosing: "תודה שבחרת בוויזאנט",
      thank_you_order: "תודה על ההזמנה שלך!",
      total_price: "מחיר כולל:",
      urgent_order: "הזמנה דחופה:",
      within_business_days: "תוך {days} ימי עסקים.",
      within_business_days_1: "עד יום העסקים הבא.",
      within_business_days_1_2_days: "within 1-2 business days.",
      within_business_days_3_days: "within 3 business days.",
      within_business_days_5_days: "within 5 business days.",
      within_business_days_few_hours: "within a few hours.",
      within_business_days_next_day: "within the next business day."
    },
    order_status: {
      closing: "בברכה,<br>צוות ויזאנט",
      current_status: "ℹ סטטוס נוכחי:",
      greeting: "שלום {name},<br>אנחנו כאן כדי לעדכן אותך לגבי סטטוס ההזמנה שלך! להלן העדכונים האחרונים. היה/י סמוך/ה ובטוח/ה שאנו מחויבים להפוך את תהליך הוויזה שלך לחלק ככל האפשר.",
      help_section: "<strong>❓ צריכ/ה עזרה או שיש לך שאלות?</strong><br>את/ה מוזמנ/ת <a href='https://visanet.co.il/contact'>ליצור איתנו קשר</a> בכל עת.",
      status: {
        active: {
          approval_time: "Approval typically takes {days} business days.",
          approval_time_1_2_days: "Approval typically takes 1-2 business days.",
          approval_time_3_days: "Approval typically takes 3 business days.",
          approval_time_5_days: "Approval typically takes 5 business days.",
          approval_time_few_hours: "Approval typically takes a few hours.",
          approval_time_next_day: "Approval typically takes up to 1 business day.",
          description: "קיבלנו בהצלחה את הבקשה שלך. נא להמתין בסבלנות - תהליך האישור בעיצומו ובדרך כלל לוקח {days} ימים.",
          description_1_2_days: "We’ve successfully received your application. Your application is currently under review. Approval typically takes 1-2 business days.",
          description_3_days: "We’ve successfully received your application. Your application is currently under review. Approval typically takes 3 business days.",
          description_5_days: "We’ve successfully received your application. Your application is currently under review. Approval typically takes 5 business days.",
          description_few_hours: "We’ve successfully received your application. Your application is currently under review. Approval typically takes a few hours.",
          description_next_day: "We’ve successfully received your application. Your application is currently under review. Approval typically takes up to 1 business day.",
          title: "פעיל"
        },
        canceled: {
          description: "ההזמנה שלך בוטלה.",
          title: "בוטל"
        },
        completed: {
          description: "מזל טוב! הבקשה שלך אושרה, ושלחנו לך את כל הפרטים הרלוונטיים במייל.",
          title: "הושלם"
        },
        issue: {
          description: "נראה שיש בעיה בבקשה שלך. אנא בדוק/בדקי את תיבת הדואר הנכנס שלך לקבלת פרטים.",
          title: "בעיה"
        }
      },
      thank_you: "תודה שבחרת בוויזאנט לצרכי הנסיעה שלך."
    },
    resume_url: {
      action_text: "כדי להקל עליך, <strong>פשוט לחץ/י על הכפתור למטה כדי להמשיך למלא את הטופס שלך ולהבטיח את תוכניות הנסיעה שלך</strong> 🔽",
      almost_ready_bahrain: "נראה שאת/ה במרחק של כמה צעדים בלבד מסיום מילוי טופס הוויזה שלך באתר ויזאנט. הטיול הקרוב שלך לבחריין כמעט מוכן לסיום!",
      almost_ready_cambodia: "נראה שאת/ה במרחק של כמה צעדים בלבד מסיום מילוי טופס הוויזה שלך באתר ויזאנט. הטיול הקרוב שלך לקמבודיה כמעט מוכן לסיום!",
      almost_ready_canada: "נראה שאת/ה במרחק של כמה צעדים בלבד מסיום מילוי טופס ה-eTA שלך באתר ויזאנט. הטיול הקרוב שלך לקנדה כמעט מוכן לסיום!",
      almost_ready_india: "נראה שאת/ה במרחק של כמה צעדים בלבד מסיום מילוי טופס הוויזה שלך באתר ויזאנט. הטיול הקרוב שלך להודו כמעט מוכן לסיום!",
      almost_ready_indonesia: "נראה שאת/ה במרחק של כמה צעדים בלבד מסיום מילוי טופס הוויזה שלך באתר ויזאנט. הטיול הקרוב שלך לאינדונזיה כמעט מוכן לסיום!",
      almost_ready_israel: "נראה שאת/ה במרחק של כמה צעדים בלבד מסיום מילוי טופס ה-ETA-IL שלך באתר ויזאנט. הטיול הקרוב שלך לישראל כמעט מוכן לסיום!",
      almost_ready_korea: "נראה שאת/ה במרחק של כמה צעדים בלבד מסיום מילוי טופס ה-K-ETA שלך באתר ויזאנט. הטיול הקרוב שלך לקוריאה כמעט מוכן לסיום!",
      almost_ready_morocco: "נראה שאת/ה במרחק של כמה צעדים בלבד מסיום מילוי טופס הוויזה שלך באתר ויזאנט. הטיול הקרוב שלך למרוקו כמעט מוכן לסיום!",
      almost_ready_new_zealand: "נראה שאת/ה במרחק של כמה צעדים בלבד מסיום מילוי טופס ה-NZeTA שלך באתר ויזאנט. הטיול הקרוב שלך לניו זילנד כמעט מוכן לסיום!",
      almost_ready_saudi_arabia: "נראה שאת/ה במרחק של כמה צעדים בלבד מסיום מילוי טופס הוויזה שלך באתר ויזאנט. הטיול הקרוב שלך לערב הסעודית כמעט מוכן לסיום!",
      almost_ready_sri_lanka: "נראה שאת/ה במרחק של כמה צעדים בלבד מסיום מילוי טופס הוויזה שלך באתר ויזאנט. הטיול הקרוב שלך לסרי לנקה כמעט מוכן לסיום!",
      almost_ready_thailand: "Your upcoming trip to Thailand is almost ready to be finalized!",
      almost_ready_togo: "נראה שאת/ה במרחק של כמה צעדים בלבד מסיום מילוי טופס הוויזה שלך באתר ויזאנט. הטיול הקרוב שלך לטוגו כמעט מוכן לסיום!",
      almost_ready_uk: "נראה שאת/ה במרחק של כמה צעדים בלבד מסיום מילוי טופס ה-UK-ETA שלך באתר ויזאנט. הטיול הקרוב שלך לבריטניה כמעט מוכן לסיום!",
      almost_ready_usa: "נראה שאת/ה במרחק של כמה צעדים בלבד מסיום מילוי טופס ה-ESTA שלך באתר ויזאנט. הטיול הקרוב שלך לארה\"ב כמעט מוכן לסיום!",
      almost_ready_vietnam: "נראה שאת/ה במרחק של כמה צעדים בלבד מסיום מילוי טופס הוויזה שלך באתר ויזאנט. הטיול הקרוב שלך לווייטנאם כמעט מוכן לסיום!",
      button: "המשך/י את הטופס שלך",
      closing: "מאחלים לך נסיעות בטוחות ומהנות,<br>צוות ויזאנט 👋",
      greeting: "היי {name},",
      main_text_eta: "נראה שאת/ה במרחק של כמה צעדים בלבד מסיום מילוי טופס ה-{visaDocName} שלך באתר ויזאנט.",
      main_text_evisa: "נראה שאת/ה במרחק של כמה צעדים בלבד מסיום מילוי טופס הוויזה שלך באתר ויזאנט.",
      support: "אם אתה/את צריכ/ה עזרה או שיש לך שאלות, צוות התמיכה שלנו מוכן לסייע לך.<br>את/ה מוזמנ/ת לענות למייל הזה, או ליצור איתנו קשר דרך <a href='{whatsapp}'>וואטסאפ</a> או <a href='tel:{phone}'>טלפון</a>."
    },
    wrapper: {
      confidentiality_notice: "🔐 Confidentiality Notice: This message contains information intended only for the recipient. If received in error, please notify us immediately and delete this email.",
      legal_notice: "ℹ️ קיבלת מייל זה מכיוון שהגשת בקשה לויזה דרך אתר {domain}.<br>🔒 <strong>הודעת סודיות</strong>: מייל זה וכל קובץ מצורף מיועדים אך ורק לנמען/ים המיועד/ים ועשויים להכיל מידע סודי. כל עיון, שימוש, חשיפה או הפצה לא מורשים של תקשורת זו אסורים בהחלט. אם אינך הנמען המיועד, אנא הודע/י לשולח/ת מיידית על ידי מענה למייל זה, מחק/י הודעה זו והשמד/י את כל העותקים שלה.",
      legal_notice_abandonment: "ℹ️ You received this email because you began filling out a visa application form at {domain}.",
      legal_notice_approved_eta: "ℹ️ You received this email because you applied for an {docName} through {domain}.",
      legal_notice_approved_evisa: "ℹ️ You received this email because you applied for an eVisa through {domain}.",
      legal_notice_coupon: "ℹ️ You received this email because you recently completed a visa application at {domain}.",
      legal_notice_received: "ℹ️ You received this email because you applied for a visa through {domain}.",
      legal_notice_resume: "ℹ️ You received this email because you saved your visa form at {domain}.",
      legal_notice_status: "ℹ️ You received this email because you requested a status update about your visa application at {domain}.",
      privacy_policy: "Privacy Policy"
    }
  },
  emergency_contact: "קשר חירום",
  emergency_contact_address: "כתובת איש קשר לשעת חירום",
  emergency_contact_full_name: "שמו המלא של איש הקשר לשעת חירום",
  emergency_contact_phone: "מספר הטלפון של איש הקשר לשעת חירום",
  emergency_contact_relation: "מערכת יחסים",
  employee: "עובד",
  empty_if_unknown: "אם לא ידוע, השאר ריק",
  eng_as_in_passport: "באנגלית, בדיוק כמו בדרכון שלך",
  ensure_correct_email_bahrain: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_cambodia: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_canada: "ה- eTA יישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_india: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_indonesia: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_israel: "ה- ETA-IL יישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_korea: "ה- K-ETA יישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_morocco: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_new_zealand: "ה- NZeTA יישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_saudi_arabia: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_sri_lanka: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_thailand: "The eVisa will be sent to this email address - please make sure there are no mistakes.",
  ensure_correct_email_togo: "The eVisa will be sent to this email address - please make sure there are no mistakes.",
  ensure_correct_email_uk: "ה- eTA יישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_usa: "ה- ESTA יישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  ensure_correct_email_vietnam: "הויזה האלקטרונית תישלח לכתובת דוא\"ל זו - אנא ודא שאין טעויות.",
  estimate_date: "אתה יכול להעריך שנה ותאריך משוערים",
  estimate_entry_date_5_years_valid: "No need to be exact. The visa is valid for 5 years from the moment of issue.",
  estimate_entry_date_year_valid: "No need to be exact. The visa is valid for 1 year from the moment of issue.",
  estimate_entry_in_2_years: "אין צורך להיות מדויק. אתה תהיה רשאי להיכנס למדינה עד שנתיים מרגע ההנפקה",
  estimate_entry_in_half_year: "אין צורך להיות מדויק. אתה תהיה רשאי להיכנס למדינה עד שישה חודשים מרגע ההנפקה",
  estimate_one_min: "אתה יכול להעריך. בחירה אחת מספיקה.",
  estimate_port_entry: "אתה יכול להעריך. הכניסה מותרת דרך כל אחת מהנמלים הללו.",
  estimate_visa_5_years: "אין צורך להיות מדויק. הויזה תקפה למשך 5 שנים מרגע ההנפקה.",
  eta: "ETA | תעודות",
  eta_long: "אישור נסיעה אלקטרוני | אישורי נסיעה אלקטרוניים",
  ever_convicted: "האם הורשעתם פעם בפשע?",
  ever_refused_entry: "האם בקשתך להיכנס למדינה כלשהי נדחתה?",
  ever_visited_bahrain: "Have you ever visited Bahrain before?",
  ever_visited_cambodia: "Have you ever visited Cambodia before?",
  ever_visited_canada: "האם ביקרתם פעם בקנדה בעבר?",
  ever_visited_india: "האם ביקרת בעבר בהודו?",
  ever_visited_indonesia: "Have you ever visited Indonesia before?",
  ever_visited_israel: "האם ביקרתם בעבר בישראל?",
  ever_visited_korea: "האם ביקרת בעבר בדרום קוריאה?",
  ever_visited_morocco: "Have you ever visited Morocco before?",
  ever_visited_new_zealand: "Have you ever visited New Zealand before?",
  ever_visited_saudi_arabia: "Have you ever visited Saudi Arabia before?",
  ever_visited_sri_lanka: "Have you ever visited Sri Lanka before?",
  ever_visited_thailand: "Have you ever visited Thailand before?",
  ever_visited_togo: "Have you ever visited Togo before?",
  ever_visited_uk: "Have you ever visited the UK before?",
  ever_visited_usa: "Have you ever visited the USA before?",
  ever_visited_vietnam: "Have you ever visited Vietnam before?",
  evisa: "ויסה אלקטרונית | eVisas",
  evisa_long: "ויזה אלקטרונית | אשרות אלקטרוניות",
  evisas: "אשרות אלקטרוניות",
  exactly_as_in_passport: "הפרטים שאתה מזן חייבים להיות <strong> זהים לדרכון </strong>",
  expected_entry_date: "תאריך כניסה מתוכנן",
  expected_entry_port: "נמל כניסה מתוכנן",
  expected_exit_date: "תאריך יציאה מתוכנן",
  expected_exit_port: "נמל יציאה מתוכנן",
  expected_stay_address_bahrain: "Planned residence address in Bahrain",
  expected_stay_address_cambodia: "כתובת מגורים מתוכננת בקמבודיה",
  expected_stay_address_canada: "Planned residence address in Canada",
  expected_stay_address_india: "Planned residence address in India",
  expected_stay_address_indonesia: "כתובת מגורים מתוכננת באינדונזיה",
  expected_stay_address_israel: "Planned residence address in Israel",
  expected_stay_address_korea: "כתובת מגורים מתוכננת בקוריאה",
  expected_stay_address_morocco: "Planned residence address in Morocco",
  expected_stay_address_new_zealand: "Planned residence address in New Zealand",
  expected_stay_address_saudi_arabia: "Planned residence address in Saudi Arabia",
  expected_stay_address_sri_lanka: "כתובת מגורים מתוכננת בסרי לנקה",
  expected_stay_address_thailand: "Planned residence address in Thailand",
  expected_stay_address_togo: "Planned residence address in Togo",
  expected_stay_address_uk: "Planned residence address in the UK",
  expected_stay_address_usa: "Planned residence address in the USA",
  expected_stay_address_vietnam: "כתובת מגורים מתוכננת בווייטנאם",
  explore_visa_options: "חקור את אפשרויות ה- <span class='text-primary'> eVisa שלנו </span>",
  extra_nationality: {
    birth: "מלידה",
    from: "מתי קיבלת את הלאום הזה?",
    has: "לאום נוסף",
    how: "כיצד נרכשה הלאום?",
    naturalization: "על ידי התאזרחות",
    none: "אין לי אזרחות אחרת",
    parents: "דרך ההורים",
    past: "היה לי אזרחות אחרת בעבר",
    present: "כרגע יש לי אזרחות אחרת",
    until: "מתי פג האזרחות?"
  },
  failure_page: {
    chat: "חלון הצ'אט אמור להיפתח באופן אוטומטי. אתם מוזמנים לשלוח לנו מילה שם ואנו ננסה לענות במהירות.",
    contact: "אנא {link} ואנו נעזור לך לבצע תשלום מאובטח, ולהתקדם עם הנפקת הויזה האלקטרונית שלך.",
    failed: "התשלום נכשל",
    oops: "אופס! לא הצלחנו לחייב אותך.",
    sad_emoji_img: "Sad Blue Emoji Illustration",
    saved: "אבל אל דאגה - הטופס שלך נשמר במערכת שלנו."
  },
  faq: "<span class='text-primary'>שאלות נפוצות </span>",
  faq_img: "איור סימן שאלה",
  father_country: "ארץ הולדתו של האב",
  father_name: "שם האב",
  female: "נקבה",
  final_price_note: "מחיר סופי, כולל כל המסים והעמלות",
  first_name: "שם פרטי",
  five_stars: "5 כוכבים",
  follow_us: "עקבו אחרינו",
  footer: {
    contact: "צור קשר",
    explore: "Explore",
    visas: "חשבונות אלקטרוניים ו- ETA"
  },
  form_modified_by_other: "Form has been modified by another tab or device.",
  form_review: {
    applicant_details: "סקירת דרכון",
    checkbox: "אני מאשר כי כל הפרטים לעיל נכונים ותואמים את פרטי הדרכון.",
    date_of_expiry: "תאריך תפוגה",
    date_of_issue: "תאריך ההנפקה",
    ensure_note: "אנא ודא שכל הפרטים בדף זה נכונים.",
    mistake_back: "מצאת טעות? אתה יכול לחזור לתקן את הפרטים.",
    number: "מספר",
    order_details: "סיכום הזמנה",
    quantity: "מספר המועמדים:",
    total_price: "סה\"כ מחיר:"
  },
  form_saved_in_system: "טופס הבקשה שלך נשמר כעת במערכת שלנו",
  form_steps: {
    details: "פרטים",
    payment: "תשלום",
    review: "סקירה",
    upload: "תמונות",
    visa_select: "בחירת ויזה"
  },
  from_price: "מ {price}",
  full_name: "שם מלא",
  global_faqs: [
    {
      a: "<p>התשלום וכל המידע המוזן באתרים שלנו הוא בסביבה מאובטחת ומוצפנת בכפוף לתקנים המחמירים ביותר: SSL ו- PCI של{currentYear}. 🔐 א </p> <p> בטחת נתונים ופרטיות הם בראש סדר העדיפויות שלנו. הנתונים שלך מוגנים ברמה הגבוהה ביותר, על פי הסטנדרטים המחמירים והמעודכנים ביותר המשמשים ארגונים כגון בנקים ואתרים ממשלתיים. 🛡️ </p> <p> אנו מתחייבים שלא נעשה כל שימוש בפרטים האישיים שאתה מסר לנו למעט השלמת המטרה אליה התחייבנו - הנפקת ויזה אלקטרונית עבורך. 🤝 מידע </p> <p> נוסף ניתן למצוא </a> בדף מדיניות הפר <a href=\"/privacy\" target=\"_blank\"> טיות של אתר האינטרנט שלנו. </p>",
      q: "מהי מדיניות האבטחה שלך והאם ניתן לסמוך עליה?"
    },
    {
      a: "<p>יצרנו {domain} במטרה לספק פתרון מקצועי, מהיר, מאובטח ובמחיר סביר לבעיה הידועה של קבלת ויזה למדינה זרה. הניסיון שלנו בתחום התיירות והניהול הדיפלומטי ברחבי העולם הוביל אותנו למסקנה שאין דרך קלה, בטוחה ורווחית להשיג ויזה למדינה זרה, במיוחד לישראלים. לכן יצרנו {domain} - באתר שלנו נעזור לכם לקבל אשרות אלקטרוניות למדינות שונות מבלי לעזוב את ביתכם ובמחירים הנמוכים ביותר במדינה! </p><p>🛡️ ויזנט הינה חברה רשמית ומקצועית העובדת בתחום הנפקת אשרות מזה שנים{yearsActive}. תוכלו לברר עלינו עוד בפנקס החברות הממלכתי, כמו גם לקרוא ביקורות ודעות עלינו ברשתות החברתיות:{socialLinks}. </p><p>👮 כל הוויזות שהונפקו באתר שלנו הן רשמיות ומתקבלות ישירות מרשויות הממשלה. תוכל למצוא מידע נוסף עלינו בדף אודות <a href=\"/about\"> Visanet. </a> </p>",
      q: "מי אתה, {domain} אתר אינטרנט? האם האתר שלך רשמי?"
    }
  ],
  global_field: "חל על כל המועמדים",
  google_apple_pay: "אפל/גוגל פיי",
  guardian_passport: "מספר דרכון מבוגר מלווה",
  hero_cta_bahrain: "הגש בקשה לוויזה אלקטרונית בחריין",
  hero_cta_cambodia: "הגש בקשה לקבלת ויזה אלקטרונית בקמבודיה",
  hero_cta_canada: "הגש בקשה ל- eTA של קנדה",
  hero_cta_home: "חקור את eVisas",
  hero_cta_india: "הגש בקשה לוויזה אלקטרונית בהודו",
  hero_cta_indonesia: "הגש בקשה לוויזה אלקטרונית באינדונזיה",
  hero_cta_israel: "הגש בקשה לויזת ETA לישראל",
  hero_cta_korea: "הגש בקשה לדרום קוריאה K-ETA",
  hero_cta_morocco: "הגש בקשה לקבלת ויזה אלקטרונית במרוקו",
  hero_cta_new_zealand: "הגש בקשה לניו זילנד NZeTA",
  hero_cta_saudi_arabia: "הגש בקשה לקבלת ויזה אלקטרונית בערב הסעודית",
  hero_cta_sri_lanka: "הגש בקשה לקבלת ויזה אלקטרונית בסרי לנקה",
  hero_cta_thailand: "Apply for Thailand eVisa",
  hero_cta_togo: "Apply for Togo eVisa",
  hero_cta_uk: "מלא טופס ETA בבריטניה",
  hero_cta_usa: "הגש בקשה ל- ESTA בארה\"ב",
  hero_cta_vietnam: "הגש בקשה לוויזה אלקטרונית בווייטנאם",
  hero_img: "כותרת ראשית",
  highschool: "בית ספר תיכון",
  hindu: "הינדואיזם",
  home_address: "כתובת בית",
  home_page: {
    meta_desc: "{domain}אתה יכול להגיש בקשה לויזה אלקטרונית למדינות שונות מבלי שתצטרך לעזוב את הבית או לבקר בשגרירות",
    overview_body1_bahrain: "הגש בקשה ל- eVisa שלך בבחריין באופן מקוון בקלות וקבל אישור תוך 1-3 ימים בלבד, שנמסר ישירות לתיבת הדואר הנכנס שלך.",
    overview_body1_cambodia: "הגש בקשה ל- eVisa שלך בקמבודיה במהירות ובבטחה. קבל את ה- eVisa שלך תוך 1-3 ימים וחקור את הארץ ההיסטורית הזו.",
    overview_body1_canada: "דלג על הטרחה של ניירת עם שירות ה- ETA שלנו בקנדה. ה- ETA שלך, בתוקף עד חמש שנים, יישלח ישירות לדוא\"ל שלך תוך 1-3 ימים בלבד.",
    overview_body1_india: "הגש בקשה ל- eVisa ההודית שלך באינטרנט בקלות. קבל את ה- eVisa המאושרת שלך ישירות לדוא\"ל שלך תוך 1-3 ימים והתכונן לטבול את עצמך בקסם של הודו.",
    overview_body1_indonesia: "הגשת בקשה לויזה אינדונזיה היא פשוטה אצלנו. קבל את הויזה המאושרת שלך באמצעות דוא\"ל תוך 2-3 ימים וצעד לגן עדן.",
    overview_body1_israel: "הגש בקשה ל-ETA שלך בישראל ללא מאמץ. אישור הנסיעה שלך יימסר לדוא\"ל שלך תוך 1-3 ימים, מוכן לנסיעה שלך.",
    overview_body1_korea: "הגשת בקשה ל- KETA שלך לדרום קוריאה היא פשוטה ומהירה. קבל את אישור הנסיעה שלך ישירות לתיבת הדואר הנכנס שלך תוך 1-2 ימים.",
    overview_body1_morocco: "הגש בקשה לוויזה האלקטרונית שלך במרוקו ללא מאמץ. ה-eVisa המאושרת שלך תימסר ישירות לדוא\"ל שלך תוך 2-3 ימים בלבד.",
    overview_body1_new_zealand: "אבטח את ה- NZeTA שלך בקלות באינטרנט. אישור הנסיעה שלך יישלח לדוא\"ל שלך תוך 1-3 ימים, מוכן לנסיעה שלך.",
    overview_body1_saudi_arabia: "הגש בקשה ל- eVisa שלך בערב הסעודית באינטרנט בקלות וקבל אישור תוך 1-2 ימים בלבד, מוכן למסע שלך לארץ שובה לב זו.",
    overview_body1_sri_lanka: "הגש בקשה ל- eVisa שלך בערב הסעודית באינטרנט בקלות וקבל אישור תוך 1-2 ימים בלבד, מוכן למסע שלך לארץ שובה לב זו.",
    overview_body1_thailand: "Get your Thailand Visa online hassle-free. Enjoy a quick approval process and receive your visa via email within 3-21 days.",
    overview_body1_togo: "Apply for your Togo eVisa online with ease and receive approval in just 1-3 days, ready for your journey into this captivating land.",
    overview_body1_uk: "אנו נעזור לכם להנפיק ויזה רשמית לבריטניה, בתוקף למשך 6 חודשים, ולקבל את הוויזה תוך 24-48 שעות בלבד - בעזרת הוויזה האלקטרונית בבריטניה, לא תצטרכו להגיש טפסים באנגלית ותוכלו לחסוך שעות בשדה התעופה לאחר טיסה ארוכה.",
    overview_body1_usa: "האתר היעיל שלנו הופך את הגשת בקשה ל- ESTA שלך לארה\"ב ללא מאמץ. תשכחו מעבודות הנייר המייגעות - ה- ESTA המאושר שלכם, בתוקף לשנתיים, יגיע ישירות לתיבת הדואר הנכנס שלכם תוך 1-3 ימים.",
    overview_body1_vietnam: "קבל את ויזת וייטנאם שלך באינטרנט ללא טרחה. תיהנו מתהליך אישור מהיר וקבלו את הויזה שלכם בדוא\"ל תוך 2-3 ימים.",
    overview_body2_bahrain: "חקור את המסגד הגדול אל-פתאח המהמם של בחריין.",
    overview_body2_cambodia: "התפעלו מהזריחה מעל אנגקור וואט.",
    overview_body2_canada: "התפעלו מהאורורה בוריאליס המדהימה ביוקון.",
    overview_body2_india: "רכבו על פיל בג'איפור ותרגישו כמו בני מלוכה.",
    overview_body2_indonesia: "תוכלו להירגע בחופים הבתוליים של באלי ולאמץ את אווירת האי.",
    overview_body2_israel: "לצוף במי הריפוי של ים המלח.",
    overview_body2_korea: "התמכרו לתרבות אוכל הרחוב התוססת של מיונגדונג.",
    overview_body2_morocco: "טיילו בשווקים התוססים של מרקש והתמקחו כמו מקצוען.",
    overview_body2_new_zealand: "טיילו בשבילים עוצרי הנשימה של מילפורד סאונד.",
    overview_body2_saudi_arabia: "חקור את הקברים המהממים המגולפים בסלע של אל-אולה.",
    overview_body2_sri_lanka: "חקור את הקברים המהממים המגולפים בסלע של אל-אולה.",
    overview_body2_thailand: "Explore the ancient ruins of Ayutthaya and immerse yourself in Thai history.",
    overview_body2_togo: "Explore the vibrant markets and stunning beaches of Lomé.",
    overview_body2_uk: "הממלכה המאוחדת של בריטניה הגדולה וצפון אירלנד היא מדינה הממוקמת מול החוף הצפון מערבי של יבשת אירופה. הוא כולל את האי בריטניה הגדולה, החלק הצפון-מזרחי של האי אירלנד, ואיים קטנים רבים יותר. צפון אירלנד היא החלק היחיד בבריטניה עם גבול יבשתי עם מדינה ריבונית אחרת, וחולקת אותו עם הרפובליקה של אירלנד.",
    overview_body2_usa: "טיילו בגשר שער הזהב האייקוני וספגו את הנופים של מפרץ סן פרנסיסקו.",
    overview_body2_vietnam: "צאו לשייט בסירה חולמנית דרך מערות הגיר של מפרץ האלונג.",
    overview_lead_bahrain: "תכשיט של המפרץ הערבי, בחריין מציעה שילוב ייחודי של מודרניות ומסורת, מאדריכלות עתידנית ועד מבצרים עתיקים.",
    overview_lead_cambodia: "קמבודיה, שקועה בהיסטוריה, היא ביתם של אנגקור וואט המלכותי ופנום פן התוסס.",
    overview_lead_canada: "חוו את השממה העצומה, ההרים המתנשאים והערים התוססות של קנדה. מהרוקי ועד מפלי הניאגרה, כל פינה מספרת סיפור.",
    overview_lead_india: "קליידוסקופ של צבעים, רוחניות והיסטוריה. מהטאג' מאהל המלכותי לרחובות התוססים של ג'איפור, הודו היא ארץ של חוויות תרבותיות עמוקות.",
    overview_lead_indonesia: "ביתם של החופים השלווים והתרבות העשירה של באלי, אינדונזיה מציעה בריחה קסומה. גלה את שדות האורז של אובוד או צלול לתוך שוניות האלמוגים התוססות.",
    overview_lead_israel: "ארץ של היסטוריה נצחית וחדשנות מודרנית. גלו את האתרים הקדושים בירושלים ואת חיי הלילה התוססים של תל אביב.",
    overview_lead_korea: "ארץ שבה המסורת פוגשת טכנולוגיה. חקור את הרחובות ההומים של סיאול, מקדשים בודהיסטים שלווים והנופים עוצרי הנשימה של האי ג'ג'ו.",
    overview_lead_morocco: "שער לאפריקה, מרוקו היא עומס חושי של סוקים שוקקים, מסגדים מלכותיים ומדבר סהרה העצום.",
    overview_lead_new_zealand: "חלומו של הרפתקן, ניו זילנד מתגאה בפיורדים מדהימים, גבעות מתגלגלות ופעילויות חוצות מרגשות.",
    overview_lead_saudi_arabia: "חשפו את המסתורין של ערב הסעודית, ארץ של פלאים עתיקים ופלאים מודרניים. מהקברים הנבטים של אל-אולה לעיר העתידנית ריאד.",
    overview_lead_sri_lanka: "חשפו את המסתורין של ערב הסעודית, ארץ של פלאים עתיקים ופלאים מודרניים. מהקברים הנבטים של אל-אולה לעיר העתידנית ריאד.",
    overview_lead_thailand: "A land of golden temples, vibrant markets, and stunning beaches. From the ancient ruins of Ayutthaya to the bustling streets of Bangkok, Thailand offers a tapestry of experiences waiting to be explored.",
    overview_lead_togo: "A hidden gem in West Africa, Togo offers a unique blend of vibrant markets, stunning beaches, and rich cultural heritage.",
    overview_lead_uk: "בריטניה היא מדינה בעלת היסטוריה עשירה, תרבות מגוונת ונופים מדהימים. מציוני הדרך האיקוניים של לונדון ועד היופי המחוספס של הרמות הסקוטיות, בריטניה מציעה שטיח של חוויות שמחכות לחקור.",
    overview_lead_usa: "ארץ החלומות, החדשנות והאופקים האינסופיים. מהאורות המסנוורים של טיימס סקוור ועד לנופים עוצרי הנשימה של הגרנד קניון, ארה\"ב מציעה הרפתקאות שאין שני לה לכל מטייל.",
    overview_lead_vietnam: "שילוב הרמוני של יופי טבעי ומורשת תרבותית. גלו את טרסות האורז השופעות, רחובות האנוי ההומים ומפרץ האלונג השליו.",
    overview_menu_label_desktop: "Choose Your Destination",
    overview_menu_label_mobile: "Choose Destination",
    title: "ויזה אלקטרונית מקוונת ישירות מהבית",
    travel_map: "מפת נסיעות"
  },
  homepage: "בית",
  hotel_name: "שם המלון",
  hotel_name_address: "כתובת או שם המלון",
  hourglass: "שעון חול",
  icons: {
    bell: "סמל פעמון",
    building: "אייקון בניין גבוה מודרני",
    clam: "פתח צדפה עם סמל פנינה",
    coffee: "סמל כוס קפה",
    elephant: "סמל פיל",
    honey: "בקבוק דבש עם סמל קנדה",
    lawn_mower: "סמל מכסחת דשא",
    meat: "סמל חתיכות בשר",
    raccoon: "אייקון דביבון",
    spider: "סמל עכביש",
    trees: "סמל עצים טרופיים",
    volcano: "סמל הר געש"
  },
  illustation: "איור",
  image_upload: "העלאת תמונות",
  image_upload_instructions: "הוראות העלאת תמונות",
  image_upload_prefer: "איך תרצה לשלוח לנו את התמונות?",
  images: {
    al_fateh_grand_mosque_hero: "מסגד הגדול אל-פתח דגם תלת מימד, eVisa בחריין",
    aling_aling: "מפל אלינג-אלינג, באלי, אינדונזיה",
    angkor: "אנגקור וואט, סיאם ריפ, קמבודיה eVisa",
    angkor_desc: "אנגקור וואט, סיאם ריפ, קמבודיה",
    angkor_hero: "אנגקור וואט דגם תלת מימד, קמבודיה eVisa",
    arugam: "מפרץ ארוגאם, ויזה סרי לנקה",
    arugam_desc: "מפרץ ארוגאם, סרי לנקה",
    bahrain_beach_cta: "דגם תלת מימד של חוף בחריין, eVisa בחריין",
    bahrain_fort: "מבצר בחריין, ויזה אלקטרונית בחריין",
    bahrain_fort_desc: "מבצר בחריין, בחריין",
    bahrain_trade_center: "מרכז הסחר בחריין, מנאמה",
    bahrain_world_trade_center_cta: "Bahrain World Trade Center 3D Model, Bahrain eVisa",
    bali_temple: "מקדש באלי, אינדונזיה",
    balinese_dancer_cta: "דגם תלת מימד של רקדן באלינזי, ויזה אינדונזיה",
    banff: "הפארק הלאומי באנף, קנדה",
    big_ben: "ביג בן, לונדון",
    borobudur: "מקדש בורובודור, ויזה אינדונזיה",
    borobudur_desc: "מקדש בורובודור, אינדונזיה",
    borobudur_hero: "דגם תלת מימד של מקדש בורובודור, ויזה אינדונזיה",
    british_guard_cta: "British Gaurd 3D Model, UK ETA",
    buddha_statue_cta: "דגם תלת מימד של פסל בודהה, הודו eVisa",
    cambodia_beach_cta: "דגם תלת מימד חוף קמבודיה, קמבודיה eVisa",
    camel_saudi_arabia_cta: "דגם תלת מימד של גמל, ערב הסעודית eVisa",
    casablanca: "קזבלנקה, מרוקו",
    cathedral: "קתדרלה, ירושלים",
    central_park: "סנטרל פארק, ניו יורק",
    chefchaouen: "שפצ'ואן, מרוקו eVisa",
    chefchaouen_cta: "דגם תלת מימד של שפצ'ואן, מרוקו eVisa",
    chefchaouen_desc: "שפצ'ואן, מרוקו",
    clipboard_checkmark: "Clipboard with Checkmark",
    clipboard_with_checkmark: "Clipboard with Checkmark 3D Icon",
    "da-nang-bridge": "גשר דה נאנג, וייטנאם",
    dead_sea: "ים המלח, ישראל ETA-IL",
    dead_sea_desc: "ים המלח, ישראל",
    dome_of_the_rock_hero: "כיפת הסלע דגם תלת מימד, ישראל ETA-IL",
    edinburgh_castle: "Edinburgh Castle, UK ETA",
    edinburgh_castle_desc: "Edinburgh Castle, United Kingdom",
    elephant_sri_lanka_cta: "דגם תלת מימד של פיל, ויזה סרי לנקה",
    goa: "גואה, הודו",
    golden_bridge: "גשר הזהב, ויזת וייטנאם",
    golden_bridge_desc: "גשר הזהב, וייטנאם",
    grand_canyon: "גרנד קניון, ESTA ארה\"ב",
    grand_canyon_desc: "גרנד קניון, ארה\"ב",
    gwanghwamun: "שער גוואנגוואמון, דרום קוריאה",
    gyeongbokgung_hero: "ארמון גיונגבוקגונג, דרום קוריאה KETA",
    ha_long_bay_cta: "דגם תלת מימד של מפרץ הלונג, ויזת וייטנאם",
    handara_gate: "שער הנדרה, באלי, אינדונזיה",
    hanok: "כפר בוקצ'ון האנוק, דרום קוריאה",
    hassan_ii_mosque_hero: "מסגד חסן השני דגם תלת מימד, מרוקו eVisa",
    hisma: "Hisma, ערב הסעודית",
    ho_chi_minh: "הו צ'י מין, וייטנאם",
    hollywood: "הוליווד, לוס אנג'לס",
    itmad: "קבר אטימאד-אוד-דולה, הודו",
    jeju_island: "האי ג'ג'ו, דרום קוריאה KETA",
    jeju_island_desc: "האי ג'ג'ו, דרום קוריאה",
    kokatahi: "קוקטאהי, ניו זילנד NZeTA",
    kokatahi_desc: "קוקטאהי, ניו זילנד",
    korean_warrior_cta: "לוחם קוריאני בלבוש מסורתי דגם תלת מימד, דרום קוריאה KETA",
    "lake-louise": "אגם לואיז, קנדה",
    madain_saleh: "מדין סאלח, ערב הסעודית eVisa",
    madain_saleh_desc: "מדיין סאלח, ערב הסעודית",
    manhattan_hero: "דגם תלת מימד של מנהטן, ESTA ארה\"ב",
    masjid_al_haram_hero: "מסג'יד אל חראם דגם תלת מימד, ערב הסעודית eVisa",
    masks: "טקס מסכה הינדי, צפון הודו",
    matamata: "מטמטה, ניו זילנד",
    monks: "נזירים קמבודיים, קמבודיה",
    moraine: "אגם מוריין, קנדה",
    new_zealand_landscape_hero: "מודל תלת מימד של נוף ניו זילנד, ניו זילנד NZeTA",
    niagara_falls: "מפלי הניאגרה, קנדה ETA",
    niagara_falls_cta: "דגם תלת מימד מפלי הניאגרה, קנדה ETA",
    niagara_falls_desc: "מפלי הניאגרה, קנדה",
    ninh_binh: "נין בין, וייטנאם",
    nuwara: "נוארה אלייה, סרי לנקה",
    passport_icon: "Passport Icon",
    phi_phi_islands: "Phi Phi Islands, Thailand",
    phi_phi_islands_desc: "Phi Phi Islands, Thailand",
    qalat_al_bahrain: "קלאת אל-בחריין, בחריין",
    red_bus_palace_westminster: "אוטובוס אדום, ארמון ווסטמינסטר, לונדון",
    rocking_chair_with_cat_and_laptop: "Rocking Chair with Cat and Laptop",
    royal_guard_horse: "המשמר המלכותי, לונדון",
    sigiriya: "סיגיריה, סרי לנקה",
    statue_of_liberty_cta: "פסל החירות דגם תלת מימד, ESTA ארה\"ב",
    taghazout: "טאגאזוט, מרוקו",
    taj_mahal: "טאג' מהאל, הודו eVisa",
    taj_mahal_desc: "טאג' מהאל, הודו",
    taj_mahal_hero: "דגם תלת מימד של טאג' מאהל, הודו eVisa",
    tel_aviv_beach_cta: "חוף תל אביב דגם תלת מימד, ישראל ETA-IL",
    togo_village: "Togo Village, Togo eVisa",
    togo_waterfall: "Togo Waterfall, Togo eVisa",
    togo_waterfall_desc: "Waterfall, Togo",
    toronto_hero: "טורונטו מודל תלת מימד, קנדה ETA",
    uluwatu_temple: "Uluwatu Temple 3D Model, Indonesia eVisa",
    unawatuna_beach_hero: "דגם תלת מימד חוף אונוואטונה, ויזה סרי לנקה",
    ushaiqer: "אושייקר, ערב הסעודית",
    vietnam_house_on_beach_hero: "בית וייטנאם על החוף דגם תלת מימד, ויזת וייטנאם",
    wat_chalong: "Wat Chalong, Thailand"
  },
  images_required_note_face: "תמונת פנים אחרונה.",
  images_required_note_face_pass: "תמונת פנים אחרונה וצילום דרכון.",
  images_required_note_pass: "צילום דרכון.",
  images_required_note_start_bahrain: "מחלקת ההגירה של בחריין דורשת מכל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_cambodia: "מחלקת ההגירה של קמבודיה דורשת מכל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_india: "מחלקת ההגירה של הודו דורשת מכל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_indonesia: "מחלקת ההגירה של אינדונזיה מחייבת כל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_israel: "The Immigration Department of Israel requires anyone applying for an ETA-IL to provide",
  images_required_note_start_korea: "מחלקת ההגירה של דרום קוריאה מחייבת כל מי שמבקש K-ETA לספק",
  images_required_note_start_morocco: "מחלקת ההגירה של מרוקו דורשת מכל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_saudi_arabia: "מחלקת ההגירה של ערב הסעודית דורשת מכל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_sri_lanka: "מחלקת ההגירה של סרי לנקה דורשת מכל מי שמבקש ויזה אלקטרונית לספק",
  images_required_note_start_thailand: "The Immigration Department of Thailand requires anyone applying for an e-visa to provide",
  images_required_note_start_togo: "The Immigration Department of Togo requires anyone applying for an e-visa to provide",
  images_required_note_start_uk: "מחלקת ההגירה של בריטניה דורשת מכל מי שמבקש ETA בבריטניה לספק",
  images_required_note_start_usa: "מחלקת ההגירה של ארה\"ב דורשת מכל מי שמגיש בקשה ל- ESTA לספק",
  images_required_note_start_vietnam: "מחלקת ההגירה של וייטנאם מחייבת כל מי שמבקש ויזה אלקטרונית לספק",
  india: "הודו",
  india_evisa: "ויזה אלקטרונית בהודו",
  india_page: {
    faq: [
      {
        a: "<p>לאחר מילוי והגשת טופס <a href=\"#form\"> הוויזה המקו </a> ון באתר האינטרנט שלנו, אנו נעבד את בקשתך ונשלח אותה למשרד ההגירה הראשי של הודו, המטפל בויזות אלקטרוניות מכל רחבי העולם. </p><p>לאחר 2-3 ימים הויזה האלקטרונית מאושרת ונשלחת אליך ישירות בדוא\"ל - מסמך זה מהווה אישור רשמי לבקר בהודו. </p><p>כל שעליכם לעשות בהמשך הוא להדפיס את הוויזה שלכם, לשמור אותה בהישג יד ולהציג אותה על פי בקשה ברגע שתגיעו להודו - בתמורה תקבלו (ללא עלות נוספת) חותמת רשמית בדרכון המאפשרת לכם להיכנס ולצאת מהודו למשך חודש, שנה או 5 שנים (תלוי בסוג הויזה שתבחרו), עם שהייה מקסימלית של 30/90 יום לכניסה (או 180 יום אם תבחרו אשרת עסקים). </p>",
        q: "כיצד פועל תהליך הנפקת הוויזה להודו באתר?"
      },
      {
        a: "<p>לאחר הנפקת הוויזה האלקטרונית שלך, אתה זכאי להיכנס להודו בתוך החודש, השנה או חמש השנים הבאות, תלוי בסוג הוויזה שתבחר: </p> <ul> <li> <strong> ויזה למשך 30 יום (תיירות) </strong> - מרגע כניסתך לגבולות המדינה, תוכל להישאר שם עד 30 ימים רצופים. אתה יכול להשתמש בויזה עבור 2 כניסות במהלך תוקפו. </li><li><strong>ויזה לשנה אחת/5 שנים (תיירות) </strong> - מרגע כניסתך לגבולות המדינה, תוכל להישאר שם עד 90 ימים רצופים. <br>אם עזבת את גבולות המדינה ונכנסת מחדש, תוכל להישאר למשך 90 יום נוספים וכן הלאה עד סוף שנה/5 שנים ממועד הנפקת הויזה. </li><li><strong>ויזה לשנה אחת (עסקים) </strong> - מרגע כניסתך למדינה, יש לך את הזכות להישאר בה עד 180 יום ברציפות. </li></ul><p>⚠️ שימו לב: משך הזמן הכולל בהודו מוגבל ל -180 יום בכל שנה קלנדרית (למשל 2024). </p>",
        q: "לכמה זמן תקפה ויזה אלקטרונית הודית?"
      },
      {
        a: "<p>אם רכשת ויזה אלקטרונית לשנה או יותר, אין הגבלה למספר הפעמים שתרשו להיכנס לגבולות הודו. <br>כל עוד הויזה לא פגה - הכניסה חופשית. <br>במקרה של ויזה אלקטרונית לחודש אחד, אתה רשאי להיכנס להודו פעמיים לכל היותר. </p>",
        q: "כמה פעמים מותר לך להיכנס להודו עם אותה ויזה?"
      },
      {
        a: "<p>הכניסה הראשונה שלך להודו עם הויזה שהונפקה לך חייבת להיות כניסה אווירית (במטוס) או בים (בספינה). <br>כניסה קרקעית בהחלט אפשרית, אך רק אם זו הפעם השנייה (או יותר) שאתה נכנס להודו לאחר השימוש בויזה האלקטרונית. </p>",
        q: "האם ניתן להיכנס להודו ביבשה עם הוויזה?"
      },
      {
        a: "<p>לא, ממשלת הודו מגבילה </strong> כניסה <strong> ראשונה עם ויזה אלקטרונית לנמלים מסוימים. להלן רשימת שדות התעופה שמהם מותר להיכנס להודו: </p> <ul> <li> דלהי מומ </li> <li> באי </li> <li> גואה צ' </li> <li> נאי </li> <li> קולקטה </li> <li> בנגלורו היידראבאד גאיה </li> <li> קוצ'ין אחמדאבאד אמריצר תירוואנאנ </li> <li> תאפ </li> <li> וראם ג'איפור לו </li> <li> קנאו </li> <li> </li> <li> </li> <li> </li> <li> </li><li>טרישי ור </li> <li> נאסי </li> <li> קליקוט </li> <li> מנגלור פונה נג </li> <li> פור </li> <li> קוימבטור בג </li> <li> דוגרה </li> <li> גוואהאטי </li> <li> צ'אנדיגאר מדוראי ויסאקהפטנאם בהובנשוואר פורט בלייר והנה הנמלים שדרכם אתם </li> <li> </li> <li> </li> <li> </li> <li> </li> <li> </li> </ul> <p> יכול להגיע דרך הים: </p> <ul> <li> מומבאי </li> <li> קוצ'ין </li> <li> מורמוגאו צ'נאי ניו מנגלור </li> <li> </li> <li> </li> </ul>",
        q: "האם ניתן להיכנס להודו משדה תעופה או גבול כלשהו?"
      },
      {
        a: "<p>-לא. התשלום באתרים שלנו הושלם, סופי וכולל את כל העמלות, המסים והעמלות לממשלת הודו. <br>לתשלום באתרים שלנו תקבל חותמת רשמית בדרכון שלך עם הנחיתה, ללא צורך בתשלום נוסף. </p>",
        q: "האם יש תשלום נוסף עבור הויזה בהודו?"
      },
      {
        a: "<p>כל אדם שאינו אזרח הודו, ורוצה להיכנס לגבולות המדינה. אף מדינה/לאום אינו יוצא מן הכלל. </p>",
        q: "מי צריך להגיש בקשה לויזה להודו?"
      },
      {
        a: "<p>ממשלת הודו מחייבת אותך להגיש בקשה לפחות 4 ימים לפני הטיסה המתוכננת שלך. לקבלת ביטחון רב יותר, אנו ממליצים להגיש את הבקשה לפחות שבוע לפני עזיבתך. עם זאת, ניתן להגיש בקשות 1-3 ימים לפני הטיסה שלך, כאשר 99% מהויזות מטופלות דרך האתר שלנו ויזנט, וקיבלו אישור תוך 1-3 ימים. </p><p>⚡ בנוסף, האתר שלנו מציע שירות מזורז לוויזה הודית דחופה, אשר מאושרת בדרך כלל תוך כ -24 שעות ומוכנה עד למחרת. </p>",
        q: "כמה זמן לפני הנסיעה שלי עלי להגיש בקשה לויזה הודית?"
      },
      {
        a: "<p>-לא. משרד החוץ של הודו אינו מתיר הארכה. עם זאת, בהחלט ניתן להנפיק ויזה אלקטרונית נוספת מיד לאחר תום הויזה הקודמת. </p>",
        q: "האם ניתן להאריך את תוקפו של ויזה אלקטרונית להודו?"
      },
      {
        a: "<p>-לא. עליך לעזוב את גבולות המדינה ולהיכנס רק לאחר שהנפקת ויזה אלקטרונית חדשה. </p>",
        q: "האם ניתן לקבל ויזה חדשה בהודו?"
      },
      {
        a: "<p>-כן. כל אדם שאינו אזרח הודו חייב להיות בעל אשרת כניסה כדי להיכנס לגבולות המדינה, כולל ילדים בגילאי 0-18. <br>בעזרתנו תוכלו להנפיק ויזה אלקטרונית לילדכם בשילוב עם הזמנת הויזה שלכם, והכל בטופס מקוון נוח אחד. </p>",
        q: "האם ילדים זקוקים לויזה אלקטרונית כדי להיכנס להודו?"
      },
      {
        a: "<p>גם הוויזה המסורתית וגם הוויזה האלקטרונית הם מסמכים שמטרתם לאשר את כניסתך והשהייה בהודו. <br>הוויזה האלקטרונית הומצאה על מנת להקל על חייך - אין צורך לשלוח מסמכים פיזית, להגיע לשגרירות ולחכות שבועות לתשובה ולקבל את הדרכון בחזרה. באתר שלנו התהליך כולו מתבצע באופן מקוון, באנגלית פשוטה וללא צורך לצאת מהבית. תוך 1-3 ימים בלבד. </p>",
        q: "מה ההבדל בין ויזה אלקטרונית לויזה רגילה?"
      },
      {
        a: "<p>כן, באתר Visanet תוכלו להשיג ויזות אלקטרוניות ו- ETA למדינות רבות, כולל <a href=\"/usa\"> ארצות הברית, <a href=\"/israel\"> ישראל</a>, <a href=\"/korea\"> דרום קוריאה </a> </a></a>, <a href=\"/vietnam\"> וייטנאם ועוד רבות אחרות. נשמח לסייע לכם בכל צרכי אשרת הנסיעה שלכם. </p><p>בנוסף, אתר האינטרנט הבינלאומי Visanet זמין במספר שפות לנוחיותכם: <a href=\"https://visanet.co.il/india\"> עברית</a>, Ру <a href=\"https://visanet.ru/india\"> сский, וסוודית</a>. <a href=\"https://visanet.se/india\"> </a> </p>",
        q: "האם אתה מסייע בקבלת אשרות למדינות אחרות?"
      },
      {
        a: "<p>אל תהסס לחקור את הב </a> לוג <a href=\"/blog\"> שלנו לקבלת החדשות האחרונות, העדכונים והמדריכים המקיפים לקבלת אשרות להודו. </p><p>בנוסף, הצוות שלנו מוכן להציע לך <a href=\"/contact\"> סיוע אנושי חי 24/7 </a></p>. <p>תודה לך, צוות ויזנט. </p>",
        q: "יש לי שאלות נוספות"
      }
    ],
    meta_desc: "קבל את eVisa שלך בהודו תוך 3-5 ימים על ידי מילוי טופס מקוון קצר באנגלית. ויזה הודית רשמית {currentYear} ללא ביקור בשגרירות",
    title: "ויזה אלקטרונית להודו באינטרנט"
  },
  india_stay_limit_note: "עבור לאומים שאינם ארה\"ב, בריטניה, קנדה ויפן, מגבלת השהייה היא 90 יום.",
  indonesia: "אינדונזיה",
  indonesia_evisa: "ויזה אלקטרונית של אינדונזיה",
  indonesia_page: {
    faq: [
      {
        a: "הוויזה האלקטרונית לאינדונזיה היא מסמך רשמי המאפשר כניסה לאינדונזיה למטרות שונות, כגון תיירות, עסקים וביקורים חברתיים, ללא צורך לבקר בשגרירות לקבלת חותמת ויזה פיזית בדרכון שלך.",
        q: "מהי ויזה אלקטרונית לאינדונזיה?"
      },
      {
        a: "אזרחי רוב המדינות יכולים להגיש בקשה לויזה אלקטרונית לאינדונזיה באופן מקוון. בדוק את רשימת הז <a data-eligibility-list-opener> כאות המלאה כאן </a> כדי לאשר אם הלאום שלך מתאים.",
        q: "מי זכאי לוויזה אלקטרונית של אינדונזיה?"
      },
      {
        a: "אינדונזיה מציעה מספר סוגים של ויזות אלקטרוניות, כולל: ויזה אלקטרונית ל <ul> <li> תיירים ויזה עסקית </li> <li> </li> </ul>",
        q: "אילו סוגים של ויזות אלקטרוניות זמינות לאינדונזיה?"
      },
      {
        a: "העיבוד אורך בדרך כלל 3-5 ימי עסקים, אם כי זה יכול להשתנות בהתאם לנפח היישומים או לכל בעיה ספציפית ביישומים בודדים.",
        q: "כמה זמן לוקח לעיבוד הוויזה האלקטרונית של אינדונזיה?"
      },
      {
        a: "תוקפו של הויזה האלקטרונית תלוי בסוג הויזה ונע בין 60 יום עד 5 שנים.",
        q: "מהו תוקפו של ויזה אלקטרונית לאינדונזיה?"
      },
      {
        a: "<ul><li>ויזה 60 יום: שהייה עד 60 יום (ניתנת להרחבה) (כניסה יחידה) </li> <li> ויזה לשנה: שהייה עד 60 יום לכניסה (כניסות מרובות) אשרה לשנ </li> <li> תיים: שהייה עד 60 יום בכניסה (כניסות מרובות) ויזה </li> <li> 5 שנים: שהייה עד 60 יום לכל כניסה (כניסות מרובות) </li> </ul> כל סוגי הוויזה מאפשרים פעילויות כגון תיירות, ביקור במשפחה או חברים והשתתפות בפגישות או בתערוכות כמשתתף. עם זאת, הם אוסרים בהחלט לעבוד או לעסוק בפעילויות הרווחיות.",
        q: "מהם משך הוויזה ותקופות השהייה השונות?"
      },
      {
        a: "<ul><li>דרכון תקף עם תוקף של לפחות 6 חודשים מיום הכניסה. </li><li>תמונה עדכנית בגודל דרכון - אתה יכול לשלוח לנו את התמונה בכל פורמט שתרצה (למשל, מהטלפון שלך), ואנו נערוך אותה בהתאם לדרישות הספציפיות. </li><li>כרטיס חזרה או הלאה. </li><li>הצהרת בנק אישית המציגה יתרה מינימלית של 2000 דולר ארה\"ב או שווה ערך לשלושת החודשים האחרונים (חייב לכלול את שמך, תאריך התקופה ויתרת החשבון שלך). </li></ul>",
        q: "אילו מסמכים נדרשים לבקשת הוויזה האלקטרונית לאינדונזיה?"
      },
      {
        a: "הויזה האלקטרונית הסטנדרטית לתיירים למשך 60 יום מיועדת לכניסה יחידה. עם זאת, אשרות שנה, שנתיים וחמש שנים הן כניסה מרובות, ומאפשרות לך להיכנס לאינדונזיה מספר פעמים במהלך תקופת תוקפו של הויזה, כאשר כל שהייה מוגבלת עד 60 יום.",
        q: "האם אוכל להיכנס לאינדונזיה מספר פעמים עם ויזה אלקטרונית?"
      },
      {
        a: "ניתן להגיש בקשה לויזה אלקטרונית דרך אתר <a href=\"#form\"> </a> האינטרנט שלנו. מלא את הטופס עם הפרטים שלך, העלה את המסמכים הדרושים ושלם את האגרה באופן מקוון.",
        q: "כיצד אוכל להגיש בקשה לויזה אלקטרונית לאינדונזיה?"
      },
      {
        a: "כן, באלי היא חלק מאינדונזיה, ואותן דרישות אשרה חלות.",
        q: "אני טס לבאלי, האם אני צריך גם ויזה?"
      },
      {
        a: "לא, יש להגיש בקשה לויזה אלקטרונית ולאשר אותה לפני הכניסה לאינדונזיה. אם אתה כבר באינדונזיה וצריך להאריך את שהותך, בקר במשרד הגירה.",
        q: "האם אוכל להגיש בקשה לויזה אלקטרונית כשאני כבר באינדונזיה?"
      },
      {
        a: "כן, מומלץ להדפיס את הוויזה האלקטרונית שלך ולשאת אותה איתך בעת נסיעה לאינדונזיה, מכיוון שתצטרך להציג אותה לרשויות ההגירה עם ההגעה.",
        q: "האם אני צריך להדפיס את הויזה האלקטרונית שלי?"
      },
      {
        a: "אם תאריכי הנסיעה שלך משתנים, ייתכן שתצטרך להגיש בקשה לוויזה אלקטרונית חדשה, מכיוון שכל ויזה קשורה לתאריכי כניסה ויציאה ספציפיים. <a href=\"/contact\">צור איתנו קשר </a> כדי לברר לגבי הנפקה מחדש או שינוי הויזה שלך.",
        q: "מה אם תוכניות הנסיעה שלי ישתנו?"
      }
    ],
    meta_desc: "הגש בקשה לויזה אלקטרונית לאינדונזיה באנגלית. קבל ויזה מבלי לבקר בשגרירות, תהליך מהיר ונוח",
    title: "ויזה אלקטרונית לאינדונזיה"
  },
  inside_country: "בפנים {country}",
  islam: "האיסלאם",
  israel: "ישראל",
  israel_evisa: "ישראל ETA-IL",
  israel_page: {
    faq: [
      {
        a: "בדרך כלל תקבל תשובה תוך יום עד שלושה ימים.",
        q: "כמה זמן ייקח לקבל תשובה לאחר שליחת טופס IL-ETA?"
      },
      {
        a: "ה- ETA-IL שלך תקף בדרך כלל לנסיעות מרובות עד שנתיים או עד שתוקף הדרכון שלך יפוג. אין צורך להגיש בקשה חוזרת בתקופה זו. תפוגה בישראל לא תשפיע על עזיבתך.",
        q: "כמה זמן תקף ה- ETA-IL שלי?"
      },
      {
        a: "אזרחים ממדינות זכאיות יכולים להגיש בקשה ל- ETA-IL לישראל באופן מקוון. תוכל לצפות ברשימת המדינות הזכאיות <a data-eligibility-list-opener>כאן</a>.",
        q: "מי זכאי להגיש בקשה ל- ETA-IL לישראל?"
      },
      {
        a: "כן, כולם, ללא קשר לגיל, זקוקים ל- ETA-IL אם מגיעים ממדינה פטורה לוויזה. מבוגר חייב להגיש בקשה בשם קטין.",
        q: "האם קטינים זקוקים ל- ETA-IL?"
      },
      {
        a: "ETA-IL מאפשר שהייה עד 90 יום. עבור שהיות ארוכות יותר, בקש הארכה במשרד ההגירה הישראלי המקומי.",
        q: "מה אם אני רוצה לבקר בישראל יותר משלושה חודשים?"
      },
      {
        a: "הגש בקשה בכל עת לפני הנסיעה שלך. מומלץ להגיש את בקשתך לפחות 72 שעות לפני הזמנת טיסות או לינה.",
        q: "מתי עלי להגיש בקשה ל- ETA-IL?"
      },
      {
        a: "הגש בקשה מחדש אם אתה מקבל דרכון חדש, שנה את שמך או שנה את האזרחות שלך. כל יישום חדש עולה $25 דולר.",
        q: "מתי עלי להגיש בקשה מחדש עבור ETA-IL חדש?"
      },
      {
        a: "כן, קיום ETA-IL תקף אינו מבטיח כניסה. קציני בקרת גבולות יכולים לדחות כניסה אם אינך עומד בדרישות החוקיות והפרוצדורליות.",
        q: "האם ניתן לסרב לי כניסה עם ETA-IL תקף?"
      },
      {
        a: "הדפסת ה- ETA-IL אינה נדרשת, אך רצוי שיהיה איתך את מספר האישור או עותק מודפס.",
        q: "האם עלי להדפיס את האישור?"
      },
      {
        a: "<p>כן, באתר Visanet תוכלו להשיג ויזות אלקטרוניות ו- ETA למדינות רבות, כולל <a href=\"/usa\"> ארצות הברית, <a href=\"/canada\"> קנדה</a>, <a href=\"/india\"> הודו </a></a>, <a href=\"/korea\"> דרום קוריאה ורבות </a> אחרות. נשמח לסייע לכם בכל צרכי אשרת הנסיעה שלכם. </p><p>בנוסף, אתר האינטרנט הבינלאומי של Visanet זמין במספר שפות לנוחיותך: Ру <a href=\"https://visanet.ru/israel\"> сский, וסוונדאית</a>. <a href=\"https://visanet.se/israel\"> </a> </p>",
        q: "האם אתה מסייע בקבלת אשרות למדינות אחרות?"
      }
    ],
    meta_desc: "קבל את אשרת ה- ETA-IL לישראל עכשיו, זמינה החל מיולי 2024. הגש טופס בקשה קצר וקבל את אישור הויזה האלקטרונית לישראל תוך 1-2 ימים",
    title: "ויזה לישראל ETA-IL זמינה באינטרנט עכשיו 2024 • Visanet"
  },
  job_seniority: "שנים של ותק",
  judaism: "יהדות",
  kid: "(ילד)",
  kid_visa_price: "מחיר ויזה לילדים:",
  korea: "דרום קוריאה",
  korea_accompanying_children_info: "Children aged 0-17 do not need a K-ETA to enter South Korea if accompanied by a parent. If your children are joining your trip, please add them below.",
  korea_evisa: "דרום קוריאה K-ETA",
  korea_page: {
    faq: [
      {
        a: "<p>ה- <strong> K- </strong> Electronic <strong> T </strong> ravel <strong> A </strong> uthorization או בקי <strong> צור K-ETA</strong>, הוא מסמך אישור נסיעה אלקטרוני המספק אישור כניסה לגבולות דרום קוריאה. זה עובד בדומה לויזה אך מתקבל באופן מקוון. </p>",
        q: "מהי אשרת כניסה K-ETA לדרום קוריאה?"
      },
      {
        a: "<p>כן, מטיילים מכמעט 112 מדינות המתכננים לבקר בקוריאה לביקור לטווח קצר זקוקים ל- K-ETA. </p>",
        q: "האם אני צריך K-ETA כדי להיכנס לדרום קוריאה?"
      },
      {
        a: "לאחר שתשלח את הטופס המקוון באתר שלנו, תקבל אישור K-ETA באמצעות דוא\"ל. הביאו עותק מודפס או דיגיטלי של מסמך זה בעת הכניסה לדרום קוריאה.",
        q: "כיצד פועל תהליך K-ETA?"
      },
      {
        a: "כל אישור K-ETA תקף לשלוש שנים או עד שתוקף הדרכון שלך יפוג.",
        q: "לכמה זמן תקף ה- K-ETA?"
      },
      {
        a: "עבור רוב הלאומים, לאחר שנכנסת לדרום קוריאה באמצעות K-ETA, אתה רשאי להישאר עד 90 יום לכל היותר. עם זאת, אם השתמשת בדרכון הרוסי שלך עבור ה- K-ETA שלך, השהייה שלך לא תעלה על 60 יום ברציפות, ולא תעלה על 90 ימי שהייה בתוך 180 יום.",
        q: "מהי מגבלת השהייה המקסימלית בדרום קוריאה עם K-ETA?"
      },
      {
        a: "העלות עבור K-ETA של דרום קוריאה באתר שלנו היא{price}.",
        q: "כמה עולה K-ETA?"
      },
      {
        a: "התהליך אורך בדרך כלל עד שלושה ימי עבודה.",
        q: "כמה זמן לוקח להנפיק K-ETA?"
      },
      {
        a: "לא, אין צורך כזה בדרכון ביומטרי כדי להגיש בקשה ל-K-ETA.",
        q: "האם אני צריך דרכון ביומטרי כדי לקבל ויזה באמצעות K-ETA?"
      },
      {
        a: "לא. אתה יכול להגיש בקשה ל- ETA קוריאני גם אם טרם רכשת כרטיס טיסה.",
        q: "האם עלי לרכוש כרטיסי טיסה לפני הגשת בקשה ל- ETA קוריאנית?"
      },
      {
        a: "כן. אם כבר יש לך ויזה תקפה, אתה יכול להשתמש בה כדי להיכנס לדרום קוריאה. K-ETA אינו מבטל אשרות קיימות.",
        q: "יש לי כבר ויזה תקפה. האם אוכל להשתמש בו במקום לקבל K-ETA?"
      },
      {
        a: "הויזה המסורתית דורשת תיעוד פיזי, ביקורי שגרירות ותקופת המתנה ארוכה יותר. מצד שני, K-ETA היא מערכת מקוונת פשוטה המאפשרת לקבל אישור להיכנס לדרום קוריאה תוך מספר ימים.",
        q: "מה ההבדל בין ויזה רגילה לבין K-ETA?"
      },
      {
        a: "<p>אל תהסס לחקור את הב </a> לוג <a href=\"/blog\"> שלנו לקבלת החדשות האחרונות, העדכונים והמדריכים המקיפים להשגת ETA לקוריאה. </p><p>בנוסף, הצוות שלנו מוכן להציע לך <a href=\"/contact\"> סיוע אנושי חי 24/7 </a></p>. <p>תודה לך, צוות ויזנט. </p>",
        q: "יש לי שאלות נוספות"
      }
    ],
    meta_desc: "הגש בקשה להיתר כניסה אלקטרוני לדרום קוריאה K-ETA באנגלית וקבל אותו תוך 1-3 ימים",
    title: "eVisa לדרום קוריאה באינטרנט"
  },
  landport: "לנדפורט",
  languages: {
    en: "English",
    he: "Hebrew",
    ru: "Russian",
    sv: "Swedish"
  },
  last_name: "שם משפחה",
  last_travel: {
    country: "Where did you last travel to?",
    from: "From",
    traveled: "Have you ever traveled abroad?",
    until: "Until"
  },
  last_visa_issue_date: "תאריך הנפקת אשרה קודמת",
  link_copied: "קישור הועתק",
  link_send: "שלח את הקישור",
  link_sent: "הקישור נשלח בהצלחה",
  link_validity_time: "הקישור תקף למשך 30 יום בלבד. אנא חזרו ומלאו את הטופס במסגרת הזמן.",
  list_price: "מחיר מחירון",
  male: "זכר",
  marital: {
    divorced: "גרושים",
    married: "נשוי",
    single: "יחיד",
    widowed: "אלמן"
  },
  marital_status: "מצב משפחתי",
  may_resume: "אתה יכול להמשיך את הטופס מהנקודה שבה הפסקת",
  may_use_phone_camera: "אתה יכול להשתמש במצלמה של הטלפון.",
  medical_insurance_included: "ביטוח רפואי נדרש כבר כלול במחיר הויזה שלנו.",
  military_rank: "דרגה",
  military_ranks: {
    corporal: "רב\"ט",
    nco: "NCO",
    officer: "קצין",
    "private": "פרטי",
    sergeant: "סרג'נט",
    staff_sergeant: "סמל ראשון"
  },
  military_roles: {
    fighter: "לוחם",
    office: "עבודה במשרד",
    support: "תמיכה"
  },
  military_service: "שירות צבאי",
  military_service_type: "סוג השירות",
  mobile_payment: {
    header: "הוראות תשלום בנייד",
    instruction_1: "היכנסו לאפליקציה ובצעו העברה על סך:",
    instruction_2: "את ההעברה שלחו למספר {0}",
    phone_hint: "לצורך אימות - מספר הטלפון ממנו בוצעה העברה",
    phone_label: "טלפון מעביר",
    proceed: "אישור תשלום",
    transfer_id: "מספר אישור העברה",
    transfer_id_hint: "מספר אישור העברה שמופיע באפליקציה לאחר ביצוע התשלום"
  },
  month: "חודש",
  morocco: "מרוקו",
  morocco_evisa: "מרוקו eVisa",
  morocco_page: {
    faq: [
      {
        a: "<p>לאחר מילוי והגשת טופס הוויזה המקוון באתר האינטרנט שלנו, אנו נעבד את בקשתך ונשלח אותה למשרד ההגירה הראשי של מרוקו, המטפל בויזות אלקטרוניות מכל רחבי העולם. <br><br>לאחר 2-3 ימים הויזה האלקטרונית מאושרת ונשלחת ישירות לדוא\"ל שלך. מסמך זה מהווה אישור רשמי להיכנס ולבקר במרוקו. <br><br>מכאן והלאה, כל שעליכם לעשות הוא להדפיס את הוויזה, לשמור אותה בהישג יד ולהציג אותה כשתתבקשו לעשות זאת בעת הצ'ק-אין לטיסה, ולאחר מכן עם הנחיתה במרוקו. <br>בתמורה תקבל (ללא תשלום נוסף) חותמת רשמית בדרכון שלך המאפשרת לך להיכנס ולהישאר במרוקו למשך חודש. </p>",
        q: "כיצד פועל תהליך הנפקת ויזה אלקטרונית למרוקו?"
      },
      {
        a: "<p>הויזה למרוקו מתקבלת תוך 2-3 ימי עסקים, תלוי בסוג הוויזה שרכשת: <br> • ויזה אלקטרונית רגילה למשך 30 יום מתקבלת תוך 2-3 ימים במרוקו. <br>• ויזה אלקטרונית דחופה מתקבלת בתוך יום עסקים אחד במרוקו. אתה יכול לקבל את הויזה האלקטרונית הדחופה באותו יום, אם אתה מזמין עד הצהריים (ביום עסקים). </p>",
        q: "כמה זמן לוקח לקבל ויזה אלקטרונית למרוקו?"
      },
      {
        a: "<p>-לא. התשלום באתר שלנו הוא שלם, סופי וכולל את כל העמלות, המסים והעמלות לממשלת מרוקו. </p>",
        q: "האם יש תשלום נוסף עבור הוויזה במרוקו?"
      },
      {
        a: "<p>אם אינך אזרח אירופה או ארה\"ב או מרוקו, אתה זקוק לויזה אלקטרונית כדי להיכנס למרוקו. </p>",
        q: "מי צריך ויזה למרוקו?"
      },
      {
        a: "לאחר שהונפקה לך ויזה אלקטרונית למרוקו והיא נשלחה לדוא\"ל שלך, תוכל להיכנס למרוקו במהלך 180 הימים הבאים.",
        q: "לכמה זמן תקפה הוויזה האלקטרונית למרוקו?"
      },
      {
        a: "ויזה אלקטרונית למשך 30 יום מאפשרת כניסה אחת בלבד למרוקו. מה שהופך אותה לויזה חד פעמית.",
        q: "כמה פעמים מותר לך להיכנס למרוקו עם אותה ויזה?"
      },
      {
        a: "כן. מיולי 2022 ניתן להנפיק ויזה אלקטרונית למרוקו למטרות תיירות ו/או עסקיות.",
        q: "האם ניתן להוציא ויזה למרוקו לאחר פרוץ מגיפת ה- COVID?"
      },
      {
        a: "כן. כל אדם שאינו אזרח מרוקו חייב להיות בעל ויזה אלקטרונית כדי להיכנס לגבולות המדינה, כולל ילדים בגילאי 0-18. בעזרתנו תוכלו להנפיק ויזה אלקטרונית לילדכם בשילוב עם הזמנת הויזה שלכם, והכל בטופס מקוון קצר ונוח.",
        q: "האם ילדים זקוקים לויזה כדי להיכנס למרוקו?"
      },
      {
        a: "<p>המינימום הנדרש על ידי ממשלת מרוקו הוא 3 ימים לפני תאריך הטיסה שלך. <br>כדי להיות בצד הבטוח, אנו ממליצים למלא את הטופס לפחות שבוע לפני הטיסה, אך מותר לעשות זאת עד 3 ימים לפני מועד הטיסה שלך. <br><strong>אם הטיסה שלך היא בעוד יומיים או פחות, אתה יכול להנפיק ויזה דחופה באתר שלנו, שתהיה מוכנה למחרת (או תוך מספר שעות, להזמנות מוקדמות במהלך ימי העבודה) </strong> </p>",
        q: "כמה זמן לפני הנסיעה עלי להנפיק ויזה למרוקו?"
      },
      {
        a: "לא. משרד החוץ של מרוקו אינו מאפשר הארכה. עם זאת, בהחלט ניתן להנפיק ויזה אלקטרונית נוספת מיד לאחר תום הויזה הקודמת.",
        q: "האם ניתן להאריך את תוקפו של ויזה אלקטרונית למרוקו?"
      },
      {
        a: "לא. עליך לעזוב את גבולות המדינה ולהיכנס רק לאחר שהנפקת ויזה אלקטרונית חדשה.",
        q: "האם ניתן להנפיק ויזה אלקטרונית חדשה בזמן שאני במרוקו?"
      },
      {
        a: "כניסתך למרוקו עם הויזה האלקטרונית שהונפקה לך חייבת להיות אווירית (במטוס) או בים (באונייה).",
        q: "האם אוכל להיכנס למרוקו בים/יבשה באמצעות הוויזה האלקטרונית?"
      },
      {
        a: "גם הוויזה המסורתית וגם הוויזה האלקטרונית הם מסמכים שמטרתם לאשר את כניסתך והשהייה במרוקו. הוויזה האלקטרונית הומצאה על מנת להקל על חייכם - אין צורך לשלוח מסמכים פיזית, להגיע לשגרירות ולחכות שבועות לתשובה ולקבל את הדרכון בחזרה - באתר שלנו התהליך כולו מתבצע באופן מקוון, באנגלית פשוטה וללא צורך לצאת מהבית, באמצעות טופס מקוון קצר. בדרך זו אתה יכול לקבל ויזה תוך 2-3 ימים בלבד.",
        q: "מה ההבדל בין ויזה אלקטרונית לויזה רגילה?"
      }
    ],
    meta_desc: "Get your Morocco eVisa in 2-3 days by filling out a short online form in English. Official visa to Morocco in {currentYear} without visiting an embassy",
    title: "eVisa to Morocco - Quick Online Application {currentYear} {'|'} Visanet"
  },
  mother_country: "ארץ הלידה של האם",
  mother_name: "שם אמא",
  msg_contact: "הודעה - צור קשר",
  nationality: "לאום",
  nav: {
    cta_bahrain: "קבל את הוויזה האלקטרונית שלך לבחריין",
    cta_cambodia: "קבל את הוויזה האלקטרונית שלך לקמבודיה",
    cta_canada: "קבל את eTA שלך בקנדה",
    cta_home: "התחל את היישום שלך",
    cta_india: "קבל את הויזה האלקטרונית שלך להודו",
    cta_indonesia: "קבל את הוויזה האלקטרונית שלך באינדונזיה",
    cta_israel: "קבל את ה- ETA-IL שלך",
    cta_korea: "קבל את ה- K-ETA שלך",
    cta_morocco: "קבל את הוויזה האלקטרונית שלך למרוקו",
    cta_new_zealand: "קבל את ה- NZeTA שלך",
    cta_saudi_arabia: "קבל את הוויזה האלקטרונית של ערב הסעודית",
    cta_sri_lanka: "קבל את הויזה האלקטרונית שלך לסרי לנקה",
    cta_thailand: "Get Your Thailand eVisa",
    cta_togo: "Get Your Togo eVisa",
    cta_uk: "קבל את ETA בבריטניה",
    cta_usa: "קבל את ה- ESTA שלך",
    cta_vietnam: "קבל את הוויזה האלקטרונית שלך בווייטנאם",
    visa_country_select: {
      label: "הויזות שלנו",
      option_bahrain: "ויזה אלקטרונית בחריין",
      option_cambodia: "ויזה אלקטרונית בקמבודיה",
      option_canada: "קנדה eTA",
      option_india: "ויזה אלקטרונית בהודו",
      option_indonesia: "ויזה אלקטרונית של אינדונזיה",
      option_israel: "ישראל ETA-IL",
      option_korea: "דרום קוריאה K-ETA",
      option_morocco: "מרוקו eVisa",
      option_new_zealand: "ניו זילנד NZeTA",
      option_saudi_arabia: "ערב הסעודית eVisa",
      option_sri_lanka: "ויזה אלקטרונית של סרי לנקה",
      option_thailand: "Thailand eVisa",
      option_togo: "Togo eVisa",
      option_uk: "בריטניה ו",
      option_usa: "ארה\"ב זה",
      option_vietnam: "ויזה אלקטרונית בווייטנאם"
    }
  },
  "new": "חדש",
  new_zealand: "ניו זילנד",
  new_zealand_evisa: "ניו זילנד eTA - NZeTA",
  new_zealand_page: {
    faq: [
      {
        a: "<p>• א <b> שרת כניסה ל- NZeTA לניו זילנד </b> <br> אם ברצונך להיכנס לניו זילנד למטרות תיירות ו/או לימודים לטווח קצר, עליך להנפיק אשרת כניסה ל- NZeTA לניו זילנד. אתה יכול לעשות זאת ישירות באתר שלנו במחיר של {price} <br> אשרת הכניסה לניו זילנד תקפה לשנתיים ומאפשרת לך להיכנס, לנסוע ולהיכנס מחדש לניו זילנד במהלך השנתיים הללו. <br>• <b> אשרת מעבר (חיבור) לניו זילנד </b> <br> אם אתה עובר דרך ניו זילנד בחיבור - כלומר בדרכך ליעד אחר ולא תישאר במדינה, אתה צריך אשרת מעבר. הנפקת אשרת מעבר לניו זילנד דומה להנפקת אשרת כניסה, אך זהו מסמך אחר שנותן לך הרשאות אחרות - או נכון יותר: הגבלות. <br>• אשרת מעבר לניו זילנד מאפשרת לך לעבור בשדה התעופה הבינלאומי באוקלנד. <br>• בזמן השהייה בשדה התעופה, אינך יכול לעזוב את אזור החיבור. <br>• משך השהייה בשדה התעופה מוגבל ל -24 שעות. <br>• עליך להחזיק כרטיס טיסה מניו זילנד, המתוכנן ל -24 השעות הבאות מההגעה. <br>• אינך יכול להגיש בקשות ויזה לניו זילנד במהלך שהותך בשדה התעופה. </p>",
        q: "מה ההבדל בין אשרת כניסה לאשרת מעבר לניו זילנד?"
      },
      {
        a: "עלות הנפקת אשרת תייר לניו זילנד באתר האינטרנט שלנו היא{price}.",
        q: "מה המחיר של NZeTA (ויזה אלקטרונית לניו זילנד)?"
      },
      {
        a: "<p>אשרת כניסה/מעבר של NZeTA לניו זילנד מוכנה תוך 1-2 ימים. <br>במקרים דחופים ניתן לקבל טיפול דחוף ואישור ויזה באותו יום/למחרת. </p>",
        q: "כמה זמן לוקח לקבל את אישור הוויזה האלקטרונית לניו זילנד?"
      },
      {
        a: "<p>לאחר הגשת טופס ה- NZeTA הקצר המקוון באתר שלנו, נעבד את בקשתך ונשלח אותה למשרד ההגירה הראשי של ניו זילנד, המטפל בבקשות לוויזות כניסה/מעבר אלקטרוניות מכל רחבי העולם. <br>לאחר 1-2 ימים הויזה האלקטרונית של NZeTA מאושרת ונשלחת ישירות לדוא\"ל שלך - מסמך זה הוא הרשאה רשמית להיכנס ולבקר בניו זילנד. זה הכל! </p>",
        q: "כיצד פועל תהליך הנפקת הוויזה האלקטרונית של NZeTA?"
      },
      {
        a: "כל אדם המעוניין לבקר בניו זילנד ו/או לעבור בשדה התעופה בניו זילנד חייב להנפיק כניסה/מעבר NZeTA.",
        q: "מי צריך ויזה אלקטרונית לניו זילנד?"
      },
      {
        a: "ויזה אלקטרונית של NZeTA לניו זילנד תקפה לשנתיים מרגע הנפקת הויזה האלקטרונית.",
        q: "כמה זמן תקפה אשרת הכניסה לניו זילנד?"
      },
      {
        a: "הויזה האלקטרונית של NZeTA מאפשרת כניסה ויציאה ללא הגבלה לניו זילנד. אתה יכול לבוא וללכת כרצונך.",
        q: "כמה פעמים מותר לך להיכנס לניו זילנד עם ה- NZeTA?"
      },
      {
        a: "אם רכשת אשרת כניסה (העלות באתר שלנו:{price}), התשובה היא <strong> לא. אין תשלום נוסף עבור דמי IVL, או כל תשלום נוסף אחר. המחיר באתר שלנו מלא וכולל את כל העמלות והעמלות. </strong><br>מצד שני, אם רכשת אשרת מעבר, ואתה מעוניין להיכנס לניו זילנד, תצטרך \"לשדרג\" את בקשתך על ידי תשלום דמי IVL המתבקשים מכל תייר ונגבים להגנת הטבע בניו זילנד.",
        q: "האם יש תשלום נוסף בניו זילנד עבור דמי IVL?"
      },
      {
        a: "<p>כדי לקבל ויזה אלקטרונית של NZeTA עליך לספק את פרטי הדרכון שלך ותמונה עדכנית של הפנים שלך. אתה יכול לצלם סלפי לתמונה זו. <br>לאחר מכן, כדי להיכנס לניו זילנד, תצטרך להציג כרטיס טיסה יוצא. </p>",
        q: "מה נדרש כדי להנפיק ויזה אלקטרונית לניו זילנד?"
      }
    ],
    meta_desc: "Get your New Zealand eVisa in 1-2 days by filling out a short online form in English. Official visa to New Zealand in {currentYear} without visiting an embassy",
    title: "NZeTA to New Zealand - Online Visa Application {currentYear} {'|'} Visanet"
  },
  next: "הבא",
  next_day: "למחרת",
  no: "לא",
  num_entries: "מספר כניסות:",
  occupation: "עיסוק",
  order_email_after_payment: "עם התשלום, אנו נשלח לך דוא\"ל המאשר את הזמנתך וקבלה לתשלום שלך.",
  order_summary: "Order Summary",
  other: "אחר",
  our_payment_methods: "זהו, טופס בקשת הוויזה שלך מוכן ונשמר במערכת! כדי לאשר את ההזמנה שלך, כל שנותר הוא לבצע תשלום מאובטח:",
  outside_country: "בחוץ {country}",
  page: {
    about: "אודותינו",
    contact: "צור קשר",
    country_flag: "דגל מדינה",
    features: {
      "1_body_bahrain": "טופס הבקשה eVisa מוגש ישירות באתר האינטרנט שלנו, ללא צורך בשליחה פיזית של מסמכים או הגעה לשגרירות. לאחר 3-5 ימים תקבל את ה- eVisa המאושרת שהזמנת ישירות לדוא\"ל שלך במחיר הנמוך ביותר.",
      "1_body_cambodia": "טופס הבקשה eVisa מוגש ישירות באתר האינטרנט שלנו, ללא צורך בשליחה פיזית של מסמכים או הגעה לשגרירות. לאחר 2-3 ימים תקבל את הויזה האלקטרונית המאושרת שהזמנת ישירות לדוא\"ל שלך במחיר הנמוך ביותר.",
      "1_body_canada": "טופס הבקשה eTA מוגש ישירות באתר האינטרנט שלנו, ללא צורך לשלוח מסמכים פיזית או להגיע לשגרירות. לאחר 1-2 ימים תקבל את ה- eTA המאושר שהזמנת ישירות לדוא\"ל שלך במחיר הנמוך ביותר.",
      "1_body_home": "הגש בקשה ל- eVisa שלך מבלי לעזוב את הבית שלך. הטופס המקוון המאובטח שלנו מבטל את הצורך בשליחת מסמכים או ביקור בשגרירויות. תוך 1-3 ימים בלבד, ה- eVisa המאושר שלך יגיע ישירות לדוא\"ל שלך - נוח, במחיר סביר וללא טרחה.",
      "1_body_india": "הגש בקשה לביזה האלקטרונית שלך בהודו מבלי לעזוב את ביתך. הטופס המקוון המאובטח שלנו מבטל את הצורך בשליחת מסמכים או ביקור בשגרירויות. תוך 1-3 ימים בלבד, ה- eVisa המאושר שלך יגיע ישירות לדוא\"ל שלך - מהיר, נוח וללא טרחה.",
      "1_body_indonesia": "טופס הבקשה eVisa מוגש ישירות באתר האינטרנט שלנו, ללא צורך בשליחה פיזית של מסמכים או הגעה לשגרירות. לאחר 1-3 ימים תקבל את ה- eVisa המאושרת שהזמנת ישירות לדוא\"ל שלך במחיר הנמוך ביותר.",
      "1_body_israel": "טופס הבקשה eTA מוגש ישירות באתר האינטרנט שלנו, ללא צורך לשלוח מסמכים פיזית או להגיע לשגרירות. לאחר 1-2 ימים תקבל את ה- eTA המאושר שהזמנת ישירות לדוא\"ל שלך במחיר הנמוך ביותר.",
      "1_body_korea": "טופס הבקשה K-ETA מוגש ישירות באתר האינטרנט שלנו, ללא צורך לשלוח מסמכים פיזית או להגיע לשגרירות. לאחר 1-3 ימים תקבל את ה- K-ETA המאושר שהזמנת ישירות לדוא\"ל שלך במחיר הנמוך ביותר.",
      "1_body_morocco": "טופס הבקשה eVisa מוגש ישירות באתר האינטרנט שלנו, ללא צורך בשליחה פיזית של מסמכים או הגעה לשגרירות. לאחר 1-3 ימים תקבל את ה- eVisa המאושרת שהזמנת ישירות לדוא\"ל שלך במחיר הנמוך ביותר.",
      "1_body_new_zealand": "טופס הבקשה של NZeTA מוגש ישירות באתר האינטרנט שלנו, ללא צורך לשלוח מסמכים פיזית או להגיע לשגרירות. לאחר 1-2 ימים תקבל את ה- nZeTA המאושר שהזמנת ישירות לדוא\"ל שלך במחיר הנמוך ביותר.",
      "1_body_saudi_arabia": "טופס הבקשה eVisa מוגש ישירות באתר האינטרנט שלנו, ללא צורך בשליחה פיזית של מסמכים או הגעה לשגרירות. לאחר 1-2 ימים תקבל את ה- eVisa המאושרת שהזמנת ישירות לדוא\"ל שלך במחיר הנמוך ביותר.",
      "1_body_sri_lanka": "טופס הבקשה eVisa מוגש ישירות באתר האינטרנט שלנו, ללא צורך בשליחה פיזית של מסמכים או הגעה לשגרירות. לאחר 1-2 ימים תקבל את ה- eVisa המאושרת שהזמנת ישירות לדוא\"ל שלך במחיר הנמוך ביותר.",
      "1_body_thailand": "No queues, no embassy visits — just a simple online form. Receive your approved eVisa directly in your inbox within days.",
      "1_body_togo": "No queues, no embassy visits — just a simple online form. Receive your approved eVisa directly in your inbox within days.",
      "1_body_uk": "טופס הבקשה ETA בבריטניה מוגש ישירות באתר האינטרנט שלנו, ללא צורך לשלוח מסמכים פיזית או להגיע לשגרירות. לאחר 1-3 ימים תקבל את ה- ETA המאושר שהזמנת ישירות לדוא\"ל שלך במחיר הנמוך ביותר.",
      "1_body_usa": "טופס הבקשה ל- ESTA מוגש ישירות באתר האינטרנט שלנו, ללא צורך לשלוח מסמכים פיזית או להגיע לשגרירות. לאחר 1-3 ימים תקבל את ה- ESTA המאושר שהזמנת ישירות לדוא\"ל שלך במחיר הנמוך ביותר.",
      "1_body_vietnam": "טופס הבקשה eVisa מוגש ישירות באתר האינטרנט שלנו, ללא צורך בשליחה פיזית של מסמכים או הגעה לשגרירות. לאחר 4-5 ימים תקבל את ה- eVisa המאושרת שהזמנת ישירות לדוא\"ל שלך במחיר הנמוך ביותר.",
      "1_title_bahrain": "A Quick and Streamlined Process",
      "1_title_cambodia": "A Quick and Streamlined Process",
      "1_title_canada": "A Quick, Streamlined Process",
      "1_title_home": "A Quick and Easy Process",
      "1_title_india": "A Quick and Easy Process",
      "1_title_indonesia": "A Quick and Streamlined Process",
      "1_title_israel": "A Quick, Streamlined Process",
      "1_title_korea": "A Quick, Streamlined Process",
      "1_title_morocco": "A Quick and Streamlined Process",
      "1_title_new_zealand": "A Quick, Streamlined Process",
      "1_title_saudi_arabia": "A Quick and Easy Process",
      "1_title_sri_lanka": "A Quick and Easy Process",
      "1_title_thailand": "A Quick, Streamlined Process",
      "1_title_togo": "A Quick, Streamlined Process",
      "1_title_uk": "A Quick, Streamlined Process",
      "1_title_usa": "A Quick, Streamlined Process",
      "1_title_vietnam": "A Quick and Easy Process",
      "2_body_bahrain": "Enjoy peace of mind knowing we stand firmly behind our service. If your application is denied, we’ll fix it or refund you entirely, no questions asked.",
      "2_body_cambodia": "Enjoy peace of mind knowing we stand firmly behind our service. If your application is denied, we’ll fix it or refund you entirely, no questions asked.",
      "2_body_canada": "Feel reassured knowing we stand behind our service. If your application is denied, we’ll correct it or refund you entirely.",
      "2_body_home": "תיהנו משקט נפשי עם התחייבות להחזר כספי שלנו. אם בקשתך נדחתה (תופעה נדירה), אנו ננפיק ויזה אלקטרונית חדשה ללא עלות נוספת או נחזיר את התשלום שלך במלואו - ללא שאלות.",
      "2_body_india": "Enjoy peace of mind with our money-back promise. If your application is denied, we’ll fix it or refund you — no questions asked.",
      "2_body_indonesia": "Enjoy peace of mind knowing we stand firmly behind our service. If your application is denied, we’ll fix it or refund you entirely, no questions asked.",
      "2_body_israel": "Feel reassured knowing we stand behind our service. If your application is denied, we’ll correct it or refund you entirely.",
      "2_body_korea": "Feel reassured knowing we stand behind our service. If your application is denied, we’ll correct it or refund you entirely.",
      "2_body_morocco": "Enjoy peace of mind knowing we stand firmly behind our service. If your application is denied, we’ll fix it or refund you entirely, no questions asked.",
      "2_body_new_zealand": "Feel reassured knowing we stand behind our service. If your application is denied, we’ll correct it or refund you entirely.",
      "2_body_saudi_arabia": "Enjoy peace of mind with our money-back promise. If your application is denied, we’ll fix it or refund you — no questions asked.",
      "2_body_sri_lanka": "Enjoy peace of mind with our money-back promise. If your application is denied, we’ll fix it or refund you — no questions asked.",
      "2_body_thailand": "Feel reassured knowing we stand behind our service. If your application is denied, we’ll correct it or refund you entirely — no questions asked.",
      "2_body_togo": "Feel reassured knowing we stand behind our service. If your application is denied, we’ll correct it or refund you entirely.",
      "2_body_uk": "Feel reassured knowing we stand behind our service. If your application is denied, we’ll correct it or refund you entirely.",
      "2_body_usa": "Feel reassured knowing we stand behind our service. If your application is denied, we’ll correct it or refund you entirely.",
      "2_body_vietnam": "Enjoy peace of mind with our money-back promise. If your application is denied, we’ll fix it or refund you — no questions asked.",
      "2_title_bahrain": "Success Guarantee or Full Refund",
      "2_title_cambodia": "Success Guarantee or Full Refund",
      "2_title_canada": "Success Guarantee or Full Refund",
      "2_title_home": "Guaranteed Peace of Mind",
      "2_title_india": "Success Guarantee or Full Refund",
      "2_title_indonesia": "Success Guarantee or Full Refund",
      "2_title_israel": "Success Guarantee or Full Refund",
      "2_title_korea": "Success Guarantee or Full Refund",
      "2_title_morocco": "Success Guarantee or Full Refund",
      "2_title_new_zealand": "Success Guarantee or Full Refund",
      "2_title_saudi_arabia": "Success Guarantee or Full Refund",
      "2_title_sri_lanka": "Success Guarantee or Full Refund",
      "2_title_thailand": "Success Guarantee or Full Refund",
      "2_title_togo": "Success Guarantee or Full Refund",
      "2_title_uk": "Success Guarantee or Full Refund",
      "2_title_usa": "Success Guarantee or Full Refund",
      "2_title_vietnam": "Success Guarantee or Full Refund",
      "3_body_bahrain": "מאז 2019, עזרנו לעשרות אלפי מטיילים להגיש מועמדות בהצלחה ל- eVisa בחריין. צוות המומחים שלנו זמין מסביב לשעון באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp </a></a>, <a href=\"{telegram}\"> טלגרם</a>, צ' <a href=\"mailto:{email}\" target=\"_blank\"> אט <a data-chat-opener> </a> חי, דוא\"ל ו <a href=\"tel:{phone}\"> טלפון </a> כדי לסייע לך בכל שלב בדרך.",
      "3_body_cambodia": "מאז 2019, עזרנו לעשרות אלפי מטיילים להגיש מועמדות בהצלחה לקבלת eVisa בקמבודיה. צוות המומחים שלנו זמין מסביב לשעון באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp </a></a>, <a href=\"{telegram}\"> טלגרם</a>, צ' <a href=\"mailto:{email}\" target=\"_blank\"> אט <a data-chat-opener> </a> חי, דוא\"ל ו <a href=\"tel:{phone}\"> טלפון </a> כדי לסייע לך בכל שלב בדרך.",
      "3_body_canada": "מאז 2019, עזרנו לעשרות אלפי מטיילים להגיש מועמדות בהצלחה עבור ETA בקנדה. צוות המומחים שלנו זמין מסביב לשעון באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp </a></a>, <a href=\"{telegram}\"> טלגרם</a>, צ' <a href=\"mailto:{email}\" target=\"_blank\"> אט <a data-chat-opener> </a> חי, דוא\"ל ו <a href=\"tel:{phone}\"> טלפון </a> כדי לסייע לך בכל שלב בדרך.",
      "3_body_home": "מאז 2019, עזרנו לעשרות אלפי נוסעים מרחבי העולם לקבל את הוויזה שלהם בקלות. צוות המומחים שלנו מעבד יישומים מסביב לשעון וזמין באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp </a></a>, <a href=\"{telegram}\"> Telegram, <a data-chat-opener> צ' </a> אט <a href=\"mailto:{email}\" target=\"_blank\"> חי</a>, דוא\"ל ו <a href=\"tel:{phone}\"> טלפון </a> כדי לסייע לך בכל שלב בדרך.",
      "3_body_india": "מאז 2019, עזרנו לעשרות אלפי מטיילים להגיש מועמדות בהצלחה ל- eVisa בהודו. צוות המומחים שלנו זמין מסביב לשעון באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp </a></a>, <a href=\"{telegram}\"> Telegram, <a data-chat-opener> צ' </a> אט <a href=\"mailto:{email}\" target=\"_blank\"> חי</a>, דוא\"ל ו <a href=\"tel:{phone}\"> טלפון </a> כדי לסייע לך בכל שלב בדרך.",
      "3_body_indonesia": "מאז 2019, עזרנו לעשרות אלפי מטיילים להגיש בקשה בהצלחה לוויזות אינדונזיה. צוות המומחים שלנו זמין מסביב לשעון באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp </a></a>, <a href=\"{telegram}\"> טלגרם</a>, צ' <a href=\"mailto:{email}\" target=\"_blank\"> אט <a data-chat-opener> </a> חי, דוא\"ל ו <a href=\"tel:{phone}\"> טלפון </a> כדי לסייע לך בכל שלב בדרך.",
      "3_body_israel": "מאז 2019 עזרנו לעשרות אלפי נוסעים להגיש מועמדות להצלחה עבור תעודת איל ישראלית. צוות המומחים שלנו זמין מסביב לשעון באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp </a></a>, <a href=\"{telegram}\"> Telegram, <a data-chat-opener> צ' </a> אט <a href=\"mailto:{email}\" target=\"_blank\"> חי</a>, דוא\"ל ו <a href=\"tel:{phone}\"> טלפון </a> כדי לסייע לך בכל שלב בדרך.",
      "3_body_korea": "מאז 2019, עזרנו לעשרות אלפי מטיילים להגיש מועמדות בהצלחה ל- KETA בדרום קוריאה. צוות המומחים שלנו זמין מסביב לשעון באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp </a></a>, <a href=\"{telegram}\"> Telegram, <a data-chat-opener> צ' </a> אט <a href=\"mailto:{email}\" target=\"_blank\"> חי</a>, דוא\"ל ו <a href=\"tel:{phone}\"> טלפון </a> כדי לסייע לך בכל שלב בדרך.",
      "3_body_morocco": "מאז 2019, עזרנו לעשרות אלפי מטיילים להגיש מועמדות בהצלחה ל- eVisa במרוקו. צוות המומחים שלנו זמין מסביב לשעון באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp </a></a>, <a href=\"{telegram}\"> טלגרם</a>, צ' <a href=\"mailto:{email}\" target=\"_blank\"> אט <a data-chat-opener> </a> חי, דוא\"ל ו <a href=\"tel:{phone}\"> טלפון </a> כדי לסייע לך בכל שלב בדרך.",
      "3_body_new_zealand": "מאז 2019, עזרנו לעשרות אלפי מטיילים להגיש מועמדות בהצלחה ל-NZETA בניו זילנד. צוות המומחים שלנו זמין מסביב לשעון באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp </a></a>, <a href=\"{telegram}\"> טלגרם</a>, צ' <a href=\"mailto:{email}\" target=\"_blank\"> אט <a data-chat-opener> </a> חי, דוא\"ל ו <a href=\"tel:{phone}\"> טלפון </a> כדי לסייע לך בכל שלב בדרך.",
      "3_body_saudi_arabia": "מאז 2019, עזרנו לעשרות אלפי מטיילים להגיש מועמדות בהצלחה ל- eVisa של ערב הסעודית. צוות המומחים שלנו זמין מסביב לשעון באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp </a></a>, <a href=\"{telegram}\"> טלגרם</a>, צ' <a href=\"mailto:{email}\" target=\"_blank\"> אט <a data-chat-opener> </a> חי, דוא\"ל ו <a href=\"tel:{phone}\"> טלפון </a> כדי לסייע לך בכל שלב בדרך.",
      "3_body_sri_lanka": "מאז 2019, עזרנו לעשרות אלפי מטיילים להגיש בקשה לויזות לסרי לנקה בהצלחה. צוות המומחים שלנו זמין מסביב לשעון באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp </a></a>, <a href=\"{telegram}\"> טלגרם</a>, צ' <a href=\"mailto:{email}\" target=\"_blank\"> אט <a data-chat-opener> </a> חי, דוא\"ל ו <a href=\"tel:{phone}\"> טלפון </a> כדי לסייע לך בכל שלב בדרך.",
      "3_body_thailand": "Since 2019, we’ve helped countless travelers secure their eVisas smoothly. Our multilingual team is ready to assist anytime via <a href=\"{whatsapp}\" target=\"_blank\">WhatsApp</a>, <a href=\"{telegram}\">Telegram</a>, <a data-chat-opener>live chat</a>, <a href=\"mailto:{email}\" target=\"_blank\">email</a>, and <a href=\"tel:{phone}\">phone</a>.",
      "3_body_togo": "Since 2019, we’ve helped countless travelers secure their eVisas smoothly. Our multilingual team is ready to assist anytime via <a href=\"{whatsapp}\" target=\"_blank\">WhatsApp</a>, <a href=\"{telegram}\">Telegram</a>, <a data-chat-opener>live chat</a>, <a href=\"mailto:{email}\" target=\"_blank\">email</a>, and <a href=\"tel:{phone}\">phone</a>.",
      "3_body_uk": "מאז 2019, עזרנו לעשרות אלפי מטיילים להגיש מועמדות בהצלחה עבור ETA בבריטניה. צוות המומחים שלנו זמין מסביב לשעון באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp </a></a>, <a href=\"{telegram}\"> טלגרם</a>, צ' <a href=\"mailto:{email}\" target=\"_blank\"> אט <a data-chat-opener> </a> חי, דוא\"ל ו <a href=\"tel:{phone}\"> טלפון </a> כדי לסייע לך בכל שלב בדרך.",
      "3_body_usa": "מאז 2019, עזרנו לעשרות אלפי מטיילים להגיש מועמדות בהצלחה ל- ESTA בארה\"ב. צוות המומחים שלנו זמין מסביב לשעון באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp </a></a>, <a href=\"{telegram}\"> טלגרם</a>, צ' <a href=\"mailto:{email}\" target=\"_blank\"> אט <a data-chat-opener> </a> חי, דוא\"ל ו <a href=\"tel:{phone}\"> טלפון </a> כדי לסייע לך בכל שלב בדרך.",
      "3_body_vietnam": "מאז 2019, עזרנו לעשרות אלפי מטיילים להגיש בקשה לויזת וייטנאם בהצלחה. צוות המומחים שלנו זמין מסביב לשעון באמצעות <a href=\"{whatsapp}\" target=\"_blank\"> WhatsApp </a></a>, <a href=\"{telegram}\"> טלגרם</a>, צ' <a href=\"mailto:{email}\" target=\"_blank\"> אט <a data-chat-opener> </a> חי, דוא\"ל ו <a href=\"tel:{phone}\"> טלפון </a> כדי לסייע לך בכל שלב בדרך.",
      "3_title_bahrain": "Expert, 24/7 Customer Care",
      "3_title_cambodia": "Expert, 24/7 Customer Care",
      "3_title_canada": "Professional 24/7 Customer Support",
      "3_title_home": "Dedicated Around-the-Clock Support",
      "3_title_india": "Professional 24/7 Customer Support",
      "3_title_indonesia": "Expert, 24/7 Customer Care",
      "3_title_israel": "Professional 24/7 Customer Support",
      "3_title_korea": "Professional 24/7 Customer Support",
      "3_title_morocco": "Expert, 24/7 Customer Care",
      "3_title_new_zealand": "Professional 24/7 Customer Support",
      "3_title_saudi_arabia": "Professional 24/7 Customer Support",
      "3_title_sri_lanka": "Professional 24/7 Customer Support",
      "3_title_thailand": "Professional 24/7 Customer Support",
      "3_title_togo": "Professional 24/7 Customer Support",
      "3_title_uk": "Professional 24/7 Customer Support",
      "3_title_usa": "Professional 24/7 Customer Support",
      "3_title_vietnam": "Professional 24/7 Customer Support",
      open_passports_img: "דרכונים פתוחים",
      socials_body_bahrain: "Need help, updates, or travel tips? <a href='/contact'>Reach out to us</a> or follow us on social media. We’re dedicated to making your journey effortless from start to finish.",
      socials_body_cambodia: "Need help, updates, or travel tips? <a href='/contact'>Reach out to us</a> or follow us on social media. We’re dedicated to making your journey effortless from start to finish.",
      socials_body_canada: "Need help or more info? <a href='/contact'>Get in touch</a> or follow us on social media to stay updated and make your travel planning even easier.",
      socials_body_home: "Questions, feedback, or travel tips? Connect with us on your favorite platform and let’s keep your journeys smooth.",
      socials_body_india: "Have a question or need help? <a href='/contact'>Reach out to us</a> or follow us on social media to stay informed.",
      socials_body_indonesia: "Need help, updates, or travel tips? <a href='/contact'>Reach out to us</a> or follow us on social media. We’re dedicated to making your journey effortless from start to finish.",
      socials_body_israel: "Need help or more info? <a href='/contact'>Get in touch</a> or follow us on social media to stay updated and make your travel planning even easier.",
      socials_body_korea: "Need help or more info? <a href='/contact'>Get in touch</a> or follow us on social media to stay updated and make your travel planning even easier.",
      socials_body_morocco: "Need help, updates, or travel tips? <a href='/contact'>Reach out to us</a> or follow us on social media. We’re dedicated to making your journey effortless from start to finish.",
      socials_body_new_zealand: "Need help or more info? <a href='/contact'>Get in touch</a> or follow us on social media to stay updated and make your travel planning even easier.",
      socials_body_saudi_arabia: "Have a question or need help? <a href='/contact'>Reach out to us</a> or follow us on social media to stay informed.",
      socials_body_sri_lanka: "Have a question or need help? <a href='/contact'>Reach out to us</a> or follow us on social media to stay informed.",
      socials_body_thailand: "Need help or more info? <a href='/contact'>Get in touch</a> or follow us on social media to stay updated and make your travel planning even easier.",
      socials_body_togo: "Need help or more info? <a href='/contact'>Get in touch</a> or follow us on social media to stay updated and make your travel planning even easier.",
      socials_body_uk: "Need help or more info? <a href='/contact'>Get in touch</a> or follow us on social media to stay updated and make your travel planning even easier.",
      socials_body_usa: "Need help or more info? <a href='/contact'>Get in touch</a> or follow us on social media to stay updated and make your travel planning even easier.",
      socials_body_vietnam: "Have a question or need help? <a href='/contact'>Reach out to us</a> or follow us on social media to stay informed.",
      why_evisa_desc_bahrain: "באתר שלנו תוכלו להגיש בקשה לוויזה אלקטרונית לבחריין ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 3-5 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, ולקבל את ה- eVisa הרשמית שלך לבחריין.",
      why_evisa_desc_cambodia: "באתר האינטרנט שלנו תוכלו להגיש בקשה לוויזה אלקטרונית לקמבודיה ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 2-3 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, ולקבל את הויזה האלקטרונית הרשמית שלך לקמבודיה, בתוקף למשך 30 יום.",
      why_evisa_desc_canada: "באתר האינטרנט שלנו תוכלו להגיש בקשה ל- eTA לקנדה ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 1-2 ימים בלבד. הגש טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים או לבקר בשגרירות, ולקבל את ה- eTA הרשמי שלך לקנדה, בתוקף למשך 5 שנים.",
      why_evisa_desc_home: "באתר האינטרנט שלנו תוכלו להגיש בקשה לויזה אלקטרונית למדינות שונות ולקבל את מכתב אישור הויזה שלכם למייל שלכם תוך מספר ימים. הגש טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, ולקבל את אשרת הכניסה הרשמית שלך.",
      why_evisa_desc_india: "באתר האינטרנט שלנו תוכלו להגיש בקשה ל- eVisa להודו ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 1-3 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, וקבל את ה- eVisa הרשמית שלך להודו, בתוקף בין 30 יום ל -5 שנים.",
      why_evisa_desc_indonesia: "באתר האינטרנט שלנו תוכלו להגיש בקשה ל- eVisa לאינדונזיה ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 1-3 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, ולקבל את ה- eVisa הרשמית שלך לאינדונזיה, תקפה למשך 60 יום.",
      why_evisa_desc_israel: "באתר האינטרנט שלנו תוכלו להגיש בקשה ל-ETA-IL לישראל ולקבל את מכתב האישור שלכם למייל שלכם תוך 1-2 ימים בלבד. הגש טופס מהיר וקל, מאובטח באינטרנט, ללא צורך בשליחת מסמכים פיזית או ביקור בשגרירות, וקבל אישור נסיעה אלקטרוני רשמי לישראל בתוקף לשנתיים.",
      why_evisa_desc_korea: "באתר שלנו אתה יכול להגיש בקשה ל- K-ETA לדרום קוריאה ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 1-3 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, ולקבל את ה- K-ETA הרשמי שלך לדרום קוריאה, בתוקף לשנתיים.",
      why_evisa_desc_morocco: "באתר האינטרנט שלנו תוכלו להגיש בקשה לוויזה אלקטרונית למרוקו ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 1-3 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים או לבקר בשגרירות, ולקבל את ה- eVisa הרשמית שלך למרוקו, בתוקף למשך 30 יום.",
      why_evisa_desc_new_zealand: "באתר האינטרנט שלנו תוכל להגיש בקשה ל- NZeTA לניו זילנד ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 1-2 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, ולקבל את ה- NZeTA הרשמי שלך לניו זילנד, בתוקף לשנתיים.",
      why_evisa_desc_saudi_arabia: "באתר האינטרנט שלנו תוכלו להגיש בקשה ל- eVisa לסעודיה ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 1-2 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, וקבל את ה- eVisa הרשמית שלך לסעודיה, בתוקף למשך 180 יום.",
      why_evisa_desc_sri_lanka: "באתר האינטרנט שלנו תוכלו להגיש בקשה ל- eVisa לסרי לנקה ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 1-2 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, וקבל את ה- eVisa הרשמית שלך לסרי לנקה, בתוקף למשך 30 יום.",
      why_evisa_desc_thailand: "On our website you can apply for an eVisa to Thailand and get your approval letter delivered to your email in just 1-3 days. Submit a quick & easy form, securely online, without the need to physically send any documents or visit the embassy, and get your official eVisa to Thailand, valid for 90 days to 5 years.",
      why_evisa_desc_togo: "On our website you can apply for an eVisa to Togo and get your approval letter delivered to your email in just 1-3 days. Submit a quick & easy form, securely online, without the need to physically send any documents or visit the embassy, and get your official eVisa to Togo, valid for 15 days to 90 days.",
      why_evisa_desc_uk: "באתר האינטרנט שלנו תוכל להגיש בקשה ל- ETA לבריטניה ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 1-3 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, ולקבל את ETA הרשמית שלך לבריטניה, בתוקף למשך 6 חודשים.",
      why_evisa_desc_usa: "באתר האינטרנט שלנו אתה יכול להגיש בקשה ל- ESTA לארה\"ב ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 1-3 ימים בלבד. הגש טופס מהיר וקל, מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים או לבקר בשגרירות, ולקבל את ה- ESTA הרשמית שלך לארה\"ב, בתוקף לשנתיים.",
      why_evisa_desc_vietnam: "באתר האינטרנט שלנו תוכלו להגיש בקשה לוויזה אלקטרונית לווייטנאם ולקבל את מכתב האישור שלך לדוא\"ל שלך תוך 4-5 ימים בלבד. שלח טופס מהיר וקל, באופן מאובטח באינטרנט, ללא צורך לשלוח פיזית מסמכים כלשהם או לבקר בשגרירות, וקבל את ה- eVisa הרשמית שלך לווייטנאם, בתוקף למשך 90 יום.",
      why_title_bahrain: "מדוע לקבל את הוויזה האלקטרונית שלך בבחריין באופן מקוון?",
      why_title_cambodia: "מדוע לקבל את הוויזה האלקטרונית שלך בקמבודיה באינטרנט?",
      why_title_canada: "מדוע לקבל את ETA קנדה שלך באינטרנט?",
      why_title_home: "למה לקבל את הוויזה שלך באינטרנט עם Visanet?",
      why_title_india: "מדוע לקבל את ה- eVisa שלך בהודו באינטרנט?",
      why_title_indonesia: "מדוע לקבל את ויזת אינדונזיה שלך באינטרנט?",
      why_title_israel: "למה להכניס את ה- ETA-IL לישראל שלך באינטרנט?",
      why_title_korea: "למה להשיג את ה- KETA של דרום קוריאה באינטרנט?",
      why_title_morocco: "מדוע לקבל את ה- eVisa שלך במרוקו באינטרנט?",
      why_title_new_zealand: "למה להשיג את ה- NZeTA שלך בניו זילנד באינטרנט?",
      why_title_saudi_arabia: "מדוע לקבל את האישור האלקטרוני שלך בערב הסעודית באינטרנט?",
      why_title_sri_lanka: "מדוע לקבל את ויזת סרי לנקה שלך באינטרנט?",
      why_title_thailand: "Why Get Your Visa to Thailand Online",
      why_title_togo: "Why Get Your Visa to Togo Online",
      why_title_uk: "Why Get Your Visa to UK Online",
      why_title_usa: "מדוע לקבל את ה- ESTA שלך בארה\"ב באופן מקוון?",
      why_title_vietnam: "מדוע לקבל את ויזת וייטנאם באופן מקוון?"
    },
    form_title_bahrain: "<span class='text-primary'>טופס ויזה אלקטרונית </span> בחריין",
    form_title_cambodia: "<span class='text-primary'>טופס ויזה אלקטרונית בק </span> מבודיה",
    form_title_canada: "<span class='text-primary'>טו </span> פס eTA קנדה",
    form_title_india: "<span class='text-primary'>טופס ויזה אלקטרונית ב </span> הודו",
    form_title_indonesia: "<span class='text-primary'>טופס ויזה אלקטרונית באינ </span> דונזיה",
    form_title_israel: "<span class='text-primary'>טופס ישראל ETA-IL </span>",
    form_title_korea: "<span class=\"text-primary\">טופס K-ETA </span> של דרום קוריאה",
    form_title_morocco: "<span class='text-primary'>טופס ויזה אלקטרונית </span> מרוקו",
    form_title_new_zealand: "<span class='text-primary'>טופס NZeTA של ניו </span> זילנד",
    form_title_saudi_arabia: "<span class='text-primary'>טופס ויזה אלקטרוני של ערב הסעודית </span>",
    form_title_sri_lanka: "<span class='text-primary'>טופס ויזה אלקטרונית בס </span> רי לנקה",
    form_title_thailand: "Thailand eVisa Form",
    form_title_togo: "Togo eVisa Form",
    form_title_uk: "<span class='text-primary'>טו </span> פס ETA בבריטניה",
    form_title_usa: "<span class='text-primary'>טו </span> פס ESTA בארה\"ב",
    form_title_vietnam: "<span class='text-primary'>טופס ויזה אלקטרונית בו </span> וייטנאם",
    get_visa_cta_bahrain: "קבל את הויזה האלקטרונית שלך בבחריין",
    get_visa_cta_cambodia: "קבל את הוויזה האלקטרונית שלך בקמבודיה",
    get_visa_cta_canada: "קבל את eTA שלך בקנדה",
    get_visa_cta_india: "קבל את הויזה האלקטרונית שלך בהודו",
    get_visa_cta_indonesia: "קבל את האישור האלקטרוני שלך באינדונזיה",
    get_visa_cta_israel: "קבל את ה- ETA-IL בישראל שלך",
    get_visa_cta_korea: "קבל את ה- K-ETA שלך בדרום קוריאה",
    get_visa_cta_morocco: "קבל את האישור האלקטרוני שלך במרוקו",
    get_visa_cta_new_zealand: "קבל את eTA שלך בניו זילנד",
    get_visa_cta_saudi_arabia: "קבל את האישור האלקטרוני שלך בערב הסעודית",
    get_visa_cta_sri_lanka: "קבל את הוויזה האלקטרונית שלך בסרי לנקה",
    get_visa_cta_thailand: "Get Your Thailand eVisa",
    get_visa_cta_togo: "Get Your Togo eVisa",
    get_visa_cta_uk: "קבל את ETA בבריטניה",
    get_visa_cta_usa: "קבל את ה- ESTA שלך בארצות הברית",
    get_visa_cta_vietnam: "קבל את הוויזה האלקטרונית שלך בווייטנאם",
    hero_body_bahrain: "הגש בקשה מקוונת דרך הפלטפורמה המאובטחת שלנו כדי לקבל את הוויזה האלקטרונית הרשמית שלך לבחריין ישירות לדוא\"ל שלך. הימנע מביקור בשגרירות ומניירת ממושכת עם תהליך מהיר ואמין המגובה באחריות ההצלחה של 100% שלנו. צוות התמיכה שלנו 24/7 נמצא כאן כדי להבטיח שהכל יתנהל בצורה חלקה.",
    hero_body_cambodia: "הגש בקשה מקוונת באמצעות הטופס המאובטח שלנו כדי לקבל את הוויזה הרשמית שלך לקמבודיה שנמסרת ישירות לדוא\"ל שלך. דלג על ביקורים בשגרירות והימנע מניירת מסובכת עם תהליך מהיר ואמין המגובה באחריות ההצלחה של 100% שלנו. צוות התמיכה שלנו 24/7 נמצא כאן כדי לסייע לך בכל שלב של הדרך.",
    hero_body_canada: "הגש בקשה מקוונת באמצעות הטופס המאובטח שלנו כדי לקבל את אשרת ה- eTA הרשמית שלך לקנדה ישירות בדוא\"ל שלך. אין צורך בביקורים בשגרירות או בניירת - רק תהליך מהיר ומאובטח המגובה באחריות להצלחה של 100%. צוות התמיכה שלנו 24/7 תמיד כאן כדי לעזור.",
    hero_body_india: "הגש בקשה מקוונת באמצעות טופס פשוט וקבל את הוויזה האלקטרונית הרשמית שלך להודו ישירות בדוא\"ל שלך. אין צורך בביקורי שגרירות או ניירת מייגעת. אנו מבטיחים 100% הצלחה או החזר כספך, עם תמיכה 24/7 מוכנה לסייע לך.",
    hero_body_indonesia: "הגש בקשה מקוונת באמצעות הטופס המאובטח שלנו כדי לקבל את ה- eVisa הרשמית שלך לאינדונזיה ותיהנה מנסיעות חלקות לבאלי. אין צורך בביקורים בשגרירות או בניירת - רק תהליך מהיר ואמין המגובה באחריות להצלחה של 100%. צוות התמיכה שלנו 24/7 תמיד מוכן לסייע.",
    hero_body_israel: "הגש בקשה מקוונת באמצעות הטופס המאובטח שלנו כדי לקבל את אשרת ה- ETA הרשמית שלך לישראל ישירות בדוא\"ל שלך. דלג על ביקורים בשגרירות ועל ניירת מסובכת עם תהליך מהיר ואמין המגובה באחריות ההצלחה של 100% שלנו. צוות התמיכה שלנו 24/7 תמיד מוכן לסייע.",
    hero_body_korea: "הגש בקשה מקוונת באמצעות הטופס המאובטח שלנו כדי לקבל את אשרת ה- K-ETA הרשמית שלך לדרום קוריאה ישירות בדוא\"ל שלך. אין צורך בביקורים בשגרירות או בניירת - רק תהליך מהיר ואמין המגובה באחריות להצלחה של 100%. צוות התמיכה שלנו 24/7 תמיד כאן כדי לעזור.",
    hero_body_morocco: "הגש בקשה מקוונת באמצעות הטופס המאובטח שלנו כדי לקבל את הוויזה האלקטרונית הרשמית שלך למרוקו ישירות בדוא\"ל שלך. דלג על ביקורי שגרירות וניירת ממושכת עם תהליך מהיר ואמין המגובה באחריות ההצלחה של 100% שלנו. צוות התמיכה שלנו 24/7 נמצא כאן כדי לסייע לך בכל שלב של הדרך.",
    hero_body_new_zealand: "הגש בקשה מקוונת באמצעות הטופס המאובטח שלנו כדי לקבל את אשרת ה- NZeTA הרשמית שלך לניו זילנד ישירות לדוא\"ל שלך. הימנע מביקור בשגרירות ומניירת מסובכת עם תהליך מהיר ואמין המגובה באחריות הצלחה של 100%. צוות התמיכה שלנו 24/7 מוכן לסייע בכל שלב.",
    hero_body_saudi_arabia: "הגש בקשה מקוונת באמצעות הטופס המאובטח שלנו כדי לקבל את האישור האלקטרוני הרשמי שלך לסעודיה ישירות בדוא\"ל שלך. דלג על ביקורים בשגרירות והימנע מטרדות בניירת באמצעות תהליך מהיר ואמין המגובה באחריות להצלחה של 100%. צוות התמיכה שלנו 24/7 נמצא כאן כדי לסייע לך בכל שלב של הדרך.",
    hero_body_sri_lanka: "הגש בקשה מקוונת באמצעות הטופס המאובטח שלנו כדי לקבל את ה- eVisa הרשמית שלך לסרי לנקה שנמסר ישירות לדוא\"ל שלך. הימנע מביקור בשגרירות ומניירת ממושכת עם תהליך מהיר ואמין המגובה באחריות ההצלחה של 100% שלנו. צוות התמיכה שלנו 24/7 תמיד מוכן לסייע.",
    hero_body_thailand: "Apply online in minutes for your official eVisa to Thailand—no embassy visits or tedious paperwork. With 24/7 support, 100% success guarantee, and direct email delivery, we make your journey to Thailand stress-free.",
    hero_body_togo: "Apply online in minutes and receive your official visa to Togo right in your inbox—no embassy visits, no hassle. With 24/7 support and a 100% success guarantee, we make starting your Togo adventure as simple as possible.",
    hero_body_uk: "Your UK ETA covers England, Wales, Scotland, and Northern Ireland. Apply online in minutes and get your approval by email—no embassy visits, no hassle. With 24/7 support and a 100% success guarantee, travel is worry-free.",
    hero_body_usa: "הגש בקשה מקוונת באמצעות הטופס המאובטח שלנו כדי לקבל את אשרת ESTA הרשמית שלך לארצות הברית ישירות בדוא\"ל שלך. דלג על ביקורים בשגרירות והימנע מניירת באמצעות תהליך מהיר ואמין המגובה באחריות להצלחה של 100%. צוות התמיכה שלנו 24/7 מוכן לסייע לך בכל שלב של הדרך.",
    hero_body_vietnam: "הגש בקשה מקוונת באמצעות הטופס המאובטח שלנו כדי לקבל את ה- eVisa הרשמיים שלך ו- VOA עבור וייטנאם ישירות בדוא\"ל שלך. דלג על ביקורים בשגרירות והימנע מטרדות בניירת באמצעות תהליך מהיר ואמין המגובה באחריות להצלחה של 100%. צוות התמיכה שלנו 24/7 נמצא כאן כדי לסייע לך בכל שלב של הדרך.",
    hero_header_bahrain: "ויזה אלקטרונית בחריין",
    hero_header_cambodia: "ויזה אלקטרונית בקמבודיה",
    hero_header_canada: "קנדה eTA",
    hero_header_home: "ויזות <span class='text-primary'> קלות, נסי </span> עות ללא גב <span class='text-primary'> ולות </span>",
    hero_header_india: "ויזה אלקטרונית בהודו",
    hero_header_indonesia: "ויזה אלקטרונית של אינדונזיה",
    hero_header_israel: "ויזה לישראל ETA-IL",
    hero_header_korea: "דרום קוריאה K-ETA",
    hero_header_morocco: "מרוקו eVisa",
    hero_header_new_zealand: "ניו זילנד NZeTA",
    hero_header_saudi_arabia: "ערב הסעודית eVisa",
    hero_header_sri_lanka: "ויזה אלקטרונית של סרי לנקה",
    hero_header_thailand: "Thailand eVisa",
    hero_header_togo: "Togo eVisa",
    hero_header_uk: "בריטניה ו",
    hero_header_usa: "ESTA של ארצות הברית",
    hero_header_vietnam: "ויזה אלקטרונית בווייטנאם",
    hero_price: "עלות:",
    hero_processing: "זמן עיבוד:",
    hero_sub: "ברוכים הבאים ל <a href=\"{baseUrl}\"> - Visanet </a> - השותף הגלובלי המהימן שלך לוויזות אלקטרוניות. הגש בקשה מקוונת בקלות, במהירות וביטחון באמצעות התהליך הפשוט והמשתלם שלנו. בין אם מדובר בבקשות דחופות או לטיולים מתוכננים, הצוות המסור שלנו 24/7 מבטיח אחוזי הצלחה של 100% או החזר כספי, והכל מבלי לבקר בשגרירות.",
    hero_sub_bahrain: "נסיעות לבחריין הופכות לפשוטות",
    hero_sub_cambodia: "קבל את הוויזה האלקטרונית שלך לקמבודיה בקלות",
    hero_sub_canada: "קבל את אשרת ה- eTA שלך לקנדה בקלות",
    hero_sub_india: "קבל את הויזה שלך להודו במהירות",
    hero_sub_indonesia: "קבל את הוויזה שלך לבאלי אינדונזיה בקלות",
    hero_sub_israel: "קבל את אשרת ה- ETA שלך לישראל במהירות",
    hero_sub_korea: "קבל את אשרת ה- KETA שלך לקוריאה בקלות",
    hero_sub_morocco: "קבל את הוויזה האלקטרונית שלך למרוקו בקלות",
    hero_sub_new_zealand: "הוויזה שלך לניו זילנד, פשוטה",
    hero_sub_saudi_arabia: "קבל את הוויזה שלך לסעודיה במהירות",
    hero_sub_sri_lanka: "נסיעות לסרי לנקה הופכות לפשוטות",
    hero_sub_thailand: "Get Your Thailand eVisa Quickly",
    hero_sub_togo: "Get Your Togo eVisa with Ease",
    hero_sub_uk: "קבל את ETA שלך לבריטניה במהירות",
    hero_sub_usa: "קבל את ה- ESTA שלך לארה\"ב במהירות",
    hero_sub_vietnam: "קבל את הוויזה שלך לווייטנאם במהירות",
    hero_video: "סרטון של חותמת ויזה Visanet בתוך דף הפתיחה של דרכון",
    how_it_works: "איך זה <span class='text-primary'> עובד </span>",
    language: "שפה",
    more_reviews: {
      body: "For additional customer reviews, visit us on:",
      title: "ראה את כל הביקורות שלנו"
    },
    pricing_card: {
      approved_within_bahrain: "אישור eVisa תוך 1-3 ימים",
      approved_within_cambodia: "אישור eVisa תוך 1-3 ימים",
      approved_within_canada: "ETA אושרה תוך 1-3 ימים",
      approved_within_india: "אישור eVisa תוך 1-3 ימים",
      approved_within_indonesia: "ויזה אושרה תוך 2-3 ימים",
      approved_within_israel: "ETA אושרה תוך 1-3 ימים",
      approved_within_korea: "KETA אושרה תוך 1-2 ימים",
      approved_within_morocco: "אישור eVisa תוך 2-3 ימים",
      approved_within_new_zealand: "NZeTA אושר תוך 1-3 ימים",
      approved_within_saudi_arabia: "ויזה אלקטרונית אושרה תוך 1-2 ימים",
      approved_within_sri_lanka: "ויזה אלקטרונית אושרה תוך 1-2 ימים",
      approved_within_thailand: "Visa approved within 3-21 days",
      approved_within_togo: "eVisa approved within 1-3 days",
      approved_within_uk: "אישור ETA בבריטניה תוך 1-3 ימים",
      approved_within_usa: "אישור ESTA תוך 1-3 ימים",
      approved_within_vietnam: "ויזה אושרה תוך 2-3 ימים",
      no_embassy: "אין צורך לבקר בשגרירות",
      online: "קבל אישור באינטרנט, ישירות מהבית",
      skip_voa: "דלג על קו VoA בשדה התעופה",
      support: "תמיכה מתמדת מתחילתו ועד סופו",
      urgent_option: "הזמנה אקספרס למקרים דחופים",
      valid_15_days_30_days_90_days: "Valid for 15 days, 30 days, or 90 days",
      valid_1_year_90_days_per_visit: "תקף לשנה אחת, 90 יום לביקור",
      valid_2_years: "Valid for 2 years",
      valid_2_years_90_days_per_visit: "תקף לשנתיים, 90 יום לביקור",
      valid_3_months_6_months_5_years: "Valid for 3 months, 6 months, or 5 years",
      valid_5_years_6_months_per_visit: "תקף למשך 5 שנים, 6 חודשים לביקור",
      valid_for_180_days: "Valid for 180 days",
      valid_for_2_weeks_3_months_or_more: "תקף לשבועיים, 3 חודשים או יותר",
      valid_for_30_days: "תקף למשך 30 יום",
      valid_for_30_days_90_days_1_year_stay: "תקף למשך 30 יום, 90 יום או שנה",
      valid_for_30_days_or_more: "תקף למשך 30 יום או יותר",
      valid_for_3_months: "תקף למשך 3 חודשים",
      valid_for_90_days: "תקף למשך 90 יום",
      valid_two_years_90_days_stay: "תקף לשנתיים, 90 ימי שהייה"
    },
    product_features: {
      cta: "Apply for Visa",
      img_bahrain: "קו הרקיע של בחריין, ויזה אלקטרונית בחריין",
      img_cambodia: "כפר בקמבודיה, קמבודיה eVisa",
      img_canada: "האגם וההר הקנדי, קנדה ETA",
      img_india: "מקדש גנגטוק, הודו eVisa",
      img_indonesia: "חתירה בבאלי, ויזה אינדונזיה",
      img_israel: "הגנים הבהאים בחיפה, ישראל ETA-IL",
      img_korea: "כפר האנוק, דרום קוריאה KETA",
      img_morocco: "אוארזאזאט, מרוקו eVisa",
      img_new_zealand: "ערוץ הוקיטיקה, ניו זילנד NZeTA",
      img_saudi_arabia: "נוף ערב הסעודית, ערב הסעודית eVisa",
      img_sri_lanka: "קו החוף, ויזת סרי לנקה",
      img_thailand: "Wat Chalong, Thailand Visa",
      img_togo: "Buddha statue, Togo Visa",
      img_uk: "Stonehenge, UK ETA",
      img_usa: "ניו יורק, ארה\"ב ESTA",
      img_vietnam: "הוי אן, וייטנאם ויזה",
      processing: "עיבוד",
      title_bahrain: "Visa to Bahrain",
      title_cambodia: "Visa to Cambodia",
      title_canada: "Visa to Canada",
      title_india: "Visa to India",
      title_indonesia: "Visa to Indonesia",
      title_israel: "Visa to Israel",
      title_korea: "Visa to South Korea",
      title_morocco: "Visa to Morocco",
      title_new_zealand: "Visa to New Zealand",
      title_saudi_arabia: "Visa to Saudi Arabia",
      title_sri_lanka: "Visa to Sri Lanka",
      title_thailand: "Visa to Thailand",
      title_togo: "Visa to Togo",
      title_uk: "Visa to the UK",
      title_usa: "Visa to the United States",
      title_vietnam: "Visa to Vietnam",
      validity: "תוקף:"
    },
    start_filling_form_bahrain: "התחל למלא את הטופס המקוון הפשוט שלנו עכשיו וקבל את אישור ה- eVisa שלך ונמסר לדוא\"ל שלך תוך 1-3 ימים.",
    start_filling_form_cambodia: "התחל למלא את הטופס המקוון הפשוט שלנו עכשיו וקבל את הוויזה האלקטרונית שלך לקמבודיה מאושרת ונמסרת לדוא\"ל שלך תוך 1-3 ימים.",
    start_filling_form_canada: "התחל למלא את הטופס המקוון הפשוט שלנו עכשיו וקבל את אישור ה- eTA שלך ונמסר לדוא\"ל שלך תוך 1-3 ימים.",
    start_filling_form_india: "התחל למלא את הטופס המקוון הפשוט שלנו עכשיו וקבל את ה- eVisa המאושרת שלך ישירות בדוא\"ל שלך תוך 1-3 ימים.",
    start_filling_form_indonesia: "התחל למלא את הטופס המקוון הפשוט שלנו עכשיו וקבל את אישור ה- eVisa שלך ונמסר לדוא\"ל שלך תוך 2-3 ימים.",
    start_filling_form_israel: "התחל למלא את הטופס המקוון הפשוט שלנו עכשיו וקבל אישור ויזה לישראל ונמסר לדוא\"ל שלך תוך 1-3 ימים.",
    start_filling_form_korea: "התחל למלא את הטופס המקוון הפשוט שלנו עכשיו וקבל את ה- K-ETA שלך מאושר ונמסר לדוא\"ל שלך תוך 1-2 ימים.",
    start_filling_form_morocco: "התחל למלא את הטופס המקוון הפשוט שלנו עכשיו וקבל את אישור ה- eVisa שלך ונמסר לדוא\"ל שלך תוך 2-3 ימים.",
    start_filling_form_new_zealand: "התחל למלא את הטופס המקוון הפשוט שלנו עכשיו וקבל את ה- NZeTA שלך מאושר ונמסר לדוא\"ל שלך תוך 1-3 ימים.",
    start_filling_form_saudi_arabia: "התחל למלא את הטופס המקוון הפשוט שלנו עכשיו וקבל את אישור ה- eVisa שלך ונמסר לדוא\"ל שלך תוך 1-2 ימים.",
    start_filling_form_sri_lanka: "התחל למלא את הטופס המקוון הפשוט שלנו עכשיו וקבל את אישור ה- eVisa שלך ונמסר לדוא\"ל שלך תוך 1-3 ימים.",
    start_filling_form_thailand: "Get started now, and you’ll receive your approved eVisa by email within 3-21 days. Experience easy, secure travel planning — begin your application today.",
    start_filling_form_togo: "Start your application today and receive your approved eVisa within 1-3 days. It’s time to explore the beauty of Togo without delays or headaches.",
    start_filling_form_uk: "התחל למלא את הטופס המקוון הפשוט שלנו עכשיו וקבל את אישור ה- eTA שלך ונמסר לדוא\"ל שלך תוך 1-3 ימים.",
    start_filling_form_usa: "התחל למלא את הטופס המקוון הפשוט שלנו עכשיו וקבל אישור ה- ESTA שלך ונמסר לדוא\"ל שלך תוך 1-3 ימים.",
    start_filling_form_vietnam: "התחל למלא את הטופס המקוון הפשוט שלנו עכשיו וקבל את אישור ה- eVisa שלך ונמסר לדוא\"ל שלך תוך 2-3 ימים.",
    steps: {
      "1_body_bahrain": "מילוי בקשת ה- <a href='#form'> eVisa שלך בבחריין </a> הוא מהיר ופשוט. מלא את הטופס המקוון המאובטח שלנו תוך 5-10 דקות בלבד עם פרטי הדרכון והתמונה שלך. אין צורך בשליחת מסמכים, יציאה מהבית או ביקור בשגרירות.",
      "1_body_cambodia": "מילוי בקשת ה- <a href='#form'> eVisa שלך בקמבודיה </a> הוא מהיר ופשוט. מלא את הטופס המקוון המאובטח שלנו תוך 5-10 דקות בלבד עם פרטי הדרכון והתמונה שלך. אין צורך בשליחת מסמכים, יציאה מהבית או ביקור בשגרירות.",
      "1_body_canada": "מילוי בקשת ה <a href='#form'> - ETA שלך בקנדה </a> הוא מהיר ופשוט. מלא את הטופס המקוון המאובטח שלנו תוך 5-10 דקות בלבד עם פרטי הדרכון והתמונה שלך. אין צורך בשליחת מסמכים, יציאה מהבית או ביקור בשגרירות.",
      "1_body_home": "מילוי בקשת ה- eVisa שלך הוא מהיר וקל. הטופס המקוון המאובטח שלנו לוקח 5-10 דקות בלבד למלא. כל שעליך לעשות הוא להכניס את פרטי הדרכון שלך (ולהעלות תמונה במידת הצורך) - אין צורך בשליחת מסמכים, יציאה מהבית או ביקור בשגרירות.",
      "1_body_india": "מילוי בקשת ה <a href='#form'> - eVisa שלך בהודו </a> הוא מהיר ופשוט. מלא את הטופס המקוון המאובטח שלנו תוך 5-10 דקות בלבד עם פרטי הדרכון והתמונה שלך. אין צורך בשליחת מסמכים, יציאה מהבית או ביקור בשגרירות.",
      "1_body_indonesia": "מילוי בקשת הוויזה שלך באינ <a href='#form'> דונזיה </a> הוא מהיר ופשוט. מלא את הטופס המקוון המאובטח שלנו תוך 5-10 דקות בלבד עם פרטי הדרכון והתמונה שלך. אין צורך בשליחת מסמכים, יציאה מהבית או ביקור בשגרירות.",
      "1_body_israel": "מילוי בקשת ETA-IL <a href='#form'> בישראל </a> הוא מהיר ופשוט. מלא את הטופס המקוון המאובטח שלנו תוך 5-10 דקות בלבד עם פרטי הדרכון והתמונה שלך. אין צורך בשליחת מסמכים, יציאה מהבית או ביקור בשגרירות.",
      "1_body_korea": "מילוי בקשת KETA שלך <a href='#form'> בדרום קוריאה </a> הוא מהיר ופשוט. מלא את הטופס המקוון המאובטח שלנו תוך 5-10 דקות בלבד עם פרטי הדרכון והתמונה שלך. אין צורך בשליחת מסמכים, יציאה מהבית או ביקור בשגרירות.",
      "1_body_morocco": "מילוי בקשת ה- <a href='#form'> eVisa שלך במרוקו </a> הוא מהיר ופשוט. מלא את הטופס המקוון המאובטח שלנו תוך 5-10 דקות בלבד עם פרטי הדרכון והתמונה שלך. אין צורך בשליחת מסמכים, יציאה מהבית או ביקור בשגרירות.",
      "1_body_new_zealand": "מילוי בקשת ה <a href='#form'> - NZeTA בניו זילנד </a> הוא מהיר ופשוט. מלא את הטופס המקוון המאובטח שלנו תוך 5-10 דקות בלבד עם פרטי הדרכון והתמונה שלך. אין צורך בשליחת מסמכים, יציאה מהבית או ביקור בשגרירות.",
      "1_body_saudi_arabia": "מילוי בקשת ה <a href='#form'> - eVisa שלך בערב הסעודית </a> הוא מהיר ופשוט. מלא את הטופס המקוון המאובטח שלנו תוך 5-10 דקות בלבד עם פרטי הדרכון והתמונה שלך. אין צורך בשליחת מסמכים, יציאה מהבית או ביקור בשגרירות.",
      "1_body_sri_lanka": "מילוי בקשת הוויזה שלך לס <a href='#form'> רי לנקה </a> הוא מהיר ופשוט. מלא את הטופס המקוון המאובטח שלנו תוך 5-10 דקות בלבד עם פרטי הדרכון והתמונה שלך. אין צורך בשליחת מסמכים, יציאה מהבית או ביקור בשגרירות.",
      "1_body_status": "Our team is available 24/7 to answer your questions.",
      "1_body_thailand": "Fill out <a href='#form'>our secure form</a> in just minutes — no need to submit physical documents or visit an office.",
      "1_body_togo": "Complete <a href='#form'>our secure application</a> in a few straightforward steps. No paperwork, no queues, and no leaving home.",
      "1_body_uk": "מילוי בקשת ה <a href='#form'> - ETA שלך בבריטניה </a> הוא מהיר ופשוט. מלא את הטופס המקוון המאובטח שלנו תוך 5-10 דקות בלבד עם פרטי הדרכון והתמונה שלך. אין צורך בשליחת מסמכים, יציאה מהבית או ביקור בשגרירות.",
      "1_body_usa": "מילוי בקשת ESTA לאר <a href='#form'> ה\"ב </a> הוא מהיר ופשוט. מלא את הטופס המקוון המאובטח שלנו תוך 5-10 דקות בלבד עם פרטי הדרכון והתמונה שלך. אין צורך בשליחת מסמכים, יציאה מהבית או ביקור בשגרירות.",
      "1_body_vietnam": "מילוי בקשת הוויזה שלך ל <a href='#form'> וייטנאם </a> הוא מהיר ופשוט. מלא את הטופס המקוון המאובטח שלנו תוך 5-10 דקות בלבד עם פרטי הדרכון והתמונה שלך. אין צורך בשליחת מסמכים, יציאה מהבית או ביקור בשגרירות.",
      "1_title_bahrain": "Fill Out the Online Form",
      "1_title_cambodia": "Fill Out the Online Form",
      "1_title_canada": "Complete the Online Form",
      "1_title_home": "מלא את הטופס המקוון",
      "1_title_india": "Fill Out the Online Form",
      "1_title_indonesia": "Fill Out the Online Form",
      "1_title_israel": "Complete the Online Form",
      "1_title_korea": "Fill Out the Online Form",
      "1_title_morocco": "Fill Out the Online Form",
      "1_title_new_zealand": "Complete the Online Form",
      "1_title_saudi_arabia": "Fill Out the Online Form",
      "1_title_sri_lanka": "Fill Out the Online Form",
      "1_title_status": "Support When You Need It",
      "1_title_thailand": "Complete the Online Form",
      "1_title_togo": "Fill Out the Online Form",
      "1_title_uk": "Complete the Online Form",
      "1_title_usa": "Complete the Online Form",
      "1_title_vietnam": "Complete the Online Form",
      "2_body_bahrain": "לאחר הגשתנו, אנו מעבדים מייד את בקשתך ושולחים בקשה רשמית למשרד ההגירה בחרייני מטעמך. האישור האלקטרוני שלך יאושר ויישלח אליך בדוא\"ל תוך 1-3 ימים.",
      "2_body_cambodia": "לאחר ההגשה, אנו מעבדים מייד את בקשתך ושולחים בקשה רשמית למשרד ההגירה הקמבודי מטעמך. האישור האלקטרוני שלך יאושר ויישלח אליך בדוא\"ל תוך 1-3 ימים.",
      "2_body_canada": "לאחר הגשתנו, אנו מעבדים מייד את בקשתך ושולחים בקשה רשמית למשרד ההגירה הקנדי בשמך. ה-ETA שלך יאושר ויישלח אליך בדוא\"ל תוך 1-3 ימים.",
      "2_body_home": "לאחר הגשת בקשתך, אנו מעבדים אותה באופן מיידי ונשלח בקשה רשמית לרשות ההגירה הרלוונטית מטעמך. האישורים נמשכים בדרך כלל 1-3 ימים ונשלחים ישירות לדוא\"ל שלך.",
      "2_body_india": "לאחר הגשתנו, אנו מעבדים מייד את בקשתך ושולחים בקשה רשמית למשרד ההגירה ההודי בשמך. האישור האלקטרוני שלך יאושר ויישלח אליך בדוא\"ל תוך 1-3 ימים.",
      "2_body_indonesia": "לאחר הגשתנו, אנו מעבדים מייד את בקשתך ושולחים בקשה רשמית למשרד ההגירה האינדונזי מטעמך. הויזה שלך תאושר ויישלח אליך בדוא\"ל תוך 2-3 ימים.",
      "2_body_israel": "לאחר הגשת הבקשה, אנו מעבדים מיד את בקשתך ושולחים בקשה רשמית למשרד ההגירה הישראלי מטעמך. ה- ETA-IL שלך יאושר ויישלח אליך בדוא\"ל תוך 1-3 ימים.",
      "2_body_korea": "לאחר הגשתנו, אנו מעבדים מייד את בקשתך ושולחים בקשה רשמית למשרד ההגירה של דרום קוריאה בשמך. ה- KETA שלך יאושר ויישלח אליך בדוא\"ל תוך 1-2 ימים.",
      "2_body_morocco": "לאחר הגשתנו, אנו מעבדים מייד את בקשתך ושולחים בקשה רשמית למשרד ההגירה המרוקאי בשמך. האישור האלקטרוני שלך יאושר ויישלח אליך בדוא\"ל תוך 2-3 ימים.",
      "2_body_new_zealand": "לאחר הגשתנו, אנו מעבדים מייד את בקשתך ושולחים בקשה רשמית למשרד ההגירה של ניו זילנד מטעמך. ה- NZeTA שלך יאושר ויישלח אליך בדוא\"ל תוך 1-3 ימים.",
      "2_body_saudi_arabia": "לאחר הגשתנו, אנו מעבדים מייד את בקשתך ושולחים בקשה רשמית למשרד ההגירה הסעודי מטעמך. האישור האלקטרוני שלך יאושר ויישלח אליך בדוא\"ל תוך 1-2 ימים.",
      "2_body_sri_lanka": "לאחר הגשתנו, אנו מעבדים מייד את בקשתך ושולחים בקשה רשמית למשרד ההגירה של סרי לנקה בשמך. הויזה שלך תאושר ויישלח אליך בדוא\"ל תוך 1-3 ימים.",
      "2_body_status": "Easily check your status anytime with just two details.",
      "2_body_thailand": "We handle the submission to the Thai authorities. Most eVisas are approved within 3-21 days (or faster for urgent requests).",
      "2_body_togo": "We securely submit your application to Togo authorities. Most eVisas are approved within 3 days and delivered straight to your inbox.",
      "2_body_uk": "לאחר ההגשה, אנו מעבדים מייד את בקשתך ושולחים בקשה רשמית למשרד ההגירה של בריטניה בשמך. ה-ETA שלך יאושר ויישלח אליך בדוא\"ל תוך 1-3 ימים.",
      "2_body_usa": "לאחר ההגשה, אנו מעבדים מייד את בקשתך ושולחים בקשה רשמית למשרד ההגירה של ארצות הברית מטעמך. ה- ESTA שלך יאושר ויישלח אליך בדוא\"ל תוך 1-3 ימים.",
      "2_body_vietnam": "לאחר הגשתנו, אנו מעבדים מייד את בקשתך ושולחים בקשה רשמית למשרד ההגירה הווייטנאמי מטעמך. הויזה שלך תאושר ויישלח אליך בדוא\"ל תוך 2-3 ימים.",
      "2_title_bahrain": "Get Your Approval",
      "2_title_cambodia": "Get Your Approval",
      "2_title_canada": "Receive Your Approval",
      "2_title_home": "Get Your Approval",
      "2_title_india": "Get Your Approval",
      "2_title_indonesia": "Get Your Approval",
      "2_title_israel": "Receive Your Approval",
      "2_title_korea": "Receive Your Approval",
      "2_title_morocco": "Get Your Approval",
      "2_title_new_zealand": "Receive Your Approval",
      "2_title_saudi_arabia": "Get Your Approval",
      "2_title_sri_lanka": "Get Your Approval",
      "2_title_status": "Seamless User Experience",
      "2_title_thailand": "Receive Your Approval",
      "2_title_togo": "Get Your Approval",
      "2_title_uk": "Receive Your Approval",
      "2_title_usa": "Receive Your Approval",
      "2_title_vietnam": "Get Your Approval",
      "3_body_bahrain": "הדפס את ה- eVisa המאושרת שלך וקח אותה איתך למסע שלך. בבקרת דרכונים תקבל חותמת רשמית בתמורה ל- eVisa שלך, המאפשרת לך להיכנס לבחריין ללא טרחה. זהו זה — תיהנו מהטיול שלכם!",
      "3_body_cambodia": "הדפס את ה- eVisa המאושרת שלך וקח אותה איתך למסע שלך. בבקרת דרכונים תקבל חותמת רשמית בתמורה ל- eVisa שלך, המאפשרת לך להיכנס לקמבודיה ללא טרחה. זהו זה — תהנו מהטיול שלכם!",
      "3_body_canada": "קח איתך את ה- ETA המאושר שלך למסע שלך. אין צורך להדפיס אותו, אתה יכול להציג אותו מהטלפון שלך בעת הצ'ק-אין ובבקרת דרכון. לאחר הצגת ETA שלך, תוכל לטוס לקנדה ללא טרחה. זהו זה — תיהנו מהטיול שלכם!",
      "3_body_home": "מזל טוב! הויזה האלקטרונית הרשמית שלך עם חתימה ממשלתית תגיע לתיבת הדואר הנכנס שלך. כל שנותר הוא להדפיס אותו, לארוז את התיקים וללכת לשדה התעופה. מסע טוב!",
      "3_body_india": "הדפס את ה- eVisa המאושרת שלך וקח אותה איתך למסע שלך. בבקרת דרכונים תקבל חותמת רשמית בתמורה ל- eVisa שלך, המאפשרת לך להיכנס להודו ללא טרחה. זהו זה — תהנו מהטיול שלכם!",
      "3_body_indonesia": "הדפס את הוויזה המאושרת שלך וקח אותה איתך למסע שלך. בבקרת דרכונים תקבל חותמת רשמית בתמורה לויזה שלך, המאפשרת לך להיכנס לאינדונזיה ללא טרחה. זהו זה — תיהנו מהטיול שלכם!",
      "3_body_israel": "קח איתך את ה- ETA-IL המאושר שלך למסע שלך. אין צורך להדפיס אותו, אתה יכול להציג אותו מהטלפון שלך בעת הצ'ק-אין ובבקרת דרכון. לאחר הצגת ה- ETA-IL שלך, תוכל לטוס לישראל ללא טרחה. זהו זה — תיהנו מהטיול שלכם!",
      "3_body_korea": "קח איתך את ה- KETA המאושר שלך למסע שלך. אין צורך להדפיס אותו, אתה יכול להציג אותו מהטלפון שלך בעת הצ'ק-אין ובבקרת דרכון. לאחר הצגת ה- KETA שלך, תוכל לטוס לדרום קוריאה ללא טרחה. זהו זה — תיהנו מהטיול שלכם!",
      "3_body_morocco": "הדפס את ה- eVisa המאושרת שלך וקח אותה איתך למסע שלך. בבקרת דרכונים תקבל חותמת רשמית בתמורה לביזה האלקטרונית שלך, המאפשרת לך להיכנס למרוקו ללא טרחה. זהו זה — תהנו מהטיול שלכם!",
      "3_body_new_zealand": "קח איתך את ה- NZeTA המאושר שלך למסע שלך. אין צורך להדפיס אותו, אתה יכול להציג אותו מהטלפון שלך בעת הצ'ק-אין ובבקרת דרכון. לאחר הצגת ה- NZeTA שלך, תוכל לטוס לניו זילנד ללא טרחה. זהו זה — תיהנו מהטיול שלכם!",
      "3_body_saudi_arabia": "הדפס את ה- eVisa המאושרת שלך וקח אותה איתך למסע שלך. בבקרת דרכונים תקבל חותמת רשמית בתמורה ל- eVisa שלך, המאפשרת לך להיכנס לסעודיה ללא טרחה. זהו זה — תהנו מהטיול שלכם!",
      "3_body_sri_lanka": "הדפס את ה- eVisa המאושרת שלך וקח אותה איתך למסע שלך. בבקרת דרכונים תקבל חותמת רשמית בתמורה ל- eVisa שלך, המאפשרת לך להיכנס לסרי לנקה ללא טרחה. זהו זה — תהנו מהטיול שלכם!",
      "3_body_status": "Receive your eVisa by email. Print it, bring it along, and breeze through passport control.",
      "3_body_thailand": "Print your approved eVisa and present it on arrival. Your entry is seamless, and you’re ready to enjoy your trip to Thailand.",
      "3_body_togo": "Print your approved eVisa and present it on arrival. Your entry is seamless, and you’re ready to enjoy your trip to Togo.",
      "3_body_uk": "קח איתך את ה- ETA המאושר שלך למסע שלך. אין צורך להדפיס אותו, אתה יכול להציג אותו מהטלפון שלך בעת הצ'ק-אין ובבקרת דרכון. לאחר הצגת ETA שלך, תוכל לטוס לבריטניה ללא טרחה. זהו זה — תהנו מהטיול שלכם!",
      "3_body_usa": "קח איתך את ה- ESTA המאושר שלך למסע שלך. אין צורך להדפיס אותו, אתה יכול להציג אותו מהטלפון שלך בעת הצ'ק-אין ובבקרת דרכון. לאחר הצגת ה- ESTA שלך, תוכל לטוס לארה\"ב ללא טרחה. זהו זה — תיהנו מהטיול שלכם!",
      "3_body_vietnam": "הדפס את הוויזה המאושרת שלך וקח אותה איתך למסע שלך. בבדיקת דרכונים תקבל חותמת רשמית בתמורה לויזה שלך, המאפשרת לך להיכנס לווייטנאם ללא טרחה. זהו זה — תהנו מהטיול שלכם!",
      "3_title_bahrain": "נסיעות לבחריין",
      "3_title_cambodia": "נסיעות לקמבודיה",
      "3_title_canada": "נסיעות לקנדה",
      "3_title_home": "הדפסה ונסיעות",
      "3_title_india": "נסיעות להודו",
      "3_title_indonesia": "נסיעות לאינדונזיה",
      "3_title_israel": "נסיעות לישראל",
      "3_title_korea": "נסיעות לדרום קוריאה",
      "3_title_morocco": "נסיעות למרוקו",
      "3_title_new_zealand": "נסיעות לניו זילנד",
      "3_title_saudi_arabia": "נסיעות לסעודיה",
      "3_title_sri_lanka": "נסיעות לסרי לנקה",
      "3_title_status": "Transparency You Can Trust",
      "3_title_thailand": "Travel to Thailand",
      "3_title_togo": "Travel to Togo",
      "3_title_uk": "נסיעות לבריטניה",
      "3_title_usa": "לנסוע לארה\"ב",
      "3_title_vietnam": "נסיעות לווייטנאם",
      cta_country_page: "Start eVisa Application",
      cta_home: "גלו יעדים",
      img_alt: "מחשב נייד פתוח עם כוס קפה על השולחן"
    },
    testimonials: {
      megaphone_img: "Megaphone Illustration",
      read_original: "Read the original review",
      title: "What Our Customers Say"
    },
    trust: {
      "1_alt": "סמל הגנת נעילה",
      "1_body": "הנתונים האישיים שלך מוגנים באמצעות הצפנת SSL 256 סיביות, מה שמבטיח תקשורת מאובטחת. אנו עומדים בסטנדרטים הבינלאומיים הגבוהים ביותר, ושומרים על המידע שלך כמו בנקים ואתרי אינטרנט ממשלתיים.",
      "1_body_bahrain": "We protect your personal details with top-tier encryption and international standards. Your data is handled as securely as in global banking or government systems.",
      "1_body_cambodia": "We protect your personal details with top-tier encryption and international standards. Your data is handled as securely as in global banking or government systems.",
      "1_body_canada": "Your info is encrypted with top-tier SSL and meets global compliance—just like major financial and government platforms.",
      "1_body_home": "Your info is encrypted with top-tier SSL and meets global compliance—just like major financial and government platforms.",
      "1_body_india": "We shield every detail with SSL encryption and global security standards—just like leading banks and government sites.",
      "1_body_indonesia": "We protect your personal details with top-tier encryption and international standards. Your data is handled as securely as in global banking or government systems.",
      "1_body_israel": "Your info is encrypted with top-tier SSL and meets global compliance—just like major financial and government platforms.",
      "1_body_korea": "Your info is encrypted with top-tier SSL and meets global compliance—just like major financial and government platforms.",
      "1_body_morocco": "We protect your personal details with top-tier encryption and international standards. Your data is handled as securely as in global banking or government systems.",
      "1_body_new_zealand": "We shield every detail with SSL encryption and global security standards—just like leading banks and government sites.",
      "1_body_saudi_arabia": "We shield every detail with SSL encryption and global security standards—just like leading banks and government sites.",
      "1_body_sri_lanka": "We shield every detail with SSL encryption and global security standards—just like leading banks and government sites.",
      "1_body_thailand": "We shield every detail with SSL encryption and global security standards—just like leading banks and government sites.",
      "1_body_togo": "We protect your personal details with top-tier encryption and international standards. Your data is handled as securely as in global banking or government systems.",
      "1_body_uk": "Your info is encrypted with top-tier SSL and meets global compliance—just like major financial and government platforms.",
      "1_body_usa": "We shield every detail with SSL encryption and global security standards—just like leading banks and government sites.",
      "1_body_vietnam": "We shield every detail with SSL encryption and global security standards—just like leading banks and government sites.",
      "1_title": "אתר מאובטח והגנה על נתונים",
      "2_alt": "שלט כסף בתוך סמל מגן",
      "2_body": "Travel with total confidence thanks to our money-back pledge. We’ll handle every detail, and if your application is denied, we’ll reapply free of charge or refund you in full—no hassle, no questions asked.",
      "2_body_bahrain": "אנו עומדים לצד השירות שלנו עם אחריות הצלחה של 100%. אם הויזה האלקטרונית שלך בחריין נדחתה או אם יש בעיה, אנו נגיש בקשה חוזרת בחינם או נחזיר את התשלום שלך במלואו - במהירות וללא טרחה.",
      "2_body_cambodia": "אנו עומדים לצד השירות שלנו עם אחריות הצלחה של 100%. אם הויזה האלקטרונית שלך בקמבודיה נדחתה או אם יש בעיה, אנו נגיש בקשה חוזרת בחינם או נחזיר את התשלום שלך במלואו - במהירות וללא טרחה.",
      "2_body_canada": "אנו עומדים לצד השירות שלנו עם אחריות הצלחה של 100%. אם ה- ETA שלך בקנדה נדחה או אם יש בעיה, אנו נגיש בקשה חוזרת בחינם או נחזיר את התשלום שלך במלואו - במהירות וללא טרחה.",
      "2_body_home": "אנו עומדים לצד השירות שלנו עם אחריות הצלחה של 100%. אם הויזה שלך נדחתה או אם יש בעיה, אנו נגיש בקשה חוזרת בחינם או נחזיר את התשלום שלך במלואו - במהירות וללא טרחה.",
      "2_body_india": "אנו עומדים לצד השירות שלנו עם אחריות הצלחה של 100%. אם הויזה האלקטרונית שלך בהודו נדחתה או אם יש בעיה, אנו נגיש בקשה חוזרת בחינם או נחזיר את התשלום שלך במלואו - במהירות וללא טרחה.",
      "2_body_indonesia": "אנו עומדים לצד השירות שלנו עם אחריות הצלחה של 100%. אם הויזה אינדונזית שלך נדחתה או אם יש בעיה, אנו נגיש בקשה חוזרת בחינם או נחזיר את התשלום שלך במלואו - במהירות וללא טרחה.",
      "2_body_israel": "אנו עומדים לצד השירות שלנו עם אחריות הצלחה של 100%. אם ה- ETA-IL שלך בישראל נדחה או אם יש בעיה, אנו נגיש בקשה חוזרת בחינם או נחזיר את התשלום שלך במלואו - במהירות וללא טרחה.",
      "2_body_korea": "אנו עומדים לצד השירות שלנו עם אחריות הצלחה של 100%. אם ה- KETA שלך בדרום קוריאה נדחה או שיש בעיה, אנו נגיש בקשה חוזרת בחינם או נחזיר את התשלום שלך במלואו - במהירות וללא טרחה.",
      "2_body_morocco": "אנו עומדים לצד השירות שלנו עם אחריות הצלחה של 100%. אם הויזה האלקטרונית שלך במרוקו נדחתה או אם יש בעיה, אנו נגיש בקשה חוזרת בחינם או נחזיר את התשלום שלך במלואו - במהירות וללא טרחה.",
      "2_body_new_zealand": "אנו עומדים לצד השירות שלנו עם אחריות הצלחה של 100%. אם ה- NZeTA שלך בניו זילנד נדחה או אם יש בעיה, אנו נגיש בקשה חוזרת בחינם או נחזיר את התשלום שלך במלואו - במהירות וללא טרחה.",
      "2_body_saudi_arabia": "אנו עומדים לצד השירות שלנו עם אחריות הצלחה של 100%. אם הויזה האלקטרונית שלך בערב הסעודית נדחתה או אם יש בעיה, אנו נגיש בקשה חוזרת בחינם או נחזיר את התשלום שלך במלואו - במהירות וללא טרחה.",
      "2_body_sri_lanka": "אנו עומדים לצד השירות שלנו עם אחריות הצלחה של 100%. אם הויזה שלך לסרי לנקה נדחתה או אם יש בעיה, אנו נגיש בקשה חוזרת בחינם או נחזיר את התשלום שלך במלואו - במהירות וללא טרחה.",
      "2_body_thailand": "If your eVisa is denied, we’ll reapply free or refund your entire payment—no questions asked.",
      "2_body_togo": "If your eVisa is denied, we’ll reapply free or refund your entire payment—no questions asked.",
      "2_body_uk": "אנו עומדים לצד השירות שלנו עם אחריות הצלחה של 100%. אם ה- ETA שלך בבריטניה נדחה או אם יש בעיה, אנו נגיש בקשה חוזרת בחינם או נחזיר את התשלום שלך במלואו - במהירות וללא טרחה.",
      "2_body_usa": "אנו עומדים לצד השירות שלנו עם אחריות הצלחה של 100%. אם ה- ESTA שלך בארה\"ב נדחה או אם יש בעיה, אנו נגיש בקשה חוזרת בחינם או נחזיר את התשלום שלך במלואו - במהירות וללא טרחה.",
      "2_body_vietnam": "אנו עומדים לצד השירות שלנו עם אחריות הצלחה של 100%. אם ויזת וייטנאם שלך נדחתה או אם יש בעיה, אנו נגיש בקשה חוזרת בחינם או נחזיר את התשלום שלך במלואו - במהירות וללא טרחה.",
      "2_title": "100% הצלחה או החזר כספי",
      "3_alt": "סמל כרטיס אשראי",
      "3_body": "We’ve guided tens of thousands of travelers worldwide since 2019. Our experts are on standby around the clock via <a href=\"{whatsapp}\" target=\"_blank\">WhatsApp</a>, <a data-chat-opener>chat</a>, <a href=\"mailto:{email}\" target=\"_blank\">email</a>, or <a href=\"tel:{phone}\">phone</a>—for updates follow us on <a href=\"{instagram}\" target=\"_blank\">Instagram</a>, and <a href=\"{facebook}\" target=\"_blank\">Facebook</a>.",
      "3_body_bahrain": "צוות המומחים שלנו זמין מסביב לשעון כדי לסייע ביישום ה- eVisa שלך בבחריין. בין אם יש לך שאלות או שאתה זקוק לעזרה דחופה, אנחנו כאן כדי להבטיח שתוכניות הנסיעה שלך יתנהלו בצורה חלקה.",
      "3_body_cambodia": "צוות המומחים שלנו זמין מסביב לשעון כדי לסייע ביישום eVisa בקמבודיה שלך. בין אם יש לך שאלות או שאתה זקוק לעזרה דחופה, אנחנו כאן כדי להבטיח שתוכניות הנסיעה שלך יתנהלו בצורה חלקה.",
      "3_body_canada": "צוות המומחים שלנו זמין מסביב לשעון כדי לסייע בבקשת ETA שלך בקנדה. בין אם יש לך שאלות או שאתה זקוק לעזרה דחופה, אנחנו כאן כדי להבטיח שתוכניות הנסיעה שלך יתנהלו בצורה חלקה.",
      "3_body_home": "הנתונים הפיננסיים שלך מעובדים באמצעות מערכות מאושרות PCI DSS, מה שמבטיח את רמת האבטחה הגבוהה ביותר. בחר מבין אמצעי תשלום מרובים, כולל כל כרטיסי האשראי העיקריים ו- PayPal, לנוחיותך.",
      "3_body_india": "צוות המומחים שלנו זמין מסביב לשעון כדי לסייע ביישום eVisa שלך בהודו. בין אם יש לך שאלות או שאתה זקוק לעזרה דחופה, אנחנו כאן כדי להבטיח שתוכניות הנסיעה שלך יתנהלו בצורה חלקה.",
      "3_body_indonesia": "צוות המומחים שלנו זמין מסביב לשעון כדי לסייע בבקשת הוויזה שלך לאינדונזיה. בין אם יש לך שאלות או שאתה זקוק לעזרה דחופה, אנחנו כאן כדי להבטיח שתוכניות הנסיעה שלך יתנהלו בצורה חלקה.",
      "3_body_israel": "צוות המומחים שלנו זמין מסביב לשעון כדי לסייע בבקשת ETA-IL בישראל. בין אם יש לך שאלות או שאתה זקוק לעזרה דחופה, אנחנו כאן כדי להבטיח שתוכניות הנסיעה שלך יתנהלו בצורה חלקה.",
      "3_body_korea": "צוות המומחים שלנו זמין מסביב לשעון כדי לסייע ביישום ה- KETA שלך בדרום קוריאה. בין אם יש לך שאלות או שאתה זקוק לעזרה דחופה, אנחנו כאן כדי להבטיח שתוכניות הנסיעה שלך יתנהלו בצורה חלקה.",
      "3_body_morocco": "צוות המומחים שלנו זמין מסביב לשעון כדי לסייע ביישום ה- eVisa שלך במרוקו. בין אם יש לך שאלות או שאתה זקוק לעזרה דחופה, אנחנו כאן כדי להבטיח שתוכניות הנסיעה שלך יתנהלו בצורה חלקה.",
      "3_body_new_zealand": "צוות המומחים שלנו זמין מסביב לשעון כדי לסייע ביישום ה- NZeTA בניו זילנד שלך. בין אם יש לך שאלות או שאתה זקוק לעזרה דחופה, אנחנו כאן כדי להבטיח שתוכניות הנסיעה שלך יתנהלו בצורה חלקה.",
      "3_body_saudi_arabia": "צוות המומחים שלנו זמין מסביב לשעון כדי לסייע ביישום ה- eVisa שלך בערב הסעודית. בין אם יש לך שאלות או שאתה זקוק לעזרה דחופה, אנחנו כאן כדי להבטיח שתוכניות הנסיעה שלך יתנהלו בצורה חלקה.",
      "3_body_sri_lanka": "צוות המומחים שלנו זמין מסביב לשעון כדי לסייע בבקשת הוויזה שלך לסרי לנקה. בין אם יש לך שאלות או שאתה זקוק לעזרה דחופה, אנחנו כאן כדי להבטיח שתוכניות הנסיעה שלך יתנהלו בצורה חלקה.",
      "3_body_thailand": "Our dedicated team is always available. From urgent requests to quick questions, we’ve got you covered day and night.",
      "3_body_togo": "Our experts are on hand around the clock. Need help or have questions? We’re here to guide you every step of the way.",
      "3_body_uk": "צוות המומחים שלנו זמין מסביב לשעון כדי לסייע בבקשת ETA שלך בבריטניה. בין אם יש לך שאלות או שאתה זקוק לעזרה דחופה, אנחנו כאן כדי להבטיח שתוכניות הנסיעה שלך יתנהלו בצורה חלקה.",
      "3_body_usa": "צוות המומחים שלנו זמין מסביב לשעון כדי לסייע בבקשת ESTA לארה\"ב. בין אם יש לך שאלות או שאתה זקוק לעזרה דחופה, אנחנו כאן כדי להבטיח שתוכניות הנסיעה שלך יתנהלו בצורה חלקה.",
      "3_body_vietnam": "צוות המומחים שלנו זמין מסביב לשעון כדי לסייע בבקשת ויזת וייטנאם שלך. בין אם יש לך שאלות או שאתה זקוק לעזרה דחופה, אנחנו כאן כדי להבטיח שתוכניות הנסיעה שלך יתנהלו בצורה חלקה.",
      "3_title": "תמיכה מקצועית 24/7",
      "3_title_home": "תשלומים מאובטחים עם תאימות PCI DSS",
      title: "למה לבטוח <span class='text-primary'>בויזהנט</span>"
    },
    visa_starting_price_bahrain: "ויזה אלקטרונית לבחריין החל מ {price}",
    visa_starting_price_cambodia: "ויזה אלקטרונית לקמבודיה החל מ {price}",
    visa_starting_price_canada: "eTA לקנדה החל מ {price}",
    visa_starting_price_india: "<span class='text-primary'>ויזה אלקטרונית בהודו </span> החל מ {price}",
    visa_starting_price_indonesia: "eVisa לאינדונזיה החל מ- {price}",
    visa_starting_price_israel: "ETA-IL לישראל החל מ {price}",
    visa_starting_price_korea: "K-ETA לדרום קוריאה החל מ {price}",
    visa_starting_price_morocco: "ויזה אלקטרונית למרוקו החל מ {price}",
    visa_starting_price_new_zealand: "eTA לניו זילנד החל מ {price}",
    visa_starting_price_saudi_arabia: "ויזה אלקטרונית לערב הסעודית החל מ {price}",
    visa_starting_price_sri_lanka: "ויזה אלקטרונית לסרי לנקה החל מ {price}",
    visa_starting_price_thailand: "Thailand eVisa from {price}",
    visa_starting_price_togo: "Togo eVisa from {price}",
    visa_starting_price_uk: "ETA בבריטניה לבריטניה החל מ {price}",
    visa_starting_price_usa: "ESTA לארצות הברית החל מ {price}",
    visa_starting_price_vietnam: "ויזה אלקטרונית לווייטנאם החל מ {price}"
  },
  parental_info: "הורים",
  passport: "דרכון",
  passport_biometric_only: "הדרכון חייב להיות דרכון ביומטרי.",
  passport_details: "פרטי דרכון",
  passport_expiry: "תאריך תפוגה של דרכון",
  passport_half_year_valid: "הדרכון חייב להיות בתוקף לפחות 6 חודשים נוספים, ולהכיל לפחות 2 עמודים ריקים.",
  passport_issue_date: "תאריך הוצאת דרכון",
  passport_issue_place: "מקום ההנפקה של דרכון",
  passport_number: "מספר דרכון",
  passport_personal_details: "פרטי דרכון ומידע אישי",
  passport_valid_six_months_min: "חייב להיות בתוקף לפחות שישה חודשים נוספים",
  passport_year_valid_two_empty_pages: "הדרכון חייב להיות בתוקף לפחות שנה נוספת, ולהכיל לפחות 2 עמודים ריקים.",
  pay: "לשלם",
  payment: "תשלום",
  payment_methods: "אמצעי תשלום",
  payment_processor_error_alert: "Error with this payment method. You may pick a different payment method or retry.",
  payment_processors: {
    bill_payment: "תשלום על ידי חשבון",
    bit: "אפליקציית ביט",
    credit_card: "כרטיס אשראי",
    credit_card_ru: "כרטיס בנקים רוסיים",
    paybox: "אפליקציית פייבוקס",
    paypal: "חשבון PayPal"
  },
  paypal: "פייפאל",
  personal_id_number: "מספר תעודת זהות לאומית",
  phone_number: "מספר טלפון",
  picture: "תמונה",
  pictures: "תמונות",
  popular: "פופולרי",
  previous: "חזרה",
  previous_visa_num: "מספר הויזה הקודם",
  priority: {
    checkbox_1_2_days: "Check ✓ to get your {docName} in 1-2 business days.",
    checkbox_3_days: "Check ✓ to get your {docName} in 3 business days.",
    checkbox_5_days: "Check ✓ to get your {docName} in 5 business days.",
    checkbox_few_hours: "Check ✓ to get your {docName} in a few hours.",
    checkbox_label: "עיבוד מהיר: {n} יום | עיבוד מהיר: {n} ימים",
    checkbox_next_day: "Check ✓ to get your {docName} by the next business day.",
    fast_processing: "עיבוד מהיר",
    hint: "בדוק ✓ כדי לקבל את הויזה האלקטרונית שלך עד יום העסקים הבא. | בדוק ✓ כדי לקבל את הויזה האלקטרונית שלך בימי {n} עסקים.",
    hint_eta: "בדוק ✓ כדי לקבל את ה-{docName} שלך עד יום העסקים הבא. | בדוק ✓ כדי לקבל את ה-{docName} שלך בימי {n} עסקים.",
    hint_evisa: "בדוק ✓ כדי לקבל את הויזה האלקטרונית שלך עד יום העסקים הבא. | בדוק ✓ כדי לקבל את הויזה האלקטרונית שלך בימי {n} עסקים.",
    processing_time: "Processing Time",
    select_1_2_days: "1-2 Days {price}",
    select_3_days: "3 Days {price}",
    select_5_days: "5 Days {price}",
    select_few_hours: "Few Hours {price}",
    select_next_day: "Next Day {price}",
    select_none: "Regular, No Extra Cost",
    wait_1_2_days: "1-2 Days",
    wait_3_days: "3 Days",
    wait_5_days: "5 Days",
    wait_few_hours: "Few Hours",
    wait_next_day: "Next Day"
  },
  privacy_autodelete: "אנו לוקחים את הפרטיות והאבטחה שלך ברצינות רבה. כל המידע באתר שלנו מאובטח בהצפנת SSL ועומד בתקן PCI הבינלאומי עבור{year}. עם קבלת הויזה האלקטרונית, התמונות שלך יימחקו משרתי האתר.",
  privacy_page: {
    meta_desc: "",
    title: "מדיניות פרטיות • ויזנט"
  },
  privacy_policy: "מדיניות פרטיות",
  privacy_security_importance: "אנו נותנים עדיפות לאבטחת מידע ופרטיות מעל לכל, ומבטיחים שהנתונים שלך מוגנים במידה המרבית.",
  product: {
    entries: {
      "double": "חדר זוגי (2)",
      multiple: "מרובה",
      single: "יחיד"
    },
    entries_full: {
      "double": "2 רשומות",
      multiple: "ערכים מרובים",
      single: "כניסה יחידה"
    },
    urgent: "דחוף",
    validity: {
      "15_days": "15 Days",
      "2_months": "60 ימים",
      "2_weeks": "14 ימים",
      "2_years": "2 שנים",
      "3_months": "90 ימים",
      "3_years": "3 שנים",
      "5_years": "5 שנים",
      "6_months": "180 ימים",
      month: "30 ימים",
      year: "שנה אחת"
    }
  },
  product_variation: {
    alert_title: "Attention!",
    label: {
      fee_60_plus: "Insurance Fee (Age 60+)",
      fee_by_nationality: "Nationality Fee",
      stay_limit_by_nationality: "Stay Limit",
      validity_6_months_by_nationality: "Visa Validity (Nationality)"
    },
    note: {
      fee_60_plus: "Applicants over the age of 60 have a higher medical insurance fee: {fee}",
      fee_by_nationality: "Issuing a visa for your selected nationality ({ nationality }) requires a higher fee: {fee}",
      stay_limit_by_nationality: "Your selected nationality is eligible to stay for a maximum of {limit} days.",
      validity_6_months_by_nationality: "Your selected nationality is eligible for a 6-month visa only."
    }
  },
  products: {
    label: {
      bahrain_2_weeks: "ויזה אלקטרונית, 14 ימים",
      bahrain_3_months: "ויזה אלקטרונית, 3 חודשים",
      bahrain_year: "ויסה אלקטרונית, שנה אחת",
      cambodia_month: "ויזה אלקטרונית, 30 ימים",
      canada_5_years: "eTA, 5 שנים",
      india_business_year: "ויזה עסקית אלקטרונית, שנה",
      india_tourist_5_years: "eVisa לתיירים, 5 שנים",
      india_tourist_month: "ויזה אלקטרונית לתיירים, 30 יום",
      india_tourist_year: "eVisa לתיירים, שנה אחת",
      indonesia_2_months: "60 ימים, כניסה יחידה",
      indonesia_2_years: "שנתיים, מספר כניסות",
      indonesia_5_years: "5 שנים, מספר כניסות",
      indonesia_year: "שנה אחת, מספר כניסות",
      israel_2_years: "אתה-איל, שנתיים",
      korea_3_years: "ETA (K-ETA), 3 שנים",
      korea_3_years_30_stay: "K-ETA, 3 Years",
      morocco_tourist_6_months: "ויזה אלקטרונית לתיירים, 180 יום",
      new_zealand_2_years: "eTA, שנתיים",
      saudi_arabia_6_months: "ויזה אלקטרונית, 6 חודשים",
      saudi_arabia_year: "Tourist eVisa, 1 Year",
      sri_lanka_month: "ויזה אלקטרונית לתיירים, 30 יום",
      thailand_3_months: "eVisa, 90 Days, Single Entry",
      thailand_5_years: "DTV, 5 Years, Multiple Entries",
      thailand_6_months: "eVisa, 180 Days, Multiple Entries",
      togo_15_days_multi: "15 Days, Multiple Entries",
      togo_15_days_single: "15 Days, Single Entry",
      togo_3_months: "90 Days, Multiple Entries",
      togo_month: "30 Days, Multiple Entries",
      uk_2_years: "ETA בבריטניה, שנתיים",
      usa_2_years: "eTA (ESTA), שנתיים",
      vietnam_3_months_multi: "90 יום, מספר כניסות",
      vietnam_3_months_single: "90 יום, כניסה יחידה"
    },
    "long": {
      bahrain_2_weeks: "ויזה אלקטרונית בחריין, 14 ימים",
      bahrain_3_months: "ויזה אלקטרונית בחריין, 3 חודשים",
      bahrain_year: "ויזה אלקטרונית בחריין, שנה אחת",
      cambodia_month: "ויזה אלקטרונית בקמבודיה, 30 ימים",
      canada_5_years: "קנדה eTA, 5 שנים",
      india_business_year: "ויזה עסקית בהודו, שנה",
      india_tourist_5_years: "ויזה תיירותית בהודו, 5 שנים",
      india_tourist_month: "ויזה תיירותית בהודו, 30 יום",
      india_tourist_year: "ויזה תיירותית בהודו, שנה",
      indonesia_2_months: "eVisa לתיירים באינדונזיה, 60 יום, כניסה יחידה",
      indonesia_2_years: "eVisa לתיירים באינדונזיה, שנתיים, כניסות מרובות",
      indonesia_5_years: "eVisa לתיירים באינדונזיה, 5 שנים, כניסות מרובות",
      indonesia_year: "eVisa לתיירים באינדונזיה, שנה אחת, כניסות מרובות",
      israel_2_years: "ישראל ETA-IL, שנתיים",
      korea_3_years: "דרום קוריאה ETA (K-ETA), 3 שנים, מספר כניסות",
      korea_3_years_30_stay: "South Korea K-ETA, 3 Years",
      morocco_tourist_6_months: "ויזה תיירותית במרוקו, 180 יום",
      new_zealand_2_years: "ניו זילנד eTA, שנתיים",
      saudi_arabia_6_months: "ערב הסעודית eVisa, 6 חודשים",
      saudi_arabia_year: "Saudi Arabia eVisa, 1 Year",
      sri_lanka_month: "ויזה תיירותית לסרי לנקה, 30 יום",
      thailand_3_months: "Thailand eVisa, 90 Days, Single",
      thailand_5_years: "Thailand DTV, 5 Years, Multi",
      thailand_6_months: "Thailand eVisa, 180 Days, Multi",
      togo_15_days_multi: "Togo eVisa, 15 Days, Multi",
      togo_15_days_single: "Togo eVisa, 15 Days, Single",
      togo_3_months: "Togo eVisa, 90 Days, Multi",
      togo_month: "Togo eVisa, 30 Days, Multi",
      uk_2_years: "ETA בבריטניה, שנתיים, כניסות מרובות",
      usa_2_years: "ארה\"ב eTA (ESTA), שנתיים, מספר כניסות",
      vietnam_3_months_multi: "ויזה אלקטרונית לתיירים בווייטנאם, 90 יום, כניסות מרובות",
      vietnam_3_months_single: "ויזה אלקטרונית לתיירים בווייטנאם, 90 יום, כניסה יחידה"
    }
  },
  professional: "מקצועי",
  quantity: "Quantity",
  quantity_select: {
    hint_all: "אחד לאדם (כולל ילדים בגילאי 0-18)",
    hint_range: "אחד לאדם ({min}עד {max} גיל שנה)",
    label: "מספר אשרות"
  },
  redirect_payment_on_click: "לאחר שתלחץ על כפתור 'שלם', תועבר לדף תשלום מאובטח כדי להשלים את התשלום שלך.",
  religion: "דת",
  religion_other: "אחר/אין",
  remove: "הסר",
  resume_form_with_link: "אתה יכול להשתמש בקישור הבא מכל מחשב או טלפון, ולהמשיך למלא את הנקודה שבה הפסקת.",
  resume_saved_form: "Resume Your Saved Form",
  retired: "בגמלאות",
  retry: "Retry",
  review_links: "גלה מה הלקוחות אומרים עלינו ב",
  rules: {
    email_invalid: "כתובת דוא\"ל לא חוקית",
    file_not_supported: "סוג קובץ לא נתמך",
    file_size: "הקובץ חייב להיות קטן ממג {max} ה-בייט",
    latin: "אותיות לטיניות, מקפים וסוגריים בלבד",
    length: "בדיוק {length} דמויות",
    numbers: "מספרים בלבד",
    one_min: "יש לבחור לפחות אפשרות אחת",
    required: "שדה חובה",
    six_months_min: "חייב להיות מעל 6 חודשים",
    too_early: "התאריך מוקדם מדי",
    too_late: "התאריך מאוחר מדי"
  },
  saarc_countries_are: "מדינות SAARC הן",
  safety_box: {
    official_visa: "Official Visa",
    refund: "Full refund in case of rejection",
    secure_payment: "Secure Payment",
    ssl: "SSL Encryption",
    support: "24/7 Support"
  },
  saudi_arabia: "ערב הסעודית",
  saudi_arabia_evisa: "ערב הסעודית eVisa",
  saudi_arabia_page: {
    faq: [
      {
        a: "eVisa היא ויזה אלקטרונית שהונפקה באופן מקוון על ידי ממשלת ערב הסעודית, המאפשרת למטיילים להיכנס למדינה למטרות תיירות או עסקיות.",
        q: "מהי ויזה אלקטרונית?"
      },
      {
        a: "אזרחים ממדינות זכאות יכולים להגיש בקשה לביזה אלקטרונית סעודית, זה כולל: אזרחים אמריקאים, קנדים, אנגלים ואוסטרלים. הרשימה המלאה של המדינות/אזרחים הזכאים זמינה <a data-eligibility-list-opener> כאן. </a>",
        q: "מי זכאי לקבלת ויזה אלקטרונית של ערב הסעודית?"
      },
      {
        a: "ניתן להגיש בקשה לביזה אלקטרונית סעודית דרך אתר Visanet על ידי מילוי טופס הבקשה, העלאת המסמכים הנדרשים (דרכון, תמונה) ותשלום האגרה הרלוונטית.",
        q: "כיצד אוכל להגיש בקשה לביזה אלקטרונית של ערב הסעודית?"
      },
      {
        a: "תזדקק לדרכון תקף בתוקף של שישה חודשים לפחות, תמונה עדכנית בגודל דרכון (כל פורמט יעבוד, נערוך את התמונה בהתאם לדרישות) וכרטיס אשראי/חיוב לתשלום.",
        q: "אילו מסמכים נדרשים לבקשת eVisa?"
      },
      {
        a: "זמן העיבוד של eVisa סעודית הוא בין 1 ל -3 ימים.",
        q: "כמה זמן לוקח לעבד את ה- eVisa?"
      },
      {
        a: "ה- eVisa הסעודית תקף לשנה מיום ההנפקה ומאפשר כניסות מרובות. כל שהייה יכולה להימשך עד 90 יום בתוך תקופה של 180 יום.",
        q: "מהי תקופת התוקף של ה- eVisa?"
      },
      {
        a: "לא, לא ניתן להאריך את ה- eVisa. עליך לעזוב את המדינה לפני שתוקף הוויזה שלך יפוג.",
        q: "האם אוכל להאריך את שהותי בערב הסעודית באמצעות eVisa?"
      },
      {
        a: "האגרה כוללת ביטוח רפואי במהלך שהותכם בערב הסעודית.",
        q: "מהן העמלות עבור ויזה אלקטרונית של ערב הסעודית?"
      },
      {
        a: "כן, מטיילים צריכים להיות מודעים למנהגים ולתקנות של ערב הסעודית, כולל הגבלות על פריטים מסוימים, התנהגות וקוד לבוש. מומלץ לעיין בכללים אלה לפני הנסיעה.",
        q: "האם יש מגבלות נסיעה שאני צריך להיות מודע להן?"
      },
      {
        a: "כן, מחזיקי eVisa לתיירים סעודיים יכולים לבצע אומרה. עם זאת, היא אינה מתירה ביצוע חאג'.",
        q: "האם אוכל לבצע אומרה עם eVisa לתיירים?"
      },
      {
        a: "כן, ביטוח נסיעות נדרש וכבר כלול במחיר שלנו. הביטוח מספק כיסוי למקרי חירום רפואיים במהלך שהותך בערב הסעודית.",
        q: "האם ביטוח נסיעות נדרש עבור eVisa?"
      },
      {
        a: "<p>כן, בעלי eVisa יכולים להיכנס לסעודיה דרך שדות תעופה ומעברי גבול ייעודיים. רשימת נקודות הכניסה היא כדלקמן: נמל התעופה הבינלאומי המלך חאלד, נמל התעופה <ul> <li> הבינלאומי ריאד המלך עבדול-עזיז, נמל התעופה הבינלאומי ג'דה </li> <li> המלך פאהד, נמל התעופה הבינלאומי דמאם מוח </li> <li> מד בן עבדול-עזיז, מדינה </li> <li> </li> </ul> </p>",
        q: "האם יש נקודות כניסה ספציפיות למחזיקי eVisa?"
      },
      {
        a: "לא, ה- eVisa הסעודית מיועד אך ורק לתיירות או ביקורים עסקיים. אם ברצונך לעבוד בערב הסעודית, תצטרך להגיש בקשה לויזת עבודה.",
        q: "האם אוכל לעבוד בערב הסעודית עם ויזה אלקטרונית?"
      }
    ],
    meta_desc: "הגש בקשה לויזה לסעודיה באופן מקוון עם Visanet בשנת 2024. תהליך הגשת בקשה מהיר ומאובטח. קבל את אישור הנסיעה שלך במהירות ובקלות.",
    title: "בקשה מקוונת לוויזה אלקטרונית לסעודיה 2024 • Visanet"
  },
  save_form: "שמור טופס",
  seaport: "נמל ים",
  sector: "מגזר",
  sector_hint: "המגזר של העסק שלך, למשל 'טק' או 'מוסיקה'",
  select: "בחר",
  select_education: "בחר באפשרות המתארת בצורה הטובה ביותר את רמת ההשכלה שלך",
  select_from_my_addresses: "בחר מתוך הכתובות שלי",
  select_nationality: "לאום",
  select_occupation: "בחר עיסוק",
  select_payment_method: "בחר אמצעי תשלום",
  select_seniority_years: "בחר שנים של ותק",
  select_visa_type_bahrain: "בחר את הסוג הרצוי של ויזה אלקטרונית לבחריין",
  select_visa_type_cambodia: "בחר את הסוג הרצוי של eVisa לקמבודיה",
  select_visa_type_canada: "בחר את סוג הוויזה הרצוי לקנדה",
  select_visa_type_india: "בחר את הסוג הרצוי של eVisa להודו",
  select_visa_type_indonesia: "בחר את הסוג הרצוי של eVisa לאינדונזיה",
  select_visa_type_israel: "בחר את סוג הוויזה הרצוי לישראל",
  select_visa_type_korea: "בחר את סוג הוויזה הרצוי לדרום קוריאה",
  select_visa_type_morocco: "בחר את הסוג הרצוי של eVisa למרוקו",
  select_visa_type_new_zealand: "בחר את סוג הויזה הרצוי לניו זילנד",
  select_visa_type_saudi_arabia: "בחר את הסוג הרצוי של eVisa לערב הסעודית",
  select_visa_type_sri_lanka: "בחר את הסוג הרצוי של eVisa לסרי לנקה",
  select_visa_type_thailand: "Choose your desired type of visa to Thailand",
  select_visa_type_togo: "Choose your desired type of eVisa to Togo",
  select_visa_type_uk: "בחר את סוג הוויזה הרצוי לבריטניה",
  select_visa_type_usa: "בחר את סוג הוויזה הרצוי לארה\"ב",
  select_visa_type_vietnam: "בחר את הסוג הרצוי של eVisa לווייטנאם",
  self_employed: "עצמאי",
  send: "שלח",
  send_images_later: "מאוחר יותר",
  send_link: "שלח קישור",
  send_link_to_email: "ניתן לשלוח את הקישור ישירות לדוא\"ל שלך.",
  send_message: "שלח הודעה",
  sent: "נשלח בהצלחה!",
  sex: "מגדר",
  shutdown_sri_lanka: "החל מאוקטובר 2024, אין צורך להגיש בקשה לויזה אלקטרונית לסרי לנקה.",
  six_hours: "6 שעות",
  socials: {
    "2gis": "2גיס",
    easy: "easy",
    facebook: "פייסבוק",
    google: "גוגל",
    instagram: "אינסטגרם",
    irecommend: "אני ממליץ",
    otzovik: "Otzovik",
    telegram: "מברק",
    trustpilot: "Trustpilot",
    vk: "VK",
    x: "x",
    yandex: "ינדקס"
  },
  spouse_country: "ארץ הלידה של בן הזוג",
  spouse_name: "שם בן הזוג",
  sri_lanka: "סרי לנקה",
  sri_lanka_evisa: "ויזה אלקטרונית של סרי לנקה",
  sri_lanka_page: {
    faq: [
      {
        a: "ויזה אלקטרונית היא אישור מהממשלה המאפשרת כניסה לסרי לנקה ותנועה בתוך המדינה למטרות תיירות. הוויזה האלקטרונית מהווה תחליף מקוון נוח למסמך נייר שהשגרירות מנפיקה לאחר שהגיעה פיזית למשרדיה.",
        q: "מהי ויזה אלקטרונית לסרי לנקה?"
      },
      {
        a: "קרוב לוודאי, כן. המדינות היחידות שאזרחיהן פטורים מהנפקת ויזה בעת הכניסה לסרי לנקה הן: <br> • סיישל <br> • סינגפור <br> • האיים המלדיביים <br> לכן אם אין לך אזרחות של אחת משלוש המדינות שהוזכרו, עליך לקבל ויזה אלקטרונית כדי להיכנס לסרי לנקה.",
        q: "האם אני צריך ויזה אלקטרונית כדי להיכנס לסרי לנקה?"
      },
      {
        a: "1-2 ימים לאחר הגשת הטופס המקוון באתרי האינטרנט שלנו, הוויזה האלקטרונית של סרי לנקה תישלח אליך כמסמך המצורף לכתובת הדוא\"ל שלך. מספר הוויזה יצורף גם להודעה, בעזרתו תקבל חותמת רשמית בדרכון שלך במהלך בדיקות דרכון עם הכניסה לסרי לנקה. <br>בנוסף לויזה, כאשר אתה נוחת בסרי לנקה, תתבקש גם להציג כרטיס טיסה חזרה מהארץ. <br>ייתכן שתתבקש להוכיח יכולת כלכלית ללינה בסרי לנקה במהלך שהותך. ישנן מספר דרכים לעשות זאת: <br> • תדפיס של יתרת החשבון השוטף בחשבון הבנק שלך. <br>• תדפיס של אישור המרת מטבע. <br>• תדפיס המוכיח כי בבעלותך כרטיס אשראי תקף. <br>• מזומן. <br>ברוב המכריע של המקרים, תיירים אינם מתבקשים להוכיח יכולת כלכלית. עם זאת, אנו ממליצים להביא הוכחה כלשהי, ליתר ביטחון.",
        q: "כיצד פועלת הנפקת ויזה אלקטרונית לסרי לנקה?"
      },
      {
        a: "כן. מקסימום פעמיים עם אותה ויזה במסגרת זמן תוקפו.",
        q: "האם אוכל לנסוע שוב לסרי לנקה עם אותה ויזה?"
      },
      {
        a: "כן. הוויזה האלקטרונית של סרי לנקה תקפה למשך 90 יום מרגע הוצאתה. אתה יכול להיכנס לסרי לנקה מתי שתרצה במהלך מסגרת זמן זו. <br>אנא שימו לב כי השהייה במדינה מוגבלת ל-60 יום, בהתאם לסוג הויזה האלקטרונית שתרכשו.",
        q: "האם ניתן להיכנס לסרי לנקה בזמן שונה מזה שצוין בויזה?"
      },
      {
        a: "כן. ילדים זקוקים לויזה אלקטרונית כדי להיכנס לסרי לנקה.",
        q: "האם ילדים זקוקים לויזה כדי להיכנס לסרי לנקה?"
      },
      {
        a: "לא, זה לא נדרש. ניתן להנפיק ויזה אלקטרונית גם אם טרם קנית כרטיס טיסה. <br><b>שימו לב כי עם הנחיתה בסרי לנקה תתבקשו להציג כרטיס טיסה מחוץ למדינה</b>.",
        q: "האם אני צריך לקנות כרטיס טיסה לפני הגשת טופס הויזה?"
      },
      {
        a: "כן. כדי להאריך את תוקפו של אשרת כניסה ושהייה, עליך לפנות למשרדי רשות ההגירה הממוקמים בקולומבו, סרי לנקה.",
        q: "האם ניתן להאריך את הויזה בזמן השהייה בסרי לנקה?"
      },
      {
        a: "למרבה הצער, אין אפשרות כזו. כדי לבצע שינויים, עליך להנפיק ויזה אלקטרונית חדשה. לכן, אנא שימו לב בעת מילוי הטופס שכל הפרטים שתזנו תואמים את הפרטים המצוינים בדרכון.",
        q: "האם ניתן לבקש שינוי בויזה לאחר שהיא נשלחה למייל שלי?"
      },
      {
        a: "<p>אל תהסס לחקור את הב </a> לוג <a href=\"/blog\"> שלנו לקבלת החדשות האחרונות, העדכונים והמדריכים המקיפים לקבלת אשרות לסרי לנקה. </p><p>בנוסף, הצוות שלנו מוכן להציע לך <a href=\"/contact\"> סיוע אנושי חי 24/7 </a></p>. <p>תודה לך, צוות ויזנט. </p>",
        q: "יש לי שאלות נוספות"
      }
    ],
    meta_desc: "הגש בקשה לאישור נסיעה אלקטרוני לסרי לנקה באנגלית וקבל אותו תוך יום אחד",
    title: "eVisa לסרי לנקה באינטרנט"
  },
  stamp: "חותמת",
  status_page: {
    applied: "יישומי",
    applied_desc: "יישמנו בהצלחה את הבקשה הרשמית בשמך. עכשיו אנחנו מחכים לאישור.",
    approval_doc: "מסמך אישור # {n}",
    approved: "אושרה",
    approved_desc: "מזל טוב! הבקשה שלך אושרה רשמית! כרגע אנחנו עוברים על כמה פרטים לפני שנשלח לך את המסמכים ואת כל המידע החשוב.",
    canceled: "בוטל",
    canceled_desc: "בקשה זו בוטלה.",
    check: "בדוק את מצב היישום",
    clock_img: "Clock Illustration",
    contact_us: "לשאלות דחופות או סיוע, אנא אל תהססו לפנות אלינו באמצעות:",
    current: "סטטוס:",
    email_address: "כתובת אימייל",
    find_application_id: "ניתן למצוא את מזהה הבקשה שלך בדוא\"ל האישור ששלחנו לך לאחר הגשת הבקשה שלך. הקפד להכניס את אותה כתובת דוא\"ל שבה השתמשת במהלך תהליך הגשת הבקשה.",
    find_application_id_title: "היכן ניתן למצוא את מזהה היישום שלך?",
    find_here_1: "שלב העיבוד הנוכחי.",
    find_here_2: "זמן אישור משוער.",
    find_here_3: "התראות על כל המסמכים או השלבים הנוספים הנדרשים.",
    find_here_body: "דף זה מספק עדכונים בזמן אמת על התקדמות בקשת הוויזה שלך, כולל:",
    find_here_title: "מה תמצאו כאן",
    future: "בהמתנה",
    future_desc: "אנו דוחים את בקשתך למועד מאוחר יותר, כך שתאריכי תוקף הוויזה שלך יתאימו לתאריכי הביקור שלך.",
    instructions_title: "בדוק את מצב בקשת הויזה שלך",
    intro: "ברוכים הבאים לדף מצב ויזה, שבו תוכל לעקוב אחר התקדמות בקשת הוויזה שלך באמצעות Visanet.",
    man_lays_on_laptop_img: "A Man Lays His Head on a Laptop Keyboard Illustration",
    may_download: "תוכל גם להוריד את מסמכי האישור שלך כאן:",
    meta_desc: "דף מצב הוויזה באתר שלנו מאפשר לך לבדוק את הסטטוס העדכני והמעודכן ביותר של בקשת הויזה שלך. כל שעליך לעשות הוא להכניס את מזהה ההזמנה שלך ב- Visanet",
    mistake: "טעות",
    mistake_desc: "מצאנו משהו בעייתי בטופס הבקשה שלך. אנא בדוק את תיבת הדואר הנכנס שלך לפרטים נוספים.",
    need_help_body: "אם אתה נתקל בבעיות כלשהן בגישה לסטטוס שלך או אם יש לך שאלות נוספות, אנא פנה לצוות התמיכה שלנו. אנחנו כאן כדי לעזור לך בכל צעד של הדרך.",
    need_help_title: "זקוק לעזרה?",
    "new": "חדש",
    new_desc: "קיבלנו את טופס הבקשה שלך וכעת בודקים אותו לפני הגשת בקשה רשמית בשמך.",
    not_found: "לא הצלחנו למצוא את ההזמנה שלך באמצעות הפרטים שסופקו. הקפד להכניס את אותה כתובת דוא\"ל ששימשה בטופס הבקשה שלנו, ואת מזהה הבקשה מהודעת אישור ההזמנה ששלחנו.",
    pending: "בהמתנה",
    pending_desc: "קיבלנו את בקשתך, אך אנו עדיין מחכים למידע נוסף או תמונות ממך. אנא בדוק את הודעת האישור שלנו לקבלת פרטים נוספים.",
    phone: "טלפון:",
    progress_bar_on_card_img: "Progress Bar with Airplane and Suitcase Icons on Blue Card",
    rejected: "נדחה",
    rejected_desc: "בקשתך נדחתה. אנא בדוק את תיבת הדואר הנכנס שלך לפרטים נוספים.",
    sent: "ויזה נשלחה",
    sent_desc: "מזל טוב! הבקשה שלך אושרה רשמית! שלחנו את כל הפרטים החשובים בדוא\"ל.",
    success: "עדכון על מצב ההזמנה שלך נשלח לדוא\"ל שלך.",
    title: "בדוק את מצב בקשת הוויזה • Visanet",
    visa_status: "Visa <span class='text-primary'>Status</span>",
    why_title: "למה לעקוב אחר מצב הוויזה שלך עם Visanet?"
  },
  stay_days: "{limit}ימים לביקור",
  stay_limit: "הישאר מעודכן עד:",
  street_number: "שורת כתובת",
  student: "סטודנט",
  success_page: {
    now_what: "אז מה קורה מנקודה זו ואילך?",
    pay_success: "תודה על התשלום שלך",
    step1_body_bahrain: "אתה צפוי לקבל ויזה אלקטרונית חתומה ישירות לדוא\"ל שלך תוך 3-5 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_cambodia: "אתה צפוי לקבל ויזה אלקטרונית חתומה ישירות לדוא\"ל שלך תוך 2-3 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_canada: "אתה צפוי לקבל eTA חתום ישירות לדוא\"ל שלך תוך 1-2 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_india: "אתה צפוי לקבל ויזה אלקטרונית חתומה ישירות לדוא\"ל שלך תוך 1-3 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_indonesia: "אתה צפוי לקבל ויזה אלקטרונית חתומה ישירות לדוא\"ל שלך תוך 3-5 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_israel: "אתה צפוי לקבל eTA חתום ישירות לדוא\"ל שלך תוך 1-2 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_korea: "אתה צפוי לקבל KETA חתום ישירות לדוא\"ל שלך תוך 1-3 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_morocco: "אתה צפוי לקבל ויזה אלקטרונית חתומה ישירות לדוא\"ל שלך תוך 1-3 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_new_zealand: "אתה צפוי לקבל NZeTA חתום ישירות לדוא\"ל שלך תוך 1-2 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_saudi_arabia: "אתה צפוי לקבל ויזה אלקטרונית חתומה ישירות לדוא\"ל שלך תוך 1-3 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_sri_lanka: "אתה צפוי לקבל ויזה אלקטרונית חתומה ישירות לדוא\"ל שלך תוך 1-2 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_thailand: "You are expected to receive a signed e-visa directly to your email soon.<br>In the meantime, we've sent you an order confirmation and an invoice for your payment.",
    step1_body_togo: "You are expected to receive a signed e-visa directly to your email in 3-5 days.<br>In the meantime, we've sent you an order confirmation and an invoice for your payment.",
    step1_body_uk: "אתה צפוי לקבל ETA חתום בבריטניה ישירות לדוא\"ל שלך תוך 1-3 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_usa: "אתה צפוי לקבל ESTA חתום ישירות לדוא\"ל שלך תוך 1-3 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_body_vietnam: "אתה צפוי לקבל ויזה אלקטרונית חתומה ישירות לדוא\"ל שלך תוך 4-5 ימים. <br>בינתיים שלחנו לך אישור הזמנה וחשבונית לתשלום שלך.",
    step1_header: "ויזה אלקטרונית תישלח לדוא\"ל שלך",
    step2_body: "לכל שאלה, הערה או בקשה, אתה תמיד מוזמן <a href=\"/contact\"> לפנות אלינו</a>.",
    step2_header: "דרכים ליצור קשר",
    step3_body: "ותודה שבחרת בויזנט.",
    step3_header: "שיהיה לך מסע נעים",
    under_way_bahrain: "אנו נעבד מייד את בקשתך על סמך הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eVisa שלך באמצעות רשויות ההגירה של בחריין.",
    under_way_cambodia: "אנו נעבד מייד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eVisa שלך באמצעות רשויות ההגירה של קמבודיה.",
    under_way_canada: "אנו נעבד מיד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eTA שלך באמצעות רשויות ההגירה של קנדה.",
    under_way_india: "אנו נעבד מייד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eVisa שלך באמצעות רשויות ההגירה של הודו.",
    under_way_indonesia: "אנו נעבד מייד את בקשתך על סמך הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eVisa שלך באמצעות רשויות ההגירה של אינדונזיה.",
    under_way_israel: "אנו נעבד מיד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eTA שלך באמצעות",
    under_way_korea: "אנו נעבד מייד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- K-ETA שלך באמצעות רשויות ההגירה של דרום קוריאה.",
    under_way_morocco: "אנו נעבד מייד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eVisa שלך באמצעות רשויות ההגירה של מרוקו.",
    under_way_new_zealand: "אנו נעבד מייד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eVisa שלך באמצעות רשויות ההגירה של ניו זילנד.",
    under_way_saudi_arabia: "אנו נעבד מייד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eVisa שלך באמצעות רשויות ההגירה של ערב הסעודית.",
    under_way_sri_lanka: "אנו נעבד מייד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eVisa שלך באמצעות רשויות ההגירה של סרי לנקה.",
    under_way_thailand: "We will immediately process your application based on the details you've provided and start the process of issuing your eVisa through the immigration authorities of Thailand.",
    under_way_togo: "We will immediately process your application based on the details you've provided and start the process of issuing your eVisa through the immigration authorities of Togo.",
    under_way_uk: "אנו נעבד מיד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- ETA שלך בבריטניה באמצעות רשויות ההגירה של בריטניה.",
    under_way_usa: "אנו נעבד מיד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- ESTA שלך באמצעות רשויות ההגירה של ארצות הברית.",
    under_way_vietnam: "אנו נעבד מייד את בקשתך בהתבסס על הפרטים שסיפקת ונתחיל בתהליך הנפקת ה- eVisa שלך באמצעות רשויות ההגירה של וייטנאם."
  },
  suggest_later_pic: "תמונות נדרשות לעיבוד בקשתך. אם אתה מעדיף לשלוח אותם מאוחר יותר,",
  support: "Support",
  surname: "Surname",
  tax_id: "פונדק",
  terms_of_use: "תנאי שימוש",
  terms_page: {
    meta_desc: "",
    title: "תנאי שימוש • ויזנט"
  },
  thailand: "Thailand",
  thailand_page: {
    exempt_alert: "⚠ Please note: American citizen or <a data-exempt-list-opener>any of those nationalities</a> can visit Thailand without a visa for up to 60 days. A short-term visa is recommended if you want to ensure the fastest and most comfortable entry procedure at the airport.<br>📅 If you plan to stay in Thailand for longer than 60 days in a row, we recommend applying for a long-term DTV visa.",
    exempt_modal_title: "eVisa Exemption Notice",
    faq: [
      {
        a: "The DTV Visa is valid for a full five years, with each stay in Thailand allowing up to 180 consecutive days.",
        q: "How long is the DTV Visa valid?"
      },
      {
        a: "The DTV Visa permits unlimited entries during its five-year validity.",
        q: "How many entries are allowed with the DTV Visa?"
      },
      {
        a: "Simply complete our <a href=\"#form\">online application form</a>, upload the required documents, and we'll handle the rest by submitting your application to the Thai Immigration Office. Within 14-21 business days, you'll receive your visa directly via email, ready to print and use upon entry to Thailand.",
        q: "How does the DTV Visa application process work at Visanet?"
      },
      {
        a: "Yes. Citizens from the US, UK, Canada, Australia, the EU, and most other eligible countries who enter Thailand visa-free can extend their stay for an additional 30 days at a local immigration office. With the DTV Visa, it's possible to extend for another 180 days; however, it’s often simpler and recommended to briefly exit Thailand (e.g., to <a href=\"/vietnam\">Vietnam</a> or <a href=\"/cambodia\">Cambodia</a>) and re-enter to reset your 180-day allowance.",
        q: "Can I extend my stay in Thailand?"
      },
      {
        a: "You can extend your stay at major immigration offices across Thailand, including:<ul><li><b>Bangkok</b> – Chaeng Wattana Immigration Office</li><li><b>Phuket</b> – Phuket Immigration Office</li><li><b>Chiang Mai</b> – Chiang Mai Immigration Office</li><li><b>Pattaya</b> – Chonburi Immigration Office</li><li><b>Koh Samui</b> – Koh Samui Immigration Office</li><li><b>Krabi</b> – Krabi Immigration Office</li><li><b>Hua Hin</b> – Prachuap Khiri Khan Immigration Office</li><li><b>Udon Thani</b> – Udon Thani Immigration Office</li></ul>",
        q: "Where can I extend my stay in Thailand?"
      },
      {
        a: "Yes. All documents submitted to Thai immigration authorities must be in English or Thai. If your documents are in another language, please provide a certified English or Thai translation.",
        q: "Do my documents need to be in English or Thai?"
      },
      {
        a: "Yes, the DTV Visa allows entry through any international airport, seaport or official land border crossing in Thailand.",
        q: "Can I enter Thailand with the DTV Visa through any airport or border?"
      },
      {
        a: "A short-term visa is not required for visa-free entry up to 60 days for citizens from the US, UK, Canada, Australia, the EU, and other eligible nationalities. However, it can be beneficial if you prefer to avoid waiting in airport immigration lines and ensure quick, smooth entry into Thailand.",
        q: "Is there any advantage to getting a short-term visa if I'm staying fewer than 60 days?"
      },
      {
        a: "No. Citizens from these countries can enter Thailand visa-free for stays up to 60 days (with an optional 30-day extension available locally at Thai immigration offices). A visa is necessary only for longer stays or to ensure swift and smooth entry. <details><summary>A complete list of eligible nationalities</summary>Albania, Andorra, Australia, Austria, Bahrain, Belgium, Bhutan, Brazil, Brunei, Bulgaria, Cambodia, Canada, China, Colombia, Croatia, Cuba, Cyprus, Czechia, Denmark, Dominica, Dominican Republic, Ecuador, Estonia, Fiji, Finland, France, Georgia, Germany, Greece, Guatemala, Hong Kong, Hungary, Iceland, India, Indonesia, Ireland, Israel, Italy, Jamaica, Japan, Jordan, Kazakhstan, Korea (ROK), Kosovo, Kuwait, Laos, Latvia, Liechtenstein, Lithuania, Luxembourg, Macao, Malaysia, Maldives, Malta, Mauritius, Mexico, Monaco, Mongolia, Morocco, Netherlands, New Zealand, Norway, Oman, Panama, Papua New Guinea, Peru, Philippines, Poland, Portugal, Qatar, Romania, Russia, San Marino, Saudi Arabia, Singapore, Slovakia, Slovenia, Spain, Sri Lanka, South Africa, Sweden, Switzerland, Taiwan, Tonga, Trinidad and Tobago, Türkiye, Ukraine, UAE, UK, USA, Uruguay, Uzbekistan, Vietnam</details>",
        q: "Do citizens from the US, UK, Canada, Australia, and EU countries require a visa for Thailand?"
      },
      {
        a: "Children from the US, UK, Canada, Australia, EU, and do not need a visa for stays up to 60 days. For longer stays, a separate visa is required for each child.",
        q: "Do children require a visa for Thailand?"
      },
      {
        a: "<ul><li>Single-entry tourist eVisa (90 days) – {thailand_3_months_price}</li><li>Multiple-entry tourist eVisa (180 days) – {thailand_6_months_price}</li></ul>",
        q: "What short-term visas are available for Thailand?"
      },
      {
        a: "For the long-term DTV visa, we recommend applying at least 3-4 weeks before your planned travel date to ensure smooth and timely processing. For the short-term eVisas, two weeks is plenty enough.",
        q: "How far in advance should I apply for the visa?"
      },
      {
        a: "We're always available via <a href=\"{whatsapp}\">WhatsApp</a>, <a data-chat-opener>online chat</a>, <a href=\"mailto:{email}\">email</a>, or <a href=\"tel:{phone}\">phone</a>. Have more questions? Don't hesitate to contact us—Thailand is waiting for you, and we're here to make your travel easy and stress-free!",
        q: "How can I receive additional help or personal guidance?"
      }
    ],
    meta_desc: "Apply for an official electronic visa to Thailand in English. Get a visa without visiting the embassy, a fast and convenient process",
    title: "eVisa to Thailand - Easy Online Application {currentYear} {'|'} Visanet"
  },
  togo: "Togo",
  togo_page: {
    meta_desc: "Apply for an official electronic visa to Togo in English. Get a visa without visiting the embassy, a fast and convenient process",
    title: "eVisa to Togo - Easy Online Application {currentYear} {'|'} Visanet"
  },
  total_price: "מחיר כולל",
  transfer_payment: "תשלום על ידי חשבון",
  uk: "UK",
  uk_evisa: "בריטניה ו",
  uk_page: {
    faq: [
      {
        a: "ה <strong> - ETA בבריטניה (אישור נסיעה אלקטרוני) </strong> הוא ויתור אלקטרוני על ויזה הנדרש למטיילים המבקרים בבריטניה 🇬🇧. <br>הוא משמש כאישור רשמי מרשויות ההגירה בבריטניה, ומאפשר לך להיכנס לאנגליה, סקוטלנד, ויילס וצפון אירלנד ללא צורך בויזה מסורתית.",
        q: "מהו ה- ETA בבריטניה?"
      },
      {
        a: "מטיילים ממדינות זכאות יכולים להגיש בקשה לקבלת ETA בבריטניה באופן מקוון. תוכל לצפות ברשימת המדינות הזכאות <a data-eligibility-list-opener> כאן</a>.",
        q: "מי זכאי להגיש בקשה ל- ETA בבריטניה?"
      },
      {
        a: "ℹ הגשת בקשה ל- ETA בבריטניה היא פשוטה: <br> <ol> <li> מלא את טופס הבקשה המקוון. </li><li>העלה את הדרכון שלך ותמונה אחרונה. </li><li>שלם את האגרה והגיש את בקשתך. </li></ol>לאחר אישור, ה- ETA שלך בבריטניה יישלח ישירות לדוא\"ל שלך תוך 1-3 ימים.",
        q: "כיצד פועל תהליך הגשת הבקשה ל- ETA בבריטניה?"
      },
      {
        a: "ה- ETA בבריטניה תקף לשנ <strong> תיים </strong> או עד שתוקף הדרכון שלך יפוג, המוקדם מביניהם.",
        q: "כמה זמן תקף ה- ETA בבריטניה?"
      },
      {
        a: "ה- ETA בבריטניה מאפשר שהייה של עד <strong> 6 חודשים לכל ביקור</strong>.",
        q: "כמה זמן אוכל להישאר בבריטניה עם ETA?"
      },
      {
        a: "דמי ה- ETA בבריטניה הם{price}. זה כולל עמלות ממשלתיות ועיבוד באמצעות המערכת המאובטחת שלנו.",
        q: "כמה עולה ETA בבריטניה?"
      },
      {
        a: "לא, אתה יכול להגיש בקשה ל- ETA בבריטניה גם אם עדיין לא הזמנת את הטיסה שלך ✈️",
        q: "האם עלי להזמין את הטיסה שלי לפני הגשת בקשה ל- ETA בבריטניה?"
      },
      {
        a: "לא, אם כבר יש לך ויזה תקפה לבריטניה, אתה יכול להשתמש בה לטיול שלך. ה- ETA נדרש רק למי שאין לו ויזה פעילה בבריטניה.",
        q: "יש לי כבר ויזה תקפה לבריטניה. האם אני עדיין צריך ETA?"
      },
      {
        a: "כן, גם אם אתה עובר דרך בריטניה בדרכך ליעד אחר, תזדקק ל- ETA תקף בבריטניה.",
        q: "האם אני צריך ETA בבריטניה למעבר דרך בריטניה?"
      },
      {
        a: "ה- ETA בבריטניה הוא אלטרנטיבה מהירה ונוחה יותר לויזה מסורתית. זה דיגיטלי לחלוטין, כלומר אינך צריך לבקר בשגרירות או לשלוח מסמכים פיזיים. התהליך אורך בדרך כלל 1-3 ימים בלבד, בהשוואה לשבועות עבור ויזה רגילה.",
        q: "מה ההבדל בין ETA בבריטניה לבין ויזה מסורתית?"
      },
      {
        a: "כן, כל הנוסעים, כולל ילדים ותינוקות (בגילאי 0-18), דורשים ETA בבריטניה כדי להיכנס לבריטניה. אתה יכול לכלול ילדים ביישום שלך לנוחות נוספת.",
        q: "האם ילדים זקוקים ל- ETA בבריטניה?"
      }
    ],
    meta_desc: "הגש בקשה ל- ETA שלך בבריטניה באופן מקוון עם Visanet בשנת 2024. תהליך הגשת בקשה מהיר ומאובטח. קבל את אישור הנסיעה שלך במהירות ובקלות.",
    title: "בקשה מקוונת ETA בבריטניה 2024 • Visanet"
  },
  underage: "קטינים",
  unemployed: "מובטלים",
  unexpected_payment_error: "אירעה שגיאה בלתי צפויה. אנא נסה שוב או צור איתנו קשר לקבלת עזרה",
  upload_images_now: "העלה כאן",
  urgent_visa_fast_service: "ויזה דחופה - עיבוד מהיר",
  usa: "\"ארה\"\"ב\"",
  usa_evisa: "ESTA של ארצות הברית",
  usa_page: {
    faq: [
      {
        a: "<p>לאחרונה מדינות רבות נכנסו לרשימת המדינות הפטורות מוויזה לארה\"ב. למרות שזה אומר שהכניסה היא הרבה יותר פשוטה, זה עדיין לא אומר שאין צורך בהיתר כניסה. <br><br>כאן היתר הכניסה החדש של ארצות הברית, ה- <strong> E </strong> lectronic <strong> S </strong> system for <strong> T </strong> ravel <strong> A </strong> uthorization, או בקיצור <strong> ESTA</strong>, בדומה לוויזה אלקטרונית, הוא מסמך מטעם רשויות ההגירה של ארצות הברית שמותר לך להיכנס לגבולות המדינה. עם ESTA לארה\"ב תקבל אישור ממשלתי לטוס ולבקר בארצות הברית. </p>",
        q: "מהי אשרת כניסה של ESTA לארה\"ב?"
      },
      {
        a: "<p>אם אתה רוצה להיכנס לארה\"ב באמצעות דרכון תואם ESTA, התשובה היא כן. בעבר היית צריך לקבל ויזה רגילה (פיזית), שכללה עלות גבוהה יותר, הגעה לקונסוליה, ויש לך סיכוי אמיתי מאוד שהבקשה תידחה לחלוטין. <br>היום הדברים פשוטים יותר, והכל יכול להיעשות באמצעות טופס מקוון קצר ופשוט. </p>",
        q: "האם אני צריך ESTA כדי להיכנס לארצות הברית?"
      },
      {
        a: "מטיילים ממדינות זכאיות יכולים להגיש בקשה ל- ESTA לארה\"ב באופן מקוון. תוכל לצפות ברשימת המדינות הזכאות <a data-eligibility-list-opener>כאן</a>.",
        q: "מי זכאי להגיש בקשה ל- ESTA לארה\"ב?"
      },
      {
        a: "יום או יומיים לאחר הגשת הטופס המקוון באתר האינטרנט שלנו, אישור ה- ESTA לארצות הברית יישלח כמסמך מצורף לדוא\"ל שלך. מספר האישור יצורף גם להודעה, דרכה תקבל חותמת רשמית בדרכון שלך כשתגיע לבקרת הגבול בעת כניסתך לארה\"ב.",
        q: "כיצד פועל תהליך ה- ESTA?"
      },
      {
        a: "אישור הויזה האמריקני (ESTA) תקף לשנתיים או עד שתוקף הדרכון שלך יפוג, המוקדם מביניהם.",
        q: "כמה זמן תקף ה- ESTA?"
      },
      {
        a: "לאחר שנכנסת לארה\"ב באמצעות ESTA, אתה רשאי להישאר עד 90 יום לכל היותר.",
        q: "מהי מגבלת השהייה המקסימלית בארה\"ב עם ESTA?"
      },
      {
        a: "עלות הוועדה הממשלתית היא 21 דולר. אתה יכול להאיץ את התהליך באמצעות הטופס הפשוט שלנו כאן באתר, במחיר הטוב ביותר.",
        q: "כמה עולה ESTA?"
      },
      {
        a: "אורך התהליך תלוי באופן שמילאת את הפרטים האישיים שלך. ניתן לעשות זאת באמצעות האתר הרשמי של ESTA, שאינו ידידותי למשתמש במיוחד, ואינו כולל תמיכה או עזרה מכל סוג שהוא. זה עשוי להאריך באופן משמעותי את ההליך עבורך. עם זאת, אתה יכול למקם את היישום דרכנו, ממש כאן באתר. האישור מגיע תוך שלושה ימים.",
        q: "כמה זמן לוקח להנפיק ESTA?"
      },
      {
        a: "כן. אחד התנאים החובה לקבלת היתר הכניסה (ESTA) לארצות הברית הוא דרכון ביומטרי.",
        q: "האם אני צריך דרכון ביומטרי כדי לקבל ויזה באמצעות ESTA?"
      },
      {
        a: "לא, זה לא נדרש. ניתן להנפיק אשרת כניסה גם אם טרם קנית כרטיס טיסה.",
        q: "האם עלי לרכוש כרטיסי טיסה לפני הגשת בקשה ל- ESTA?"
      },
      {
        a: "כן. תוכנית הפטור מוויזה אינה מבטלת אשרות קיימות כמו ויזה פיזית למשך 10 שנים, אלא פועלת לצידן.",
        q: "יש לי כבר ויזה תקפה. אני יכול פשוט להשתמש בו?"
      },
      {
        a: "גם הוויזה המסורתית וגם הוויזה האלקטרונית הם מסמכים שמטרתם לאשר את כניסתך והשהייה בארה\"ב. הויזה האלקטרונית (אישור כניסה אלקטרונית ESTA) הומצאה על מנת להקל על חייכם - אין צורך לשלוח מסמכים פיזית בדואר, להגיע לשגרירות ולחכות שבועות לתשובה ולקבל את הדרכון בחזרה - באתרים שלנו התהליך כולו מתבצע באופן מקוון, באנגלית וללא צורך לצאת מהבית, תוך 1-3 ימים בלבד.",
        q: "מה ההבדל בין ויזה רגילה לויזה אלקטרונית?"
      },
      {
        a: "<p>אל תהסס לחקור את </a> הבלוג <a href=\"/blog\"> שלנו לקבלת החדשות האחרונות, העדכונים והמדריכים המקיפים להשגת ETA לארה\"ב. </p><p>בנוסף, הצוות שלנו מוכן להציע לך <a href=\"/contact\"> סיוע אנושי חי 24/7 </a></p>. <p>תודה לך, צוות ויזנט. </p>",
        q: "יש לי שאלות נוספות"
      }
    ],
    meta_desc: "הגש בקשה ל- ESTA שלך לארה\"ב באופן מקוון עם Visanet בשנת 2024. תהליך הגשת בקשה מהיר ומאובטח. קבל את אישור הנסיעה שלך במהירות ובקלות.",
    title: "בקשה מקוונת של ESTA לארה\"ב 2024 • Visanet"
  },
  use_coupon: "קופון",
  valid_for: "תקף ל:",
  validity_range_bahrain: "14+ Days",
  validity_range_cambodia: "30 Days",
  validity_range_canada: "5 Years",
  validity_range_india: "30+ Days",
  validity_range_indonesia: "60+ Days",
  validity_range_israel: "2 Years",
  validity_range_korea: "3 Years",
  validity_range_morocco: "180 Days",
  validity_range_new_zealand: "2 Years",
  validity_range_saudi_arabia: "365 Days",
  validity_range_sri_lanka: "from 30 Days",
  validity_range_thailand: "90+ Days",
  validity_range_togo: "15+ Days",
  validity_range_uk: "2 Years",
  validity_range_usa: "2 Years",
  validity_range_vietnam: "90 Days",
  vietnam: "וייטנאם",
  vietnam_evisa: "ויזה אלקטרונית בווייטנאם",
  vietnam_holiday_alert: {
    body: "The Vietnam Immigration Department will be closed from April 30, to May 5, 2025 for a national holiday. No visas will be issued during this time. Please plan accordingly. Thank you!",
    title: "Notice: Holiday Closure"
  },
  vietnam_page: {
    faq: [
      {
        a: "ממשלת וייטנאם הציגה מערכת ויזה אלקטרונית פיילוט לתושבי <a href=\"https://evisa.xuatnhapcanh.gov.vn/documents/20181/117155/Vietnam-Evisa-nation-list.pdf/21e0f88f-d8a0-48b8-bfdb-a0f82b0853e2\" target=\"_blank\"> 80 מדינות</a>. כל אדם המחזיק בדרכון מאחת המדינות הללו רשאי להגיש בקשה לויזה אלקטרונית לווייטנאם.",
        q: "אילו אנשים יכולים להגיש בקשה לויזה אלקטרונית?"
      },
      {
        a: "עם קבלת הבקשה והתשלום המלאים, מחלקת ההגירה בווייטנאם בדרך כלל מעבדת ויזה אלקטרונית תוך 3 ימי עסקים.",
        q: "מהו זמן העיבוד של ויזה אלקטרונית בווייטנאם?"
      },
      {
        a: "ויזה אלקטרונית היא ויזה לכניסה יחידה או רב-כניסה שתוקפה למשך 90 יום לכל היותר.",
        q: "מהו משך תוקפו של ויזה אלקטרונית?"
      },
      {
        a: "כדי להיות זכאי לוויזה אלקטרונית, תאריך התפוגה של הויזה חייב להיות לפחות 90 יום לפני תאריך התפוגה של הדרכון, כפי שנקבע בחוק וייטנאמי.",
        q: "מהו תאריך התפוגה המינימלי של הדרכון הנדרש להגשת בקשה לויזה אלקטרונית?"
      },
      {
        a: "לאחר קבלת ויזה אלקטרונית תקפה בווייטנאם, אינך נדרש לעמוד בתור בדלפקי הוויזה להגעה. יש לך אפשרות להציג את הויזה האלקטרונית והדרכון המודפסים שלך ישירות בדלפק ההגירה.",
        q: "האם יש צורך לחכות בתור בדלפק הוויזה להגעה בווייטנאם?"
      },
      {
        a: "בדרך כלל, זמן העיבוד עבור ויזה אלקטרונית בווייטנאם הוא 2-3 ימים. עם זאת, מומלץ להגיש את בקשתך לפחות 10 עד 14 ימים לפני הגעתך המיועדת כדי לאפשר עיכובים פוטנציאליים. מניסיוננו, ייתכן שיחלפו עד שמונה ימים כדי לקבל תוצאות, בגלל חגים. לכן חשוב לתכנן בהתאם.",
        q: "מהו פרק הזמן המומלץ להגשת בקשה לוויזה האלקטרונית של וייטנאם?"
      },
      {
        a: "בהתאם לתקנות הוויזה האלקטרונית של וייטנאם, אתה רשאי להיכנס למדינה רק דרך נמל הכניסה שבחרת במהלך תהליך הגשת הבקשה, אשר יפורט גם במסמך הויזה שלך. אמנם יתכנו מקרים שבהם אתה יכול להיכנס דרך שדה תעופה אחר מזה הרשום בויזה האלקטרונית שלך לווייטנאם, אך מומלץ להימנע מלעשות זאת. חברות תעופה עשויות לסרב לתת לך לעלות על הטיסה שלך, וזו הבעיה הנפוצה ביותר. אם תצליחו לעלות, לקצין ההגירה ביעד ההגעה שלכם תהיה המילה האחרונה אם מותר לכם להיכנס או לא. כדי למזער את הסיכון לבעיות, אנו ממליצים לדבוק בשדה התעופה או בגבול היבשתי שבחרת. במקרה שתוכניות הנסיעה שלך ישתנו באופן בלתי צפוי, עדיף לבחור בנמל התעופה הו צ'י מין סיטי, האנוי או דה נאנג כנמל הכניסה שלך, מכיוון שהם מקבלים נפח גבוה יותר של טיסות בינלאומיות, מה שנותן לך סיכוי טוב יותר להיכנס לשם, אפילו ברגע האחרון.",
        q: "האם ניתן להיכנס לווייטנאם דרך נמל כניסה שונה מזה שצוין בויזה האלקטרונית?"
      },
      {
        a: "ניתן להשתמש בויזה האלקטרונית של וייטנאם כדי להיכנס למדינה דרך <a href=\"https://evisa.xuatnhapcanh.gov.vn/documents/20181/117155/List-of-evisa-port.pdf/c774e24b-1ab8-4fb6-9ac1-dcdfaccecf8e\" target=\"_blank\"> 33 מחסומים בינלאומיים שונים</a>, הכוללים שדות תעופה, גבולות יבשתיים ונמלי ים.",
        q: "מהן נקודות הכניסה והיציאה הזמינות בהן ניתן להשתמש בויזה האלקטרונית של וייטנאם?"
      },
      {
        a: "דמי העיבוד בסך 25 דולר עבור ויזה אלקטרונית בווייטנאם אינם ניתנים להחזר ולא ניתן להחזיר אותם בשום פנים ואופן, ללא קשר לתוצאות הבקשה.",
        q: "האם ניתן להחזיר את דמי הויזה האלקטרונית של וייטנאם?"
      },
      {
        a: "כן, למרות הגשת בקשה לויזה אלקטרונית של וייטנאם באופן מקוון לחלוטין, חובה להדפיס עותק פיזי ולהציג אותו עם ההגעה לווייטנאם.",
        q: "האם יש צורך להדפיס את הוויזה האלקטרונית של וייטנאם?"
      },
      {
        a: "אם טופס בקשת הוויזה האלקטרונית שלך בווייטנאם אינו שלם או מכיל מידע לא מדויק, מחלקת ההגירה עשויה לבקש ממך מידע נוסף. במקרים נדירים, הם עשויים גם לדחות את בקשתך.",
        q: "מה קורה אם הכנסתי מידע שגוי או לא חוקי בטופס בקשת הוויזה האלקטרונית של וייטנאם?"
      },
      {
        a: "כדי להיכנס לווייטנאם עם הוויזה האלקטרונית של וייטנאם, עליך להציג עותק מודפס של מסמך הוויזה האלקטרונית (מודפס מתוך קובץ PDF - תקבל קובץ זה בדוא\"ל האישור שאנו שולחים לך) ואת הדרכון שלך.",
        q: "אילו מסמכים נדרשים להציג עם ההגעה לווייטנאם עם הוויזה האלקטרונית של וייטנאם?"
      },
      {
        a: "ניתן להגיע מאוחר יותר מתאריך הכניסה המצוין בבקשת הוויזה האלקטרונית שלך בווייטנאם, אך אינך יכול להגיע מוקדם יותר. חשוב לציין שתאריך הכניסה שתציין בבקשתך נחשב לתאריך ההתחלה של תקופת תוקפו של הויזה שלך, גם אם הויזה האלקטרונית מגיעה מאוחר מהצפוי.",
        q: "האם מותר להגיע לווייטנאם בתאריכים שונים מאלה המפורטים בויזה האלקטרונית?"
      },
      {
        a: "<p>אל תהסס לחקור את הב </a> לוג <a href=\"/blog\"> שלנו לקבלת החדשות האחרונות, העדכונים והמדריכים המקיפים לקבלת אשרות לווייטנאם. </p><p>בנוסף, הצוות שלנו מוכן להציע לך <a href=\"/contact\"> סיוע אנושי חי 24/7 </a></p>. <p>תודה לך, צוות ויזנט. </p>",
        q: "יש לי שאלות נוספות"
      }
    ],
    meta_desc: "הגש בקשה לויזה אלקטרונית רשמית לווייטנאם באנגלית. קבל ויזה מבלי לבקר בשגרירות, תהליך מהיר ונוח",
    title: "ויזה אלקטרונית לווייטנאם"
  },
  visa_example_bahrain: "דוגמה לביזה אלקטרונית בחריין",
  visa_example_cambodia: "דוגמה לוויזה אלקטרונית לקמבודיה",
  visa_example_canada: "דוגמה eTA לקנדה",
  visa_example_india: "דוגמה לוויזה אלקטרונית בהודו",
  visa_example_indonesia: "דוגמה לוויזה אלקטרונית באינדונזיה",
  visa_example_israel: "דוגמה ל- ETA-IL",
  visa_example_korea: "דוגמה K-ETA של דרום קוריאה",
  visa_example_morocco: "דוגמה לביזה אלקטרונית של מרוקו",
  visa_example_new_zealand: "דוגמה של NZeTA בניו זילנד",
  visa_example_saudi_arabia: "דוגמה ל- eVisa של ערב הסעודית",
  visa_example_sri_lanka: "דוגמה לביזה אלקטרונית של סרי לנקה",
  visa_example_thailand: "See eVisa Example",
  visa_example_togo: "See eVisa Example",
  visa_example_uk: "דוגמה ETA בבריטניה",
  visa_example_usa: "דוגמה ל- ESTA של ארצות הברית",
  visa_example_vietnam: "דוגמה לוויזה אלקטרונית בווייטנאם",
  visa_form_resume_link: "קישור להמשך טופס הויזה האלקטרונית שלך",
  visa_ready_within: "מאושר בתוך:",
  visa_ready_within_priority: "מאושר בתוך:",
  visa_rejection_or_expel: "דחיית בקשת ויזה או גירוש ממדינה",
  visa_select: "בחירת ויזה",
  visa_status: "סטטוס ויזה",
  visa_to_bahrain: "ויזה לבחריין",
  visa_to_cambodia: "ויזה לקמבודיה",
  visa_to_canada: "ויזה לקנדה ETA",
  visa_to_india: "ויזה להודו",
  visa_to_indonesia: "ויזה לאינדונזיה",
  visa_to_israel: "ויזה לישראל ETAIL",
  visa_to_korea: "ויזה לדרום קוריאה KETA",
  visa_to_morocco: "ויזה למרוקו",
  visa_to_new_zealand: "ויזה לניו זילנד NZeTA",
  visa_to_saudi_arabia: "ויזה לסעודיה",
  visa_to_sri_lanka: "ויזה לסרי לנקה",
  visa_to_thailand: "Visa to Thailand",
  visa_to_togo: "Visa to Togo",
  visa_to_uk: "ויזה ל- ETA בבריטניה",
  visa_to_usa: "ויזה ל- ESTA בארה\"ב",
  visa_to_vietnam: "ויזה לווייטנאם",
  visa_type_info: "מידע על סוג הויזה שנבחר:",
  visit_details: "פרטי ביקור",
  visited_vietnam_past_10_years: "ביקרת בווייטנאם בעשר השנים האחרונות?",
  waiting_business_days: "יום עסקים אחד | {days} ימי עסקים",
  waiting_business_days_nominative: "יום עסקים אחד | {days} ימי עסקים | {days} ימי עסקים",
  waiting_days: {
    bahrain: "3-5 days",
    cambodia: "3-5 days",
    canada: "1-2 days",
    india: "1-3 days",
    indonesia: "5 days",
    israel: "1-2 days",
    korea: "1-3 days",
    morocco: "1-3 days",
    new_zealand: "1-2 days",
    saudi_arabia: "1-3 days",
    sri_lanka: "1-2 days",
    thailand: "3-21 days",
    togo: "1-3 days",
    uk: "1-3 days",
    usa: "1-3 days",
    vietnam: "1-7 days"
  },
  waiting_days_nominative: "יום אחד | {days} ימים | {days} ימים",
  want_kids_visa: "אנחנו צריכים גם ויזות לילדים",
  we_are_pci_compliant: "התשלומים באתר שלנו מוגנים בצורה מאובטחת באמצעות הצפנת SSL, תואמים באופן מלא לתק {year} ני PCI הבינלאומיים.",
  website: "אתר אינטרנט",
  website_hint: "כתובת האתר של העסק שלך. אופציונלי.",
  what_is_said_about_us: "מה אנשים אומרים עלינו?",
  whatsapp: "וואטסאפ",
  whatsapp_images_continue: "אנא שלח את התמונות שלך באמצעות WhatsApp בכתובת <a href=\"{url}\" target=\"_blank\"> {phone}</a>. <br>אתה יכול להמשיך לאחר מכן.",
  when_was_visit: "מתי היה הביקור האחרון שלך?",
  where_passport_issue_place: "ציין אם הנפקת את הדרכון בישראל או מחוצה לו <br> הסניף מצוין בסעיף 'סמכות קצין דרכונים'",
  where_stayed_in_india: "איפה היית בהודו?",
  which_countries_you_visited: "באילו מדינות ביקרת?",
  which_country_date: "איזו מדינה, מתי זה קרה וכו'",
  year: "שנה",
  yes: "הן"
};
